export default (function () {
	var e = Math.min,
		t = Math.floor,
		n = Math.ceil,
		o = Math.max,
		a = Math.round;
	return (function (e) {
		function t(o) {
			if (n[o]) return n[o].exports;
			var a = (n[o] = { i: o, l: !1, exports: {} });
			return e[o].call(a.exports, a, a.exports, t), (a.l = !0), a.exports;
		}
		var n = {};
		return (
			(t.m = e),
			(t.c = n),
			(t.d = function (e, n, o) {
				t.o(e, n) ||
					Object.defineProperty(e, n, {
						configurable: !1,
						enumerable: !0,
						get: o,
					});
			}),
			(t.n = function (e) {
				var n =
					e && e.__esModule
						? function () {
								return e["default"];
						  }
						: function () {
								return e;
						  };
				return t.d(n, "a", n), n;
			}),
			(t.o = function (e, t) {
				return Object.prototype.hasOwnProperty.call(e, t);
			}),
			(t.p = ""),
			t((t.s = 36))
		);
	})([
		function (e, t) {
			var i, s;
			/*!
			 * jQuery JavaScript Library v3.4.1
			 * https://jquery.com/
			 *
			 * Includes Sizzle.js
			 * https://sizzlejs.com/
			 *
			 * Copyright JS Foundation and misc contributors
			 * Released under the MIT license
			 * https://jquery.org/license
			 *
			 * Date: 2019-05-01T21:04Z
			 */ (function (t, n) {
				"use strict";
				"object" == typeof e && "object" == typeof e.exports
					? (e.exports = t.document
							? n(t, !0)
							: function (e) {
									if (!e.document)
										throw new Error(
											"jQuery requires a window with a document"
										);
									return n(e);
							  })
					: n(t);
			})("undefined" == typeof window ? this : window, function (r, l) {
				"use strict";
				function d(e, t, n) {
					n = n || ge;
					var o = n.createElement("script"),
						a,
						i;
					if (((o.text = e), t))
						for (a in Ee)
							(i = t[a] || (t.getAttribute && t.getAttribute(a))),
								i && o.setAttribute(a, i);
					n.head.appendChild(o).parentNode.removeChild(o);
				}
				function c(e) {
					return null == e
						? e + ""
						: "object" == typeof e || "function" == typeof e
						? ve[xe.call(e)] || "object"
						: typeof e;
				}
				function p(e) {
					var t = !!e && "length" in e && e.length,
						n = c(e);
					return Te(e) || Se(e)
						? !1
						: "array" === n ||
								0 === t ||
								("number" == typeof t && 0 < t && t - 1 in e);
				}
				function m(e, t) {
					return (
						e.nodeName &&
						e.nodeName.toLowerCase() === t.toLowerCase()
					);
				}
				function u(e, t, n) {
					return Te(t)
						? Ae.grep(e, function (e, o) {
								return !!t.call(e, o, e) !== n;
						  })
						: t.nodeType
						? Ae.grep(e, function (e) {
								return (e === t) !== n;
						  })
						: "string" == typeof t
						? Ae.filter(t, e, n)
						: Ae.grep(e, function (e) {
								return -1 < be.call(t, e) !== n;
						  });
				}
				function g(e, t) {
					for (; (e = e[t]) && 1 !== e.nodeType; );
					return e;
				}
				function h(e) {
					var t = {};
					return (
						Ae.each(e.match(qe) || [], function (e, n) {
							t[n] = !0;
						}),
						t
					);
				}
				function f(e) {
					return e;
				}
				function _(e) {
					throw e;
				}
				function y(e, t, n, o) {
					var a;
					try {
						e && Te((a = e.promise))
							? a.call(e).done(t).fail(n)
							: e && Te((a = e.then))
							? a.call(e, t, n)
							: t.apply(void 0, [e].slice(o));
					} catch (e) {
						n.apply(void 0, [e]);
					}
				}
				function b() {
					ge.removeEventListener("DOMContentLoaded", b),
						r.removeEventListener("load", b),
						Ae.ready();
				}
				function v(e, t) {
					return t.toUpperCase();
				}
				function x(e) {
					return e.replace(Ge, "ms-").replace(Xe, v);
				}
				function k() {
					this.expando = Ae.expando + k.uid++;
				}
				function w(e) {
					return (
						"true" === e ||
						("false" !== e &&
							("null" === e
								? null
								: e === +e + ""
								? +e
								: Ke.test(e)
								? JSON.parse(e)
								: e))
					);
				}
				function I(e, t, n) {
					var o;
					if (void 0 === n && 1 === e.nodeType)
						if (
							((o = "data-" + t.replace(Je, "-$&").toLowerCase()),
							(n = e.getAttribute(o)),
							"string" == typeof n)
						) {
							try {
								n = w(n);
							} catch (t) {}
							Ze.set(e, t, n);
						} else n = void 0;
					return n;
				}
				function C(e, t, n, o) {
					var a = 20,
						i = o
							? function () {
									return o.cur();
							  }
							: function () {
									return Ae.css(e, t, "");
							  },
						s = i(),
						r = (n && n[3]) || (Ae.cssNumber[t] ? "" : "px"),
						l =
							e.nodeType &&
							(Ae.cssNumber[t] || ("px" !== r && +s)) &&
							et.exec(Ae.css(e, t)),
						d,
						c;
					if (l && l[3] !== r) {
						for (s /= 2, r = r || l[3], l = +s || 1; a--; )
							Ae.style(e, t, l + r),
								0 >= (1 - c) * (1 - (c = i() / s || 0.5)) &&
									(a = 0),
								(l /= c);
						(l *= 2), Ae.style(e, t, l + r), (n = n || []);
					}
					return (
						n &&
							((l = +l || +s || 0),
							(d = n[1] ? l + (n[1] + 1) * n[2] : +n[2]),
							o && ((o.unit = r), (o.start = l), (o.end = d))),
						d
					);
				}
				function T(e) {
					var t = e.ownerDocument,
						n = e.nodeName,
						o = rt[n],
						a;
					return o
						? o
						: ((a = t.body.appendChild(t.createElement(n))),
						  (o = Ae.css(a, "display")),
						  a.parentNode.removeChild(a),
						  "none" === o && (o = "block"),
						  (rt[n] = o),
						  o);
				}
				function S(e, t) {
					for (var n = [], o = 0, a = e.length, i, s; o < a; o++)
						((s = e[o]), !!s.style) &&
							((i = s.style.display),
							t
								? ("none" === i &&
										((n[o] = Ve.get(s, "display") || null),
										!n[o] && (s.style.display = "")),
								  "" === s.style.display &&
										it(s) &&
										(n[o] = T(s)))
								: "none" !== i &&
								  ((n[o] = "none"), Ve.set(s, "display", i)));
					for (o = 0; o < a; o++)
						null != n[o] && (e[o].style.display = n[o]);
					return e;
				}
				function E(e, t) {
					var n;
					return (
						(n =
							"undefined" == typeof e.getElementsByTagName
								? "undefined" == typeof e.querySelectorAll
									? []
									: e.querySelectorAll(t || "*")
								: e.getElementsByTagName(t || "*")),
						void 0 === t || (t && m(e, t)) ? Ae.merge([e], n) : n
					);
				}
				function D(e, t) {
					for (var n = 0, o = e.length; n < o; n++)
						Ve.set(
							e[n],
							"globalEval",
							!t || Ve.get(t[n], "globalEval")
						);
				}
				function A(e, t, n, o, a) {
					for (
						var s = t.createDocumentFragment(),
							r = [],
							d = 0,
							i = e.length,
							l,
							p,
							m,
							u,
							g,
							h;
						d < i;
						d++
					)
						if (((l = e[d]), l || 0 === l))
							if ("object" === c(l))
								Ae.merge(r, l.nodeType ? [l] : l);
							else if (!mt.test(l)) r.push(t.createTextNode(l));
							else {
								for (
									p =
										p ||
										s.appendChild(t.createElement("div")),
										m = (dt.exec(l) || [
											"",
											"",
										])[1].toLowerCase(),
										u = pt[m] || pt._default,
										p.innerHTML =
											u[1] + Ae.htmlPrefilter(l) + u[2],
										h = u[0];
									h--;

								)
									p = p.lastChild;
								Ae.merge(r, p.childNodes),
									(p = s.firstChild),
									(p.textContent = "");
							}
					for (s.textContent = "", d = 0; (l = r[d++]); ) {
						if (o && -1 < Ae.inArray(l, o)) {
							a && a.push(l);
							continue;
						}
						if (
							((g = ot(l)),
							(p = E(s.appendChild(l), "script")),
							g && D(p),
							n)
						)
							for (h = 0; (l = p[h++]); )
								ct.test(l.type || "") && n.push(l);
					}
					return s;
				}
				function j() {
					return !0;
				}
				function P() {
					return !1;
				}
				function N(e, t) {
					return (e === $()) == ("focus" === t);
				}
				function $() {
					try {
						return ge.activeElement;
					} catch (e) {}
				}
				function M(e, t, n, o, a, i) {
					var s, r;
					if ("object" == typeof t) {
						for (r in ("string" != typeof n &&
							((o = o || n), (n = void 0)),
						t))
							M(e, r, n, o, t[r], i);
						return e;
					}
					if (
						(null == o && null == a
							? ((a = n), (o = n = void 0))
							: null == a &&
							  ("string" == typeof n
									? ((a = o), (o = void 0))
									: ((a = o), (o = n), (n = void 0))),
						!1 === a)
					)
						a = P;
					else if (!a) return e;
					return (
						1 === i &&
							((s = a),
							(a = function (e) {
								return Ae().off(e), s.apply(this, arguments);
							}),
							(a.guid = s.guid || (s.guid = Ae.guid++))),
						e.each(function () {
							Ae.event.add(this, t, a, o, n);
						})
					);
				}
				function O(e, t, n) {
					return n
						? void (Ve.set(e, t, !1),
						  Ae.event.add(e, t, {
								namespace: !1,
								handler: function (e) {
									var o = Ve.get(this, t),
										a,
										i;
									if (!(1 & e.isTrigger && this[t]))
										o.length &&
											(Ve.set(this, t, {
												value: Ae.event.trigger(
													Ae.extend(
														o[0],
														Ae.Event.prototype
													),
													o.slice(1),
													this
												),
											}),
											e.stopImmediatePropagation());
									else if (!!o.length)
										(Ae.event.special[t] || {})
											.delegateType &&
											e.stopPropagation();
									else if (
										((o = fe.call(arguments)),
										Ve.set(this, t, o),
										(a = n(this, t)),
										this[t](),
										(i = Ve.get(this, t)),
										o !== i || a
											? Ve.set(this, t, !1)
											: (i = {}),
										o !== i)
									)
										return (
											e.stopImmediatePropagation(),
											e.preventDefault(),
											i.value
										);
								},
						  }))
						: void (
								void 0 === Ve.get(e, t) && Ae.event.add(e, t, j)
						  );
				}
				function L(e, t) {
					return m(e, "table") &&
						m(11 === t.nodeType ? t.firstChild : t, "tr")
						? Ae(e).children("tbody")[0] || e
						: e;
				}
				function z(e) {
					return (
						(e.type =
							(null !== e.getAttribute("type")) + "/" + e.type),
						e
					);
				}
				function R(e) {
					return (
						"true/" === (e.type || "").slice(0, 5)
							? (e.type = e.type.slice(5))
							: e.removeAttribute("type"),
						e
					);
				}
				function H(e, t) {
					var n, o, a, i, s, r, l, d;
					if (1 === t.nodeType) {
						if (
							Ve.hasData(e) &&
							((i = Ve.access(e)),
							(s = Ve.set(t, i)),
							(d = i.events),
							d)
						)
							for (a in (delete s.handle, (s.events = {}), d))
								for (n = 0, o = d[a].length; n < o; n++)
									Ae.event.add(t, a, d[a][n]);
						Ze.hasData(e) &&
							((r = Ze.access(e)),
							(l = Ae.extend({}, r)),
							Ze.set(t, l));
					}
				}
				function F(e, t) {
					var n = t.nodeName.toLowerCase();
					"input" === n && lt.test(e.type)
						? (t.checked = e.checked)
						: ("input" === n || "textarea" === n) &&
						  (t.defaultValue = e.defaultValue);
				}
				function q(e, t, n, o) {
					t = _e.apply([], t);
					var a = 0,
						i = e.length,
						s = t[0],
						r = Te(s),
						l,
						c,
						p,
						m,
						u,
						g;
					if (
						r ||
						(1 < i &&
							"string" == typeof s &&
							!Ce.checkClone &&
							yt.test(s))
					)
						return e.each(function (a) {
							var i = e.eq(a);
							r && (t[0] = s.call(this, a, i.html())),
								q(i, t, n, o);
						});
					if (
						i &&
						((l = A(t, e[0].ownerDocument, !1, e, o)),
						(c = l.firstChild),
						1 === l.childNodes.length && (l = c),
						c || o)
					) {
						for (
							p = Ae.map(E(l, "script"), z), m = p.length;
							a < i;
							a++
						)
							(u = l),
								a != i - 1 &&
									((u = Ae.clone(u, !0, !0)),
									m && Ae.merge(p, E(u, "script"))),
								n.call(e[a], u, a);
						if (m)
							for (
								g = p[p.length - 1].ownerDocument,
									Ae.map(p, R),
									a = 0;
								a < m;
								a++
							)
								(u = p[a]),
									ct.test(u.type || "") &&
										!Ve.access(u, "globalEval") &&
										Ae.contains(g, u) &&
										(u.src &&
										"module" !==
											(u.type || "").toLowerCase()
											? Ae._evalUrl &&
											  !u.noModule &&
											  Ae._evalUrl(u.src, {
													nonce:
														u.nonce ||
														u.getAttribute("nonce"),
											  })
											: d(
													u.textContent.replace(
														bt,
														""
													),
													u,
													g
											  ));
					}
					return e;
				}
				function W(e, t, n) {
					for (
						var o = t ? Ae.filter(t, e) : e, a = 0, i;
						null != (i = o[a]);
						a++
					)
						n || 1 !== i.nodeType || Ae.cleanData(E(i)),
							i.parentNode &&
								(n && ot(i) && D(E(i, "script")),
								i.parentNode.removeChild(i));
					return e;
				}
				function B(e, t, n) {
					var o = e.style,
						a,
						i,
						s,
						r;
					return (
						(n = n || xt(e)),
						n &&
							((r = n.getPropertyValue(t) || n[t]),
							"" === r && !ot(e) && (r = Ae.style(e, t)),
							!Ce.pixelBoxStyles() &&
								vt.test(r) &&
								kt.test(t) &&
								((a = o.width),
								(i = o.minWidth),
								(s = o.maxWidth),
								(o.minWidth = o.maxWidth = o.width = r),
								(r = n.width),
								(o.width = a),
								(o.minWidth = i),
								(o.maxWidth = s))),
						void 0 === r ? r : r + ""
					);
				}
				function U(e, t) {
					return {
						get: function () {
							return e()
								? void delete this.get
								: (this.get = t).apply(this, arguments);
						},
					};
				}
				function G(e) {
					for (
						var t = e[0].toUpperCase() + e.slice(1), n = wt.length;
						n--;

					)
						if (((e = wt[n] + t), e in It)) return e;
				}
				function X(e) {
					var t = Ae.cssProps[e] || Ct[e];
					return t ? t : e in It ? e : (Ct[e] = G(e) || e);
				}
				function Y(e, t, n) {
					var a = et.exec(t);
					return a ? o(0, a[2] - (n || 0)) + (a[3] || "px") : t;
				}
				function V(e, t, a, s, r, l) {
					var d = "width" === t ? 1 : 0,
						i = 0,
						c = 0;
					if (a === (s ? "border" : "content")) return 0;
					for (; 4 > d; d += 2)
						"margin" === a && (c += Ae.css(e, a + tt[d], !0, r)),
							s
								? ("content" === a &&
										(c -= Ae.css(
											e,
											"padding" + tt[d],
											!0,
											r
										)),
								  "margin" !== a &&
										(c -= Ae.css(
											e,
											"border" + tt[d] + "Width",
											!0,
											r
										)))
								: ((c += Ae.css(e, "padding" + tt[d], !0, r)),
								  "padding" === a
										? (i += Ae.css(
												e,
												"border" + tt[d] + "Width",
												!0,
												r
										  ))
										: (c += Ae.css(
												e,
												"border" + tt[d] + "Width",
												!0,
												r
										  )));
					return (
						!s &&
							0 <= l &&
							(c +=
								o(
									0,
									n(
										e[
											"offset" +
												t[0].toUpperCase() +
												t.slice(1)
										] -
											l -
											c -
											i -
											0.5
									)
								) || 0),
						c
					);
				}
				function Z(e, t, n) {
					var o = xt(e),
						a = !Ce.boxSizingReliable() || n,
						i = a && "border-box" === Ae.css(e, "boxSizing", !1, o),
						s = i,
						r = B(e, t, o),
						l = "offset" + t[0].toUpperCase() + t.slice(1);
					if (vt.test(r)) {
						if (!n) return r;
						r = "auto";
					}
					return (
						((!Ce.boxSizingReliable() && i) ||
							"auto" === r ||
							(!parseFloat(r) &&
								"inline" === Ae.css(e, "display", !1, o))) &&
							e.getClientRects().length &&
							((i =
								"border-box" === Ae.css(e, "boxSizing", !1, o)),
							(s = l in e),
							s && (r = e[l])),
						(r = parseFloat(r) || 0),
						r +
							V(e, t, n || (i ? "border" : "content"), s, o, r) +
							"px"
					);
				}
				function K(e, t, n, o, a) {
					return new K.prototype.init(e, t, n, o, a);
				}
				function J() {
					Nt &&
						(!1 === ge.hidden && r.requestAnimationFrame
							? r.requestAnimationFrame(J)
							: r.setTimeout(J, Ae.fx.interval),
						Ae.fx.tick());
				}
				function Q() {
					return (
						r.setTimeout(function () {
							Pt = void 0;
						}),
						(Pt = Date.now())
					);
				}
				function ee(e, t) {
					var n = 0,
						o = { height: e },
						a;
					for (t = t ? 1 : 0; 4 > n; n += 2 - t)
						(a = tt[n]), (o["margin" + a] = o["padding" + a] = e);
					return t && (o.opacity = o.width = e), o;
				}
				function te(e, t, n) {
					for (
						var o = (oe.tweeners[t] || []).concat(oe.tweeners["*"]),
							a = 0,
							i = o.length,
							s;
						a < i;
						a++
					)
						if ((s = o[a].call(n, t, e))) return s;
				}
				function ne(e, t) {
					var n, o, a, i, s;
					for (n in e)
						if (
							((o = x(n)),
							(a = t[o]),
							(i = e[n]),
							Array.isArray(i) && ((a = i[1]), (i = e[n] = i[0])),
							n !== o && ((e[o] = i), delete e[n]),
							(s = Ae.cssHooks[o]),
							s && "expand" in s)
						)
							for (n in ((i = s.expand(i)), delete e[o], i))
								n in e || ((e[n] = i[n]), (t[n] = a));
						else t[o] = a;
				}
				function oe(e, t, n) {
					var a = 0,
						i = oe.prefilters.length,
						s = Ae.Deferred().always(function () {
							delete r.elem;
						}),
						r = function () {
							if (p) return !1;
							for (
								var t = Pt || Q(),
									n = o(0, l.startTime + l.duration - t),
									a = n / l.duration || 0,
									i = 1 - a,
									r = 0,
									d = l.tweens.length;
								r < d;
								r++
							)
								l.tweens[r].run(i);
							return (s.notifyWith(e, [l, i, n]), 1 > i && d)
								? n
								: (d || s.notifyWith(e, [l, 1, 0]),
								  s.resolveWith(e, [l]),
								  !1);
						},
						l = s.promise({
							elem: e,
							props: Ae.extend({}, t),
							opts: Ae.extend(
								!0,
								{
									specialEasing: {},
									easing: Ae.easing._default,
								},
								n
							),
							originalProperties: t,
							originalOptions: n,
							startTime: Pt || Q(),
							duration: n.duration,
							tweens: [],
							createTween: function (t, n) {
								var o = Ae.Tween(
									e,
									l.opts,
									t,
									n,
									l.opts.specialEasing[t] || l.opts.easing
								);
								return l.tweens.push(o), o;
							},
							stop: function (t) {
								var n = 0,
									o = t ? l.tweens.length : 0;
								if (p) return this;
								for (p = !0; n < o; n++) l.tweens[n].run(1);
								return (
									t
										? (s.notifyWith(e, [l, 1, 0]),
										  s.resolveWith(e, [l, t]))
										: s.rejectWith(e, [l, t]),
									this
								);
							},
						}),
						d = l.props,
						c,
						p;
					for (ne(d, l.opts.specialEasing); a < i; a++)
						if (((c = oe.prefilters[a].call(l, e, d, l.opts)), c))
							return (
								Te(c.stop) &&
									(Ae._queueHooks(l.elem, l.opts.queue).stop =
										c.stop.bind(c)),
								c
							);
					return (
						Ae.map(d, te, l),
						Te(l.opts.start) && l.opts.start.call(e, l),
						l
							.progress(l.opts.progress)
							.done(l.opts.done, l.opts.complete)
							.fail(l.opts.fail)
							.always(l.opts.always),
						Ae.fx.timer(
							Ae.extend(r, {
								elem: e,
								anim: l,
								queue: l.opts.queue,
							})
						),
						l
					);
				}
				function ae(e) {
					var t = e.match(qe) || [];
					return t.join(" ");
				}
				function ie(e) {
					return (e.getAttribute && e.getAttribute("class")) || "";
				}
				function se(e) {
					return Array.isArray(e)
						? e
						: "string" == typeof e
						? e.match(qe) || []
						: [];
				}
				function re(e, t, n, o) {
					if (Array.isArray(t))
						Ae.each(t, function (t, a) {
							n || Bt.test(e)
								? o(e, a)
								: re(
										e +
											"[" +
											("object" == typeof a && null != a
												? t
												: "") +
											"]",
										a,
										n,
										o
								  );
						});
					else if (!n && "object" === c(t))
						for (var a in t) re(e + "[" + a + "]", t[a], n, o);
					else o(e, t);
				}
				function le(e) {
					return function (t, n) {
						"string" != typeof t && ((n = t), (t = "*"));
						var o = 0,
							a = t.toLowerCase().match(qe) || [],
							i;
						if (Te(n))
							for (; (i = a[o++]); )
								"+" === i[0]
									? ((i = i.slice(1) || "*"),
									  (e[i] = e[i] || []).unshift(n))
									: (e[i] = e[i] || []).push(n);
					};
				}
				function de(e, t, n, o) {
					function a(r) {
						var l;
						return (
							(i[r] = !0),
							Ae.each(e[r] || [], function (e, r) {
								var d = r(t, n, o);
								return "string" != typeof d || s || i[d]
									? s
										? !(l = d)
										: void 0
									: (t.dataTypes.unshift(d), a(d), !1);
							}),
							l
						);
					}
					var i = {},
						s = e === nn;
					return a(t.dataTypes[0]) || (!i["*"] && a("*"));
				}
				function ce(e, t) {
					var n = Ae.ajaxSettings.flatOptions || {},
						o,
						a;
					for (o in t)
						void 0 !== t[o] &&
							((n[o] ? e : a || (a = {}))[o] = t[o]);
					return a && Ae.extend(!0, e, a), e;
				}
				function pe(e, t, n) {
					for (
						var o = e.contents, a = e.dataTypes, i, s, r, l;
						"*" === a[0];

					)
						a.shift(),
							void 0 == i &&
								(i =
									e.mimeType ||
									t.getResponseHeader("Content-Type"));
					if (i)
						for (s in o)
							if (o[s] && o[s].test(i)) {
								a.unshift(s);
								break;
							}
					if (a[0] in n) r = a[0];
					else {
						for (s in n) {
							if (!a[0] || e.converters[s + " " + a[0]]) {
								r = s;
								break;
							}
							l || (l = s);
						}
						r = r || l;
					}
					return r ? (r !== a[0] && a.unshift(r), n[r]) : void 0;
				}
				function me(e, t, n, o) {
					var a = {},
						i = e.dataTypes.slice(),
						s,
						r,
						l,
						d,
						c;
					if (i[1])
						for (l in e.converters)
							a[l.toLowerCase()] = e.converters[l];
					for (r = i.shift(); r; )
						if (
							(e.responseFields[r] &&
								(n[e.responseFields[r]] = t),
							!c &&
								o &&
								e.dataFilter &&
								(t = e.dataFilter(t, e.dataType)),
							(c = r),
							(r = i.shift()),
							r)
						)
							if ("*" === r) r = c;
							else if ("*" !== c && c !== r) {
								if (((l = a[c + " " + r] || a["* " + r]), !l))
									for (s in a)
										if (
											((d = s.split(" ")),
											d[1] === r &&
												((l =
													a[c + " " + d[0]] ||
													a["* " + d[0]]),
												l))
										) {
											!0 === l
												? (l = a[s])
												: !0 !== a[s] &&
												  ((r = d[0]), i.unshift(d[1]));
											break;
										}
								if (!0 !== l)
									if (l && e.throws) t = l(t);
									else
										try {
											t = l(t);
										} catch (t) {
											return {
												state: "parsererror",
												error: l
													? t
													: "No conversion from " +
													  c +
													  " to " +
													  r,
											};
										}
							}
					return { state: "success", data: t };
				}
				var ue = [],
					ge = r.document,
					he = Object.getPrototypeOf,
					fe = ue.slice,
					_e = ue.concat,
					ye = ue.push,
					be = ue.indexOf,
					ve = {},
					xe = ve.toString,
					ke = ve.hasOwnProperty,
					we = ke.toString,
					Ie = we.call(Object),
					Ce = {},
					Te = function (e) {
						return (
							"function" == typeof e &&
							"number" != typeof e.nodeType
						);
					},
					Se = function (e) {
						return null != e && e === e.window;
					},
					Ee = { type: !0, src: !0, nonce: !0, noModule: !0 },
					De = "3.4.1",
					Ae = function (e, t) {
						return new Ae.fn.init(e, t);
					},
					je = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
				(Ae.fn = Ae.prototype =
					{
						jquery: De,
						constructor: Ae,
						length: 0,
						toArray: function () {
							return fe.call(this);
						},
						get: function (e) {
							return null == e
								? fe.call(this)
								: 0 > e
								? this[e + this.length]
								: this[e];
						},
						pushStack: function (e) {
							var t = Ae.merge(this.constructor(), e);
							return (t.prevObject = this), t;
						},
						each: function (e) {
							return Ae.each(this, e);
						},
						map: function (e) {
							return this.pushStack(
								Ae.map(this, function (t, n) {
									return e.call(t, n, t);
								})
							);
						},
						slice: function () {
							return this.pushStack(fe.apply(this, arguments));
						},
						first: function () {
							return this.eq(0);
						},
						last: function () {
							return this.eq(-1);
						},
						eq: function (e) {
							var t = this.length,
								n = +e + (0 > e ? t : 0);
							return this.pushStack(
								0 <= n && n < t ? [this[n]] : []
							);
						},
						end: function () {
							return this.prevObject || this.constructor();
						},
						push: ye,
						sort: ue.sort,
						splice: ue.splice,
					}),
					(Ae.extend = Ae.fn.extend =
						function () {
							var e = arguments[0] || {},
								t = 1,
								n = arguments.length,
								o = !1,
								a,
								i,
								s,
								r,
								l,
								d;
							for (
								"boolean" == typeof e &&
									((o = e), (e = arguments[t] || {}), t++),
									"object" == typeof e || Te(e) || (e = {}),
									t === n && ((e = this), t--);
								t < n;
								t++
							)
								if (null != (a = arguments[t]))
									for (i in a)
										((r = a[i]),
										"__proto__" !== i && e !== r) &&
											(o &&
											r &&
											(Ae.isPlainObject(r) ||
												(l = Array.isArray(r)))
												? ((s = e[i]),
												  (d =
														l && !Array.isArray(s)
															? []
															: l ||
															  Ae.isPlainObject(
																	s
															  )
															? s
															: {}),
												  (l = !1),
												  (e[i] = Ae.extend(o, d, r)))
												: void 0 !== r && (e[i] = r));
							return e;
						}),
					Ae.extend({
						expando:
							"jQuery" + (De + Math.random()).replace(/\D/g, ""),
						isReady: !0,
						error: function (e) {
							throw new Error(e);
						},
						noop: function () {},
						isPlainObject: function (e) {
							var t, n;
							return (
								e &&
								"[object Object]" === xe.call(e) &&
								(((t = he(e)), !!!t) ||
									((n =
										ke.call(t, "constructor") &&
										t.constructor),
									"function" == typeof n &&
										we.call(n) === Ie))
							);
						},
						isEmptyObject: function (e) {
							for (var t in e) return !1;
							return !0;
						},
						globalEval: function (e, t) {
							d(e, { nonce: t && t.nonce });
						},
						each: function (e, t) {
							var n = 0,
								o;
							if (p(e))
								for (
									o = e.length;
									n < o && !1 !== t.call(e[n], n, e[n]);
									n++
								);
							else
								for (n in e)
									if (!1 === t.call(e[n], n, e[n])) break;
							return e;
						},
						trim: function (e) {
							return null == e ? "" : (e + "").replace(je, "");
						},
						makeArray: function (e, t) {
							var n = t || [];
							return (
								null != e &&
									(p(Object(e))
										? Ae.merge(
												n,
												"string" == typeof e ? [e] : e
										  )
										: ye.call(n, e)),
								n
							);
						},
						inArray: function (e, t, n) {
							return null == t ? -1 : be.call(t, e, n);
						},
						merge: function (e, t) {
							for (
								var n = +t.length, o = 0, a = e.length;
								o < n;
								o++
							)
								e[a++] = t[o];
							return (e.length = a), e;
						},
						grep: function (e, t, n) {
							for (var o = [], a = 0, i = e.length, s; a < i; a++)
								(s = !t(e[a], a)), s !== !n && o.push(e[a]);
							return o;
						},
						map: function (e, t, n) {
							var o = 0,
								a = [],
								i,
								s;
							if (p(e))
								for (i = e.length; o < i; o++)
									(s = t(e[o], o, n)), null != s && a.push(s);
							else
								for (o in e)
									(s = t(e[o], o, n)), null != s && a.push(s);
							return _e.apply([], a);
						},
						guid: 1,
						support: Ce,
					}),
					"function" == typeof Symbol &&
						(Ae.fn[Symbol.iterator] = ue[Symbol.iterator]),
					Ae.each(
						[
							"Boolean",
							"Number",
							"String",
							"Function",
							"Array",
							"Date",
							"RegExp",
							"Object",
							"Error",
							"Symbol",
						],
						function (e, t) {
							ve["[object " + t + "]"] = t.toLowerCase();
						}
					);
				var Pe = /*!
				 * Sizzle CSS Selector Engine v2.3.4
				 * https://sizzlejs.com/
				 *
				 * Copyright JS Foundation and misc contributors
				 * Released under the MIT license
				 * https://js.foundation/
				 *
				 * Date: 2019-04-08
				 */ (function (e) {
					function t(e, t, n, o) {
						var a = t && t.ownerDocument,
							s = t ? t.nodeType : 9,
							r,
							l,
							i,
							d,
							c,
							p,
							u;
						if (
							((n = n || []),
							"string" != typeof e ||
								!e ||
								(1 !== s && 9 !== s && 11 !== s))
						)
							return n;
						if (
							!o &&
							((t ? t.ownerDocument || t : w) !== ye && _e(t),
							(t = t || ye),
							ve)
						) {
							if (11 !== s && (c = Q.exec(e)))
								if (!(r = c[1])) {
									if (c[2])
										return (
											M.apply(
												n,
												t.getElementsByTagName(e)
											),
											n
										);
									if (
										(r = c[3]) &&
										le.getElementsByClassName &&
										t.getElementsByClassName
									)
										return (
											M.apply(
												n,
												t.getElementsByClassName(r)
											),
											n
										);
								} else if (9 === s) {
									if (!(i = t.getElementById(r))) return n;
									if (i.id === r) return n.push(i), n;
								} else if (
									a &&
									(i = a.getElementById(r)) &&
									Ie(t, i) &&
									i.id === r
								)
									return n.push(i), n;
							if (
								le.qsa &&
								!D[e + " "] &&
								(!xe || !xe.test(e)) &&
								(1 !== s ||
									"object" !== t.nodeName.toLowerCase())
							) {
								if (((u = e), (a = t), 1 === s && U.test(e))) {
									for (
										(d = t.getAttribute("id"))
											? (d = d.replace(oe, ae))
											: t.setAttribute("id", (d = k)),
											p = pe(e),
											l = p.length;
										l--;

									)
										p[l] = "#" + d + " " + g(p[l]);
									(u = p.join(",")),
										(a =
											(ee.test(e) && m(t.parentNode)) ||
											t);
								}
								try {
									return M.apply(n, a.querySelectorAll(u)), n;
								} catch (t) {
									D(e, !0);
								} finally {
									d === k && t.removeAttribute("id");
								}
							}
						}
						return ue(e.replace(q, "$1"), t, n, o);
					}
					function n() {
						function e(n, o) {
							return (
								t.push(n + " ") > de.cacheLength &&
									delete e[t.shift()],
								(e[n + " "] = o)
							);
						}
						var t = [];
						return e;
					}
					function o(e) {
						return (e[k] = !0), e;
					}
					function a(e) {
						var t = ye.createElement("fieldset");
						try {
							return !!e(t);
						} catch (t) {
							return !1;
						} finally {
							t.parentNode && t.parentNode.removeChild(t),
								(t = null);
						}
					}
					function s(e, t) {
						for (var n = e.split("|"), o = n.length; o--; )
							de.attrHandle[n[o]] = t;
					}
					function r(e, t) {
						var n = t && e,
							o =
								n &&
								1 === e.nodeType &&
								1 === t.nodeType &&
								e.sourceIndex - t.sourceIndex;
						if (o) return o;
						if (n)
							for (; (n = n.nextSibling); )
								if (n === t) return -1;
						return e ? 1 : -1;
					}
					function l(e) {
						return function (t) {
							var n = t.nodeName.toLowerCase();
							return "input" === n && t.type === e;
						};
					}
					function d(e) {
						return function (t) {
							var n = t.nodeName.toLowerCase();
							return (
								("input" === n || "button" === n) &&
								t.type === e
							);
						};
					}
					function c(e) {
						return function (t) {
							return "form" in t
								? t.parentNode && !1 === t.disabled
									? "label" in t
										? "label" in t.parentNode
											? t.parentNode.disabled === e
											: t.disabled === e
										: t.isDisabled === e ||
										  (t.isDisabled !== !e && se(t) === e)
									: t.disabled === e
								: !!("label" in t) && t.disabled === e;
						};
					}
					function p(e) {
						return o(function (t) {
							return (
								(t = +t),
								o(function (n, o) {
									for (
										var a = e([], n.length, t),
											s = a.length,
											i;
										s--;

									)
										n[(i = a[s])] &&
											(n[i] = !(o[i] = n[i]));
								})
							);
						});
					}
					function m(e) {
						return (
							e &&
							"undefined" != typeof e.getElementsByTagName &&
							e
						);
					}
					function u() {}
					function g(e) {
						for (var t = 0, n = e.length, o = ""; t < n; t++)
							o += e[t].value;
						return o;
					}
					function h(e, t, n) {
						var o = t.dir,
							a = t.next,
							i = a || o,
							s = n && "parentNode" === i,
							r = C++;
						return t.first
							? function (t, n, a) {
									for (; (t = t[o]); )
										if (1 === t.nodeType || s)
											return e(t, n, a);
									return !1;
							  }
							: function (t, n, l) {
									var d = [I, r],
										c,
										p,
										m;
									if (l) {
										for (; (t = t[o]); )
											if (
												(1 === t.nodeType || s) &&
												e(t, n, l)
											)
												return !0;
									} else
										for (; (t = t[o]); )
											if (1 === t.nodeType || s)
												if (
													((m = t[k] || (t[k] = {})),
													(p =
														m[t.uniqueID] ||
														(m[t.uniqueID] = {})),
													a &&
														a ===
															t.nodeName.toLowerCase())
												)
													t = t[o] || t;
												else {
													if (
														(c = p[i]) &&
														c[0] === I &&
														c[1] === r
													)
														return (d[2] = c[2]);
													if (
														((p[i] = d),
														(d[2] = e(t, n, l)))
													)
														return !0;
												}
									return !1;
							  };
					}
					function f(e) {
						return 1 < e.length
							? function (t, n, o) {
									for (var a = e.length; a--; )
										if (!e[a](t, n, o)) return !1;
									return !0;
							  }
							: e[0];
					}
					function _(e, n, o) {
						for (var a = 0, i = n.length; a < i; a++) t(e, n[a], o);
						return o;
					}
					function y(e, t, n, o, a) {
						for (var s = [], r = 0, i = e.length, l; r < i; r++)
							(l = e[r]) &&
								(!n || n(l, o, a)) &&
								(s.push(l), null != t && t.push(r));
						return s;
					}
					function b(e, t, n, a, s, i) {
						return (
							a && !a[k] && (a = b(a)),
							s && !s[k] && (s = b(s, i)),
							o(function (o, r, l, d) {
								var c = [],
									p = [],
									m = r.length,
									u =
										o ||
										_(t || "*", l.nodeType ? [l] : l, []),
									g = e && (o || !t) ? y(u, c, e, l, d) : u,
									h = n
										? s || (o ? e : m || a)
											? []
											: r
										: g,
									f,
									b,
									i;
								if ((n && n(g, h, l, d), a))
									for (
										f = y(h, p),
											a(f, [], l, d),
											b = f.length;
										b--;

									)
										(i = f[b]) &&
											(h[p[b]] = !(g[p[b]] = i));
								if (!o)
									(h = y(
										h === r ? h.splice(m, h.length) : h
									)),
										s ? s(null, r, h, d) : M.apply(r, h);
								else if (s || e) {
									if (s) {
										for (f = [], b = h.length; b--; )
											(i = h[b]) && f.push((g[b] = i));
										s(null, (h = []), f, d);
									}
									for (b = h.length; b--; )
										(i = h[b]) &&
											-1 < (f = s ? L(o, i) : c[b]) &&
											(o[f] = !(r[f] = i));
								}
							})
						);
					}
					function v(e) {
						for (
							var t = e.length,
								n = de.relative[e[0].type],
								o = n || de.relative[" "],
								a = n ? 1 : 0,
								i = h(
									function (e) {
										return e === l;
									},
									o,
									!0
								),
								s = h(
									function (e) {
										return -1 < L(l, e);
									},
									o,
									!0
								),
								r = [
									function (e, t, o) {
										var a =
											(!n && (o || t !== ge)) ||
											((l = t).nodeType
												? i(e, t, o)
												: s(e, t, o));
										return (l = null), a;
									},
								],
								l,
								d,
								c;
							a < t;
							a++
						)
							if ((d = de.relative[e[a].type])) r = [h(f(r), d)];
							else {
								if (
									((d = de.filter[e[a].type].apply(
										null,
										e[a].matches
									)),
									d[k])
								) {
									for (
										c = ++a;
										c < t && !de.relative[e[c].type];
										c++
									);
									return b(
										1 < a && f(r),
										1 < a &&
											g(
												e.slice(0, a - 1).concat({
													value:
														" " === e[a - 2].type
															? "*"
															: "",
												})
											).replace(q, "$1"),
										d,
										a < c && v(e.slice(a, c)),
										c < t && v((e = e.slice(c))),
										c < t && g(e)
									);
								}
								r.push(d);
							}
						return f(r);
					}
					function x(e, n) {
						var a = 0 < n.length,
							s = 0 < e.length,
							i = function (o, r, l, d, c) {
								var p = 0,
									m = "0",
									i = o && [],
									u = [],
									g = ge,
									h = o || (s && de.find.TAG("*", c)),
									f = (I +=
										null == g ? 1 : Math.random() || 0.1),
									_ = h.length,
									b,
									v,
									x;
								for (
									c && (ge = r === ye || r || c);
									m !== _ && null != (b = h[m]);
									m++
								) {
									if (s && b) {
										for (
											v = 0,
												r ||
													b.ownerDocument === ye ||
													(_e(b), (l = !ve));
											(x = e[v++]);

										)
											if (x(b, r || ye, l)) {
												d.push(b);
												break;
											}
										c && (I = f);
									}
									a && ((b = !x && b) && p--, o && i.push(b));
								}
								if (((p += m), a && m !== p)) {
									for (v = 0; (x = n[v++]); ) x(i, u, r, l);
									if (o) {
										if (0 < p)
											for (; m--; )
												i[m] ||
													u[m] ||
													(u[m] = N.call(d));
										u = y(u);
									}
									M.apply(d, u),
										c &&
											!o &&
											0 < u.length &&
											1 < p + n.length &&
											t.uniqueSort(d);
								}
								return c && ((I = f), (ge = g)), i;
							};
						return a ? o(i) : i;
					}
					var k = "sizzle" + 1 * new Date(),
						w = e.document,
						I = 0,
						C = 0,
						T = n(),
						S = n(),
						E = n(),
						D = n(),
						A = function (e, t) {
							return e === t && (fe = !0), 0;
						},
						j = {}.hasOwnProperty,
						P = [],
						N = P.pop,
						$ = P.push,
						M = P.push,
						O = P.slice,
						L = function (e, t) {
							for (var n = 0, o = e.length; n < o; n++)
								if (e[n] === t) return n;
							return -1;
						},
						z =
							"checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
						R = "[\\x20\\t\\r\\n\\f]",
						H = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
						F = /[\x20\t\r\n\f]+/g,
						q =
							/^[\x20\t\r\n\f]+|((?:^|[^\\])(?:\\.)*)[\x20\t\r\n\f]+$/g,
						W = /^[\x20\t\r\n\f]*,[\x20\t\r\n\f]*/,
						B =
							/^[\x20\t\r\n\f]*([>+~]|[\x20\t\r\n\f])[\x20\t\r\n\f]*/,
						U = /[\x20\t\r\n\f]|>/,
						G =
							/:((?:\\.|[\w-]|[^ -\xa0])+)(?:\((('((?:\\.|[^\\'])*)'|"((?:\\.|[^\\"])*)")|((?:\\.|[^\\()[\]]|\[[\x20\t\r\n\f]*((?:\\.|[\w-]|[^ -\xa0])+)(?:[\x20\t\r\n\f]*([*^$|!~]?=)[\x20\t\r\n\f]*(?:'((?:\\.|[^\\'])*)'|"((?:\\.|[^\\"])*)"|((?:\\.|[\w-]|[^ -\xa0])+))|)[\x20\t\r\n\f]*\])*)|.*)\)|)/,
						X = /^(?:\\.|[\w-]|[^ -\xa0])+$/,
						Y = {
							ID: /^#((?:\\.|[\w-]|[^ -\xa0])+)/,
							CLASS: /^\.((?:\\.|[\w-]|[^ -\xa0])+)/,
							TAG: /^((?:\\.|[\w-]|[^ -\xa0])+|[*])/,
							ATTR: /^\[[\x20\t\r\n\f]*((?:\\.|[\w-]|[^ -\xa0])+)(?:[\x20\t\r\n\f]*([*^$|!~]?=)[\x20\t\r\n\f]*(?:'((?:\\.|[^\\'])*)'|"((?:\\.|[^\\"])*)"|((?:\\.|[\w-]|[^ -\xa0])+))|)[\x20\t\r\n\f]*\]/,
							PSEUDO: /^:((?:\\.|[\w-]|[^ -\xa0])+)(?:\((('((?:\\.|[^\\'])*)'|"((?:\\.|[^\\"])*)")|((?:\\.|[^\\()[\]]|\[[\x20\t\r\n\f]*((?:\\.|[\w-]|[^ -\xa0])+)(?:[\x20\t\r\n\f]*([*^$|!~]?=)[\x20\t\r\n\f]*(?:'((?:\\.|[^\\'])*)'|"((?:\\.|[^\\"])*)"|((?:\\.|[\w-]|[^ -\xa0])+))|)[\x20\t\r\n\f]*\])*)|.*)\)|)/,
							CHILD: /^:(only|first|last|nth|nth-last)-(child|of-type)(?:\([\x20\t\r\n\f]*(even|odd|(([+-]|)(\d*)n|)[\x20\t\r\n\f]*(?:([+-]|)[\x20\t\r\n\f]*(\d+)|))[\x20\t\r\n\f]*\)|)/i,
							bool: /^(?:checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped)$/i,
							needsContext:
								/^[\x20\t\r\n\f]*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\([\x20\t\r\n\f]*((?:-\d)?\d*)[\x20\t\r\n\f]*\)|)(?=[^-]|$)/i,
						},
						V = /HTML$/i,
						Z = /^(?:input|select|textarea|button)$/i,
						K = /^h\d$/i,
						J = /^[^{]+\{\s*\[native \w/,
						Q = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
						ee = /[+~]/,
						te =
							/\\([\da-f]{1,6}[\x20\t\r\n\f]?|([\x20\t\r\n\f])|.)/gi,
						ne = function (e, t, n) {
							var o = String.fromCharCode,
								a = "0x" + t - 65536;
							return a != a || n
								? t
								: 0 > a
								? o(a + 65536)
								: o(55296 | (a >> 10), 56320 | (1023 & a));
						},
						oe =
							/([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
						ae = function (e, t) {
							return t
								? "\0" === e
									? "\uFFFD"
									: e.slice(0, -1) +
									  "\\" +
									  e.charCodeAt(e.length - 1).toString(16) +
									  " "
								: "\\" + e;
						},
						ie = function () {
							_e();
						},
						se = h(
							function (e) {
								return (
									!0 === e.disabled &&
									"fieldset" === e.nodeName.toLowerCase()
								);
							},
							{ dir: "parentNode", next: "legend" }
						),
						re,
						le,
						de,
						ce,
						i,
						pe,
						me,
						ue,
						ge,
						he,
						fe,
						_e,
						ye,
						be,
						ve,
						xe,
						ke,
						we,
						Ie;
					try {
						M.apply((P = O.call(w.childNodes)), w.childNodes),
							P[w.childNodes.length].nodeType;
					} catch (t) {
						M = {
							apply: P.length
								? function (e, t) {
										$.apply(e, O.call(t));
								  }
								: function (e, t) {
										for (
											var n = e.length, o = 0;
											(e[n++] = t[o++]);

										);
										e.length = n - 1;
								  },
						};
					}
					for (re in ((le = t.support = {}),
					(i = t.isXML =
						function (e) {
							var t = e.namespaceURI,
								n = (e.ownerDocument || e).documentElement;
							return !V.test(t || (n && n.nodeName) || "HTML");
						}),
					(_e = t.setDocument =
						function (e) {
							var t = e ? e.ownerDocument || e : w,
								n,
								o;
							return t !== ye &&
								9 === t.nodeType &&
								t.documentElement
								? ((ye = t),
								  (be = ye.documentElement),
								  (ve = !i(ye)),
								  w !== ye &&
										(o = ye.defaultView) &&
										o.top !== o &&
										(o.addEventListener
											? o.addEventListener(
													"unload",
													ie,
													!1
											  )
											: o.attachEvent &&
											  o.attachEvent("onunload", ie)),
								  (le.attributes = a(function (e) {
										return (
											(e.className = "i"),
											!e.getAttribute("className")
										);
								  })),
								  (le.getElementsByTagName = a(function (e) {
										return (
											e.appendChild(ye.createComment("")),
											!e.getElementsByTagName("*").length
										);
								  })),
								  (le.getElementsByClassName = J.test(
										ye.getElementsByClassName
								  )),
								  (le.getById = a(function (e) {
										return (
											(be.appendChild(e).id = k),
											!ye.getElementsByName ||
												!ye.getElementsByName(k).length
										);
								  })),
								  le.getById
										? ((de.filter.ID = function (e) {
												var t = e.replace(te, ne);
												return function (e) {
													return (
														e.getAttribute("id") ===
														t
													);
												};
										  }),
										  (de.find.ID = function (e, t) {
												if (
													"undefined" !=
														typeof t.getElementById &&
													ve
												) {
													var n = t.getElementById(e);
													return n ? [n] : [];
												}
										  }))
										: ((de.filter.ID = function (e) {
												var t = e.replace(te, ne);
												return function (e) {
													var n =
														"undefined" !=
															typeof e.getAttributeNode &&
														e.getAttributeNode(
															"id"
														);
													return n && n.value === t;
												};
										  }),
										  (de.find.ID = function (e, t) {
												if (
													"undefined" !=
														typeof t.getElementById &&
													ve
												) {
													var n = t.getElementById(e),
														o,
														a,
														i;
													if (n) {
														if (
															((o =
																n.getAttributeNode(
																	"id"
																)),
															o && o.value === e)
														)
															return [n];
														for (
															i =
																t.getElementsByName(
																	e
																),
																a = 0;
															(n = i[a++]);

														)
															if (
																((o =
																	n.getAttributeNode(
																		"id"
																	)),
																o &&
																	o.value ===
																		e)
															)
																return [n];
													}
													return [];
												}
										  })),
								  (de.find.TAG = le.getElementsByTagName
										? function (e, t) {
												return "undefined" ==
													typeof t.getElementsByTagName
													? le.qsa
														? t.querySelectorAll(e)
														: void 0
													: t.getElementsByTagName(e);
										  }
										: function (e, t) {
												var n = [],
													o = 0,
													a =
														t.getElementsByTagName(
															e
														),
													i;
												if ("*" === e) {
													for (; (i = a[o++]); )
														1 === i.nodeType &&
															n.push(i);
													return n;
												}
												return a;
										  }),
								  (de.find.CLASS =
										le.getElementsByClassName &&
										function (e, t) {
											if (
												"undefined" !=
													typeof t.getElementsByClassName &&
												ve
											)
												return t.getElementsByClassName(
													e
												);
										}),
								  (ke = []),
								  (xe = []),
								  (le.qsa = J.test(ye.querySelectorAll)) &&
										(a(function (e) {
											(be.appendChild(e).innerHTML =
												"<a id='" +
												k +
												"'></a><select id='" +
												k +
												"-\r\\' msallowcapture=''><option selected=''></option></select>"),
												e.querySelectorAll(
													"[msallowcapture^='']"
												).length &&
													xe.push(
														"[*^$]=" +
															R +
															"*(?:''|\"\")"
													),
												e.querySelectorAll("[selected]")
													.length ||
													xe.push(
														"\\[" +
															R +
															"*(?:value|" +
															z +
															")"
													),
												e.querySelectorAll(
													"[id~=" + k + "-]"
												).length || xe.push("~="),
												e.querySelectorAll(":checked")
													.length ||
													xe.push(":checked"),
												e.querySelectorAll(
													"a#" + k + "+*"
												).length || xe.push(".#.+[+~]");
										}),
										a(function (e) {
											e.innerHTML =
												"<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
											var t = ye.createElement("input");
											t.setAttribute("type", "hidden"),
												e
													.appendChild(t)
													.setAttribute("name", "D"),
												e.querySelectorAll("[name=d]")
													.length &&
													xe.push(
														"name" +
															R +
															"*[*^$|!~]?="
													),
												2 !==
													e.querySelectorAll(
														":enabled"
													).length &&
													xe.push(
														":enabled",
														":disabled"
													),
												(be.appendChild(e).disabled =
													!0),
												2 !==
													e.querySelectorAll(
														":disabled"
													).length &&
													xe.push(
														":enabled",
														":disabled"
													),
												e.querySelectorAll("*,:x"),
												xe.push(",.*:");
										})),
								  (le.matchesSelector = J.test(
										(we =
											be.matches ||
											be.webkitMatchesSelector ||
											be.mozMatchesSelector ||
											be.oMatchesSelector ||
											be.msMatchesSelector)
								  )) &&
										a(function (e) {
											(le.disconnectedMatch = we.call(
												e,
												"*"
											)),
												we.call(e, "[s!='']:x"),
												ke.push(
													"!=",
													":(" +
														H +
														")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
														("\\[" +
															R +
															"*(" +
															H +
															")(?:" +
															R +
															"*([*^$|!~]?=)" +
															R +
															"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
															H +
															"))|)" +
															R +
															"*\\]") +
														")*)|.*)\\)|)"
												);
										}),
								  (xe = xe.length && new RegExp(xe.join("|"))),
								  (ke = ke.length && new RegExp(ke.join("|"))),
								  (n = J.test(be.compareDocumentPosition)),
								  (Ie =
										n || J.test(be.contains)
											? function (e, t) {
													var n =
															9 === e.nodeType
																? e.documentElement
																: e,
														o = t && t.parentNode;
													return (
														e === o ||
														!!(
															o &&
															1 === o.nodeType &&
															(n.contains
																? n.contains(o)
																: e.compareDocumentPosition &&
																  16 &
																		e.compareDocumentPosition(
																			o
																		))
														)
													);
											  }
											: function (e, t) {
													if (t)
														for (
															;
															(t = t.parentNode);

														)
															if (t === e)
																return !0;
													return !1;
											  }),
								  (A = n
										? function (e, t) {
												if (e === t)
													return (fe = !0), 0;
												var n =
													!e.compareDocumentPosition -
													!t.compareDocumentPosition;
												return n
													? n
													: ((n =
															(e.ownerDocument ||
																e) ===
															(t.ownerDocument ||
																t)
																? e.compareDocumentPosition(
																		t
																  )
																: 1),
													  1 & n ||
													  (!le.sortDetached &&
															t.compareDocumentPosition(
																e
															) === n)
															? e === ye ||
															  (e.ownerDocument ===
																	w &&
																	Ie(w, e))
																? -1
																: t === ye ||
																  (t.ownerDocument ===
																		w &&
																		Ie(
																			w,
																			t
																		))
																? 1
																: he
																? L(he, e) -
																  L(he, t)
																: 0
															: 4 & n
															? -1
															: 1);
										  }
										: function (e, t) {
												if (e === t)
													return (fe = !0), 0;
												var n = 0,
													o = e.parentNode,
													a = t.parentNode,
													i = [e],
													s = [t],
													l;
												if (!o || !a)
													return e === ye
														? -1
														: t === ye
														? 1
														: o
														? -1
														: a
														? 1
														: he
														? L(he, e) - L(he, t)
														: 0;
												if (o === a) return r(e, t);
												for (
													l = e;
													(l = l.parentNode);

												)
													i.unshift(l);
												for (
													l = t;
													(l = l.parentNode);

												)
													s.unshift(l);
												for (; i[n] === s[n]; ) n++;
												return n
													? r(i[n], s[n])
													: i[n] === w
													? -1
													: s[n] === w
													? 1
													: 0;
										  }),
								  ye)
								: ye;
						}),
					(t.matches = function (e, n) {
						return t(e, null, null, n);
					}),
					(t.matchesSelector = function (e, n) {
						if (
							((e.ownerDocument || e) !== ye && _e(e),
							le.matchesSelector &&
								ve &&
								!D[n + " "] &&
								(!ke || !ke.test(n)) &&
								(!xe || !xe.test(n)))
						)
							try {
								var o = we.call(e, n);
								if (
									o ||
									le.disconnectedMatch ||
									(e.document && 11 !== e.document.nodeType)
								)
									return o;
							} catch (t) {
								D(n, !0);
							}
						return 0 < t(n, ye, null, [e]).length;
					}),
					(t.contains = function (e, t) {
						return (e.ownerDocument || e) !== ye && _e(e), Ie(e, t);
					}),
					(t.attr = function (e, t) {
						(e.ownerDocument || e) !== ye && _e(e);
						var n = de.attrHandle[t.toLowerCase()],
							o =
								n && j.call(de.attrHandle, t.toLowerCase())
									? n(e, t, !ve)
									: void 0;
						return void 0 === o
							? le.attributes || !ve
								? e.getAttribute(t)
								: (o = e.getAttributeNode(t)) && o.specified
								? o.value
								: null
							: o;
					}),
					(t.escape = function (e) {
						return (e + "").replace(oe, ae);
					}),
					(t.error = function (e) {
						throw new Error(
							"Syntax error, unrecognized expression: " + e
						);
					}),
					(t.uniqueSort = function (e) {
						var t = [],
							n = 0,
							o = 0,
							a;
						if (
							((fe = !le.detectDuplicates),
							(he = !le.sortStable && e.slice(0)),
							e.sort(A),
							fe)
						) {
							for (; (a = e[o++]); )
								a === e[o] && (n = t.push(o));
							for (; n--; ) e.splice(t[n], 1);
						}
						return (he = null), e;
					}),
					(ce = t.getText =
						function (e) {
							var t = "",
								n = 0,
								o = e.nodeType,
								a;
							if (!o) for (; (a = e[n++]); ) t += ce(a);
							else if (1 === o || 9 === o || 11 === o) {
								if ("string" == typeof e.textContent)
									return e.textContent;
								for (e = e.firstChild; e; e = e.nextSibling)
									t += ce(e);
							} else if (3 === o || 4 === o) return e.nodeValue;
							return t;
						}),
					(de = t.selectors =
						{
							cacheLength: 50,
							createPseudo: o,
							match: Y,
							attrHandle: {},
							find: {},
							relative: {
								">": { dir: "parentNode", first: !0 },
								" ": { dir: "parentNode" },
								"+": { dir: "previousSibling", first: !0 },
								"~": { dir: "previousSibling" },
							},
							preFilter: {
								ATTR: function (e) {
									return (
										(e[1] = e[1].replace(te, ne)),
										(e[3] = (
											e[3] ||
											e[4] ||
											e[5] ||
											""
										).replace(te, ne)),
										"~=" === e[2] &&
											(e[3] = " " + e[3] + " "),
										e.slice(0, 4)
									);
								},
								CHILD: function (e) {
									return (
										(e[1] = e[1].toLowerCase()),
										"nth" === e[1].slice(0, 3)
											? (!e[3] && t.error(e[0]),
											  (e[4] = +(e[4]
													? e[5] + (e[6] || 1)
													: 2 *
													  ("even" === e[3] ||
															"odd" === e[3]))),
											  (e[5] = +(
													e[7] + e[8] ||
													"odd" === e[3]
											  )))
											: e[3] && t.error(e[0]),
										e
									);
								},
								PSEUDO: function (e) {
									var t = !e[6] && e[2],
										n;
									return Y.CHILD.test(e[0])
										? null
										: (e[3]
												? (e[2] = e[4] || e[5] || "")
												: t &&
												  G.test(t) &&
												  (n = pe(t, !0)) &&
												  (n =
														t.indexOf(
															")",
															t.length - n
														) - t.length) &&
												  ((e[0] = e[0].slice(0, n)),
												  (e[2] = t.slice(0, n))),
										  e.slice(0, 3));
								},
							},
							filter: {
								TAG: function (e) {
									var t = e.replace(te, ne).toLowerCase();
									return "*" === e
										? function () {
												return !0;
										  }
										: function (e) {
												return (
													e.nodeName &&
													e.nodeName.toLowerCase() ===
														t
												);
										  };
								},
								CLASS: function (e) {
									var t = T[e + " "];
									return (
										t ||
										((t = new RegExp(
											"(^|" +
												R +
												")" +
												e +
												"(" +
												R +
												"|$)"
										)) &&
											T(e, function (e) {
												return t.test(
													("string" ==
														typeof e.className &&
														e.className) ||
														("undefined" !=
															typeof e.getAttribute &&
															e.getAttribute(
																"class"
															)) ||
														""
												);
											}))
									);
								},
								ATTR: function (e, n, o) {
									return function (a) {
										var i = t.attr(a, e);
										return null == i
											? "!=" === n
											: !n ||
													((i += ""),
													"=" === n
														? i === o
														: "!=" === n
														? i !== o
														: "^=" === n
														? o &&
														  0 === i.indexOf(o)
														: "*=" === n
														? o && -1 < i.indexOf(o)
														: "$=" === n
														? o &&
														  i.slice(-o.length) ===
																o
														: "~=" === n
														? -1 <
														  (
																" " +
																i.replace(
																	F,
																	" "
																) +
																" "
														  ).indexOf(o)
														: "|=" === n &&
														  (i === o ||
																i.slice(
																	0,
																	o.length + 1
																) ===
																	o + "-"));
									};
								},
								CHILD: function (e, t, n, o, a) {
									var i = "nth" !== e.slice(0, 3),
										s = "last" !== e.slice(-4),
										r = "of-type" === t;
									return 1 === o && 0 === a
										? function (e) {
												return !!e.parentNode;
										  }
										: function (t, n, l) {
												var d =
														i == s
															? "previousSibling"
															: "nextSibling",
													c = t.parentNode,
													p =
														r &&
														t.nodeName.toLowerCase(),
													m = !l && !r,
													u = !1,
													g,
													h,
													f,
													_,
													y,
													b;
												if (c) {
													if (i) {
														for (; d; ) {
															for (
																_ = t;
																(_ = _[d]);

															)
																if (
																	r
																		? _.nodeName.toLowerCase() ===
																		  p
																		: 1 ===
																		  _.nodeType
																)
																	return !1;
															b = d =
																"only" === e &&
																!b &&
																"nextSibling";
														}
														return !0;
													}
													if (
														((b = [
															s
																? c.firstChild
																: c.lastChild,
														]),
														s && m)
													) {
														for (
															_ = c,
																f =
																	_[k] ||
																	(_[k] = {}),
																h =
																	f[
																		_
																			.uniqueID
																	] ||
																	(f[
																		_.uniqueID
																	] = {}),
																g = h[e] || [],
																y =
																	g[0] ===
																		I &&
																	g[1],
																u = y && g[2],
																_ =
																	y &&
																	c
																		.childNodes[
																		y
																	];
															(_ =
																(++y &&
																	_ &&
																	_[d]) ||
																(u = y = 0) ||
																b.pop());

														)
															if (
																1 ===
																	_.nodeType &&
																++u &&
																_ === t
															) {
																h[e] = [
																	I,
																	y,
																	u,
																];
																break;
															}
													} else if (
														(m &&
															((_ = t),
															(f =
																_[k] ||
																(_[k] = {})),
															(h =
																f[_.uniqueID] ||
																(f[_.uniqueID] =
																	{})),
															(g = h[e] || []),
															(y =
																g[0] === I &&
																g[1]),
															(u = y)),
														!1 === u)
													)
														for (
															;
															(_ =
																(++y &&
																	_ &&
																	_[d]) ||
																(u = y = 0) ||
																b.pop()) &&
															!(
																(r
																	? _.nodeName.toLowerCase() ===
																	  p
																	: 1 ===
																	  _.nodeType) &&
																++u &&
																(m &&
																	((f =
																		_[k] ||
																		(_[k] =
																			{})),
																	(h =
																		f[
																			_
																				.uniqueID
																		] ||
																		(f[
																			_.uniqueID
																		] =
																			{})),
																	(h[e] = [
																		I,
																		u,
																	])),
																_ === t)
															);

														);
													return (
														(u -= a),
														u === o ||
															(0 == u % o &&
																0 <= u / o)
													);
												}
										  };
								},
								PSEUDO: function (e, n) {
									var a =
											de.pseudos[e] ||
											de.setFilters[e.toLowerCase()] ||
											t.error("unsupported pseudo: " + e),
										i;
									return a[k]
										? a(n)
										: 1 < a.length
										? ((i = [e, e, "", n]),
										  de.setFilters.hasOwnProperty(
												e.toLowerCase()
										  )
												? o(function (e, t) {
														for (
															var o = a(e, n),
																s = o.length,
																i;
															s--;

														)
															(i = L(e, o[s])),
																(e[i] = !(t[i] =
																	o[s]));
												  })
												: function (e) {
														return a(e, 0, i);
												  })
										: a;
								},
							},
							pseudos: {
								not: o(function (e) {
									var t = [],
										n = [],
										a = me(e.replace(q, "$1"));
									return a[k]
										? o(function (e, t, n, o) {
												for (
													var s = a(e, null, o, []),
														r = e.length,
														i;
													r--;

												)
													(i = s[r]) &&
														(e[r] = !(t[r] = i));
										  })
										: function (e, o, i) {
												return (
													(t[0] = e),
													a(t, null, i, n),
													(t[0] = null),
													!n.pop()
												);
										  };
								}),
								has: o(function (e) {
									return function (n) {
										return 0 < t(e, n).length;
									};
								}),
								contains: o(function (e) {
									return (
										(e = e.replace(te, ne)),
										function (t) {
											return (
												-1 <
												(
													t.textContent || ce(t)
												).indexOf(e)
											);
										}
									);
								}),
								lang: o(function (e) {
									return (
										X.test(e || "") ||
											t.error("unsupported lang: " + e),
										(e = e.replace(te, ne).toLowerCase()),
										function (t) {
											var n;
											do
												if (
													(n = ve
														? t.lang
														: t.getAttribute(
																"xml:lang"
														  ) ||
														  t.getAttribute(
																"lang"
														  ))
												)
													return (
														(n = n.toLowerCase()),
														n === e ||
															0 ===
																n.indexOf(
																	e + "-"
																)
													);
											while (
												(t = t.parentNode) &&
												1 === t.nodeType
											);
											return !1;
										}
									);
								}),
								target: function (t) {
									var n = e.location && e.location.hash;
									return n && n.slice(1) === t.id;
								},
								root: function (e) {
									return e === be;
								},
								focus: function (e) {
									return (
										e === ye.activeElement &&
										(!ye.hasFocus || ye.hasFocus()) &&
										!!(e.type || e.href || ~e.tabIndex)
									);
								},
								enabled: c(!1),
								disabled: c(!0),
								checked: function (e) {
									var t = e.nodeName.toLowerCase();
									return (
										("input" === t && !!e.checked) ||
										("option" === t && !!e.selected)
									);
								},
								selected: function (e) {
									return (
										e.parentNode &&
											e.parentNode.selectedIndex,
										!0 === e.selected
									);
								},
								empty: function (e) {
									for (e = e.firstChild; e; e = e.nextSibling)
										if (6 > e.nodeType) return !1;
									return !0;
								},
								parent: function (e) {
									return !de.pseudos.empty(e);
								},
								header: function (e) {
									return K.test(e.nodeName);
								},
								input: function (e) {
									return Z.test(e.nodeName);
								},
								button: function (e) {
									var t = e.nodeName.toLowerCase();
									return (
										("input" === t &&
											"button" === e.type) ||
										"button" === t
									);
								},
								text: function (e) {
									var t;
									return (
										"input" === e.nodeName.toLowerCase() &&
										"text" === e.type &&
										(null == (t = e.getAttribute("type")) ||
											"text" === t.toLowerCase())
									);
								},
								first: p(function () {
									return [0];
								}),
								last: p(function (e, t) {
									return [t - 1];
								}),
								eq: p(function (e, t, n) {
									return [0 > n ? n + t : n];
								}),
								even: p(function (e, t) {
									for (var n = 0; n < t; n += 2) e.push(n);
									return e;
								}),
								odd: p(function (e, t) {
									for (var n = 1; n < t; n += 2) e.push(n);
									return e;
								}),
								lt: p(function (e, t, n) {
									for (
										var o = 0 > n ? n + t : n > t ? t : n;
										0 <= --o;

									)
										e.push(o);
									return e;
								}),
								gt: p(function (e, t, n) {
									for (var o = 0 > n ? n + t : n; ++o < t; )
										e.push(o);
									return e;
								}),
							},
						}),
					(de.pseudos.nth = de.pseudos.eq),
					{
						radio: !0,
						checkbox: !0,
						file: !0,
						password: !0,
						image: !0,
					}))
						de.pseudos[re] = l(re);
					for (re in { submit: !0, reset: !0 })
						de.pseudos[re] = d(re);
					return (
						(u.prototype = de.filters = de.pseudos),
						(de.setFilters = new u()),
						(pe = t.tokenize =
							function (e, n) {
								var o = S[e + " "],
									a,
									i,
									s,
									r,
									l,
									d,
									c;
								if (o) return n ? 0 : o.slice(0);
								for (l = e, d = [], c = de.preFilter; l; ) {
									for (r in ((!a || (i = W.exec(l))) &&
										(i && (l = l.slice(i[0].length) || l),
										d.push((s = []))),
									(a = !1),
									(i = B.exec(l)) &&
										((a = i.shift()),
										s.push({
											value: a,
											type: i[0].replace(q, " "),
										}),
										(l = l.slice(a.length))),
									de.filter))
										(i = Y[r].exec(l)) &&
											(!c[r] || (i = c[r](i))) &&
											((a = i.shift()),
											s.push({
												value: a,
												type: r,
												matches: i,
											}),
											(l = l.slice(a.length)));
									if (!a) break;
								}
								return n
									? l.length
									: l
									? t.error(e)
									: S(e, d).slice(0);
							}),
						(me = t.compile =
							function (e, t) {
								var n = [],
									o = [],
									a = E[e + " "],
									s;
								if (!a) {
									for (t || (t = pe(e)), s = t.length; s--; )
										(a = v(t[s])),
											a[k] ? n.push(a) : o.push(a);
									(a = E(e, x(o, n))), (a.selector = e);
								}
								return a;
							}),
						(ue = t.select =
							function (e, t, n, o) {
								var a = "function" == typeof e && e,
									s = !o && pe((e = a.selector || e)),
									r,
									i,
									l,
									d,
									c;
								if (((n = n || []), 1 === s.length)) {
									if (
										((i = s[0] = s[0].slice(0)),
										2 < i.length &&
											"ID" === (l = i[0]).type &&
											9 === t.nodeType &&
											ve &&
											de.relative[i[1].type])
									) {
										if (
											((t = (de.find.ID(
												l.matches[0].replace(te, ne),
												t
											) || [])[0]),
											!t)
										)
											return n;
										a && (t = t.parentNode),
											(e = e.slice(
												i.shift().value.length
											));
									}
									for (
										r = Y.needsContext.test(e)
											? 0
											: i.length;
										r-- &&
										((l = i[r]),
										!de.relative[(d = l.type)]);

									)
										if (
											(c = de.find[d]) &&
											(o = c(
												l.matches[0].replace(te, ne),
												(ee.test(i[0].type) &&
													m(t.parentNode)) ||
													t
											))
										) {
											if (
												(i.splice(r, 1),
												(e = o.length && g(i)),
												!e)
											)
												return M.apply(n, o), n;
											break;
										}
								}
								return (
									(a || me(e, s))(
										o,
										t,
										!ve,
										n,
										!t ||
											(ee.test(e) && m(t.parentNode)) ||
											t
									),
									n
								);
							}),
						(le.sortStable = k.split("").sort(A).join("") === k),
						(le.detectDuplicates = !!fe),
						_e(),
						(le.sortDetached = a(function (e) {
							return (
								1 &
								e.compareDocumentPosition(
									ye.createElement("fieldset")
								)
							);
						})),
						a(function (e) {
							return (
								(e.innerHTML = "<a href='#'></a>"),
								"#" === e.firstChild.getAttribute("href")
							);
						}) ||
							s("type|href|height|width", function (e, t, n) {
								if (!n)
									return e.getAttribute(
										t,
										"type" === t.toLowerCase() ? 1 : 2
									);
							}),
						(le.attributes &&
							a(function (e) {
								return (
									(e.innerHTML = "<input/>"),
									e.firstChild.setAttribute("value", ""),
									"" === e.firstChild.getAttribute("value")
								);
							})) ||
							s("value", function (e, t, n) {
								if (!n && "input" === e.nodeName.toLowerCase())
									return e.defaultValue;
							}),
						a(function (e) {
							return null == e.getAttribute("disabled");
						}) ||
							s(z, function (e, t, n) {
								var o;
								if (!n)
									return !0 === e[t]
										? t.toLowerCase()
										: (o = e.getAttributeNode(t)) &&
										  o.specified
										? o.value
										: null;
							}),
						t
					);
				})(r);
				(Ae.find = Pe),
					(Ae.expr = Pe.selectors),
					(Ae.expr[":"] = Ae.expr.pseudos),
					(Ae.uniqueSort = Ae.unique = Pe.uniqueSort),
					(Ae.text = Pe.getText),
					(Ae.isXMLDoc = Pe.isXML),
					(Ae.contains = Pe.contains),
					(Ae.escapeSelector = Pe.escape);
				var Ne = function (e, t, n) {
						for (var o = []; (e = e[t]) && 9 !== e.nodeType; )
							if (1 === e.nodeType) {
								if (void 0 !== n && Ae(e).is(n)) break;
								o.push(e);
							}
						return o;
					},
					$e = function (e, t) {
						for (var n = []; e; e = e.nextSibling)
							1 === e.nodeType && e !== t && n.push(e);
						return n;
					},
					Me = Ae.expr.match.needsContext,
					Oe =
						/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
				(Ae.filter = function (e, t, n) {
					var o = t[0];
					return (
						n && (e = ":not(" + e + ")"),
						1 === t.length && 1 === o.nodeType
							? Ae.find.matchesSelector(o, e)
								? [o]
								: []
							: Ae.find.matches(
									e,
									Ae.grep(t, function (e) {
										return 1 === e.nodeType;
									})
							  )
					);
				}),
					Ae.fn.extend({
						find: function (e) {
							var t = this.length,
								n = this,
								o,
								a;
							if ("string" != typeof e)
								return this.pushStack(
									Ae(e).filter(function () {
										for (o = 0; o < t; o++)
											if (Ae.contains(n[o], this))
												return !0;
									})
								);
							for (a = this.pushStack([]), o = 0; o < t; o++)
								Ae.find(e, n[o], a);
							return 1 < t ? Ae.uniqueSort(a) : a;
						},
						filter: function (e) {
							return this.pushStack(u(this, e || [], !1));
						},
						not: function (e) {
							return this.pushStack(u(this, e || [], !0));
						},
						is: function (e) {
							return !!u(
								this,
								"string" == typeof e && Me.test(e)
									? Ae(e)
									: e || [],
								!1
							).length;
						},
					});
				var Le = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
					ze = (Ae.fn.init = function (e, t, n) {
						var o, a;
						if (!e) return this;
						if (((n = n || Re), "string" == typeof e)) {
							if (
								((o =
									"<" === e[0] &&
									">" === e[e.length - 1] &&
									3 <= e.length
										? [null, e, null]
										: Le.exec(e)),
								o && (o[1] || !t))
							) {
								if (o[1]) {
									if (
										((t = t instanceof Ae ? t[0] : t),
										Ae.merge(
											this,
											Ae.parseHTML(
												o[1],
												t && t.nodeType
													? t.ownerDocument || t
													: ge,
												!0
											)
										),
										Oe.test(o[1]) && Ae.isPlainObject(t))
									)
										for (o in t)
											Te(this[o])
												? this[o](t[o])
												: this.attr(o, t[o]);
									return this;
								}
								return (
									(a = ge.getElementById(o[2])),
									a && ((this[0] = a), (this.length = 1)),
									this
								);
							}
							return !t || t.jquery
								? (t || n).find(e)
								: this.constructor(t).find(e);
						}
						return e.nodeType
							? ((this[0] = e), (this.length = 1), this)
							: Te(e)
							? void 0 === n.ready
								? e(Ae)
								: n.ready(e)
							: Ae.makeArray(e, this);
					}),
					Re;
				(ze.prototype = Ae.fn), (Re = Ae(ge));
				var He = /^(?:parents|prev(?:Until|All))/,
					Fe = { children: !0, contents: !0, next: !0, prev: !0 };
				Ae.fn.extend({
					has: function (e) {
						var t = Ae(e, this),
							n = t.length;
						return this.filter(function () {
							for (var e = 0; e < n; e++)
								if (Ae.contains(this, t[e])) return !0;
						});
					},
					closest: function (e, t) {
						var n = 0,
							o = this.length,
							a = [],
							i = "string" != typeof e && Ae(e),
							s;
						if (!Me.test(e))
							for (; n < o; n++)
								for (
									s = this[n];
									s && s !== t;
									s = s.parentNode
								)
									if (
										11 > s.nodeType &&
										(i
											? -1 < i.index(s)
											: 1 === s.nodeType &&
											  Ae.find.matchesSelector(s, e))
									) {
										a.push(s);
										break;
									}
						return this.pushStack(
							1 < a.length ? Ae.uniqueSort(a) : a
						);
					},
					index: function (e) {
						return e
							? "string" == typeof e
								? be.call(Ae(e), this[0])
								: be.call(this, e.jquery ? e[0] : e)
							: this[0] && this[0].parentNode
							? this.first().prevAll().length
							: -1;
					},
					add: function (e, t) {
						return this.pushStack(
							Ae.uniqueSort(Ae.merge(this.get(), Ae(e, t)))
						);
					},
					addBack: function (e) {
						return this.add(
							null == e
								? this.prevObject
								: this.prevObject.filter(e)
						);
					},
				}),
					Ae.each(
						{
							parent: function (e) {
								var t = e.parentNode;
								return t && 11 !== t.nodeType ? t : null;
							},
							parents: function (e) {
								return Ne(e, "parentNode");
							},
							parentsUntil: function (e, t, n) {
								return Ne(e, "parentNode", n);
							},
							next: function (e) {
								return g(e, "nextSibling");
							},
							prev: function (e) {
								return g(e, "previousSibling");
							},
							nextAll: function (e) {
								return Ne(e, "nextSibling");
							},
							prevAll: function (e) {
								return Ne(e, "previousSibling");
							},
							nextUntil: function (e, t, n) {
								return Ne(e, "nextSibling", n);
							},
							prevUntil: function (e, t, n) {
								return Ne(e, "previousSibling", n);
							},
							siblings: function (e) {
								return $e((e.parentNode || {}).firstChild, e);
							},
							children: function (e) {
								return $e(e.firstChild);
							},
							contents: function (e) {
								return "undefined" == typeof e.contentDocument
									? (m(e, "template") && (e = e.content || e),
									  Ae.merge([], e.childNodes))
									: e.contentDocument;
							},
						},
						function (e, t) {
							Ae.fn[e] = function (n, o) {
								var a = Ae.map(this, t, n);
								return (
									"Until" !== e.slice(-5) && (o = n),
									o &&
										"string" == typeof o &&
										(a = Ae.filter(o, a)),
									1 < this.length &&
										(!Fe[e] && Ae.uniqueSort(a),
										He.test(e) && a.reverse()),
									this.pushStack(a)
								);
							};
						}
					);
				var qe = /[^\x20\t\r\n\f]+/g;
				(Ae.Callbacks = function (e) {
					e = "string" == typeof e ? h(e) : Ae.extend({}, e);
					var t = [],
						n = [],
						o = -1,
						a = function () {
							for (d = d || e.once, l = s = !0; n.length; o = -1)
								for (r = n.shift(); ++o < t.length; )
									!1 === t[o].apply(r[0], r[1]) &&
										e.stopOnFalse &&
										((o = t.length), (r = !1));
							e.memory || (r = !1),
								(s = !1),
								d && (r ? (t = []) : (t = ""));
						},
						i = {
							add: function () {
								return (
									t &&
										(r &&
											!s &&
											((o = t.length - 1), n.push(r)),
										(function n(o) {
											Ae.each(o, function (o, a) {
												Te(a)
													? (!e.unique ||
															!i.has(a)) &&
													  t.push(a)
													: a &&
													  a.length &&
													  "string" !== c(a) &&
													  n(a);
											});
										})(arguments),
										r && !s && a()),
									this
								);
							},
							remove: function () {
								return (
									Ae.each(arguments, function (e, n) {
										for (
											var a;
											-1 < (a = Ae.inArray(n, t, a));

										)
											t.splice(a, 1), a <= o && o--;
									}),
									this
								);
							},
							has: function (e) {
								return e ? -1 < Ae.inArray(e, t) : 0 < t.length;
							},
							empty: function () {
								return t && (t = []), this;
							},
							disable: function () {
								return (d = n = []), (t = r = ""), this;
							},
							disabled: function () {
								return !t;
							},
							lock: function () {
								return (
									(d = n = []), r || s || (t = r = ""), this
								);
							},
							locked: function () {
								return !!d;
							},
							fireWith: function (e, t) {
								return (
									d ||
										((t = t || []),
										(t = [e, t.slice ? t.slice() : t]),
										n.push(t),
										!s && a()),
									this
								);
							},
							fire: function () {
								return i.fireWith(this, arguments), this;
							},
							fired: function () {
								return !!l;
							},
						},
						s,
						r,
						l,
						d;
					return i;
				}),
					Ae.extend({
						Deferred: function (e) {
							var t = [
									[
										"notify",
										"progress",
										Ae.Callbacks("memory"),
										Ae.Callbacks("memory"),
										2,
									],
									[
										"resolve",
										"done",
										Ae.Callbacks("once memory"),
										Ae.Callbacks("once memory"),
										0,
										"resolved",
									],
									[
										"reject",
										"fail",
										Ae.Callbacks("once memory"),
										Ae.Callbacks("once memory"),
										1,
										"rejected",
									],
								],
								n = "pending",
								o = {
									state: function () {
										return n;
									},
									always: function () {
										return (
											a.done(arguments).fail(arguments),
											this
										);
									},
									catch: function (e) {
										return o.then(null, e);
									},
									pipe: function () {
										var e = arguments;
										return Ae.Deferred(function (n) {
											Ae.each(t, function (t, o) {
												var i = Te(e[o[4]]) && e[o[4]];
												a[o[1]](function () {
													var e =
														i &&
														i.apply(
															this,
															arguments
														);
													e && Te(e.promise)
														? e
																.promise()
																.progress(
																	n.notify
																)
																.done(n.resolve)
																.fail(n.reject)
														: n[o[0] + "With"](
																this,
																i
																	? [e]
																	: arguments
														  );
												});
											}),
												(e = null);
										}).promise();
									},
									then: function (e, n, o) {
										function a(t, n, o, e) {
											return function () {
												var s = this,
													l = arguments,
													d = function () {
														var r, d;
														if (!(t < i)) {
															if (
																((r = o.apply(
																	s,
																	l
																)),
																r ===
																	n.promise())
															)
																throw new TypeError(
																	"Thenable self-resolution"
																);
															(d =
																r &&
																("object" ==
																	typeof r ||
																	"function" ==
																		typeof r) &&
																r.then),
																Te(d)
																	? e
																		? d.call(
																				r,
																				a(
																					i,
																					n,
																					f,
																					e
																				),
																				a(
																					i,
																					n,
																					_,
																					e
																				)
																		  )
																		: (i++,
																		  d.call(
																				r,
																				a(
																					i,
																					n,
																					f,
																					e
																				),
																				a(
																					i,
																					n,
																					_,
																					e
																				),
																				a(
																					i,
																					n,
																					f,
																					n.notifyWith
																				)
																		  ))
																	: (o !==
																			f &&
																			((s =
																				void 0),
																			(l =
																				[
																					r,
																				])),
																	  (
																			e ||
																			n.resolveWith
																	  )(s, l));
														}
													},
													c = e
														? d
														: function () {
																try {
																	d();
																} catch (a) {
																	Ae.Deferred
																		.exceptionHook &&
																		Ae.Deferred.exceptionHook(
																			a,
																			c.stackTrace
																		),
																		t + 1 >=
																			i &&
																			(o !==
																				_ &&
																				((s =
																					void 0),
																				(l =
																					[
																						a,
																					])),
																			n.rejectWith(
																				s,
																				l
																			));
																}
														  };
												t
													? c()
													: (Ae.Deferred
															.getStackHook &&
															(c.stackTrace =
																Ae.Deferred.getStackHook()),
													  r.setTimeout(c));
											};
										}
										var i = 0;
										return Ae.Deferred(function (i) {
											t[0][3].add(
												a(
													0,
													i,
													Te(o) ? o : f,
													i.notifyWith
												)
											),
												t[1][3].add(
													a(0, i, Te(e) ? e : f)
												),
												t[2][3].add(
													a(0, i, Te(n) ? n : _)
												);
										}).promise();
									},
									promise: function (e) {
										return null == e ? o : Ae.extend(e, o);
									},
								},
								a = {};
							return (
								Ae.each(t, function (e, i) {
									var s = i[2],
										r = i[5];
									(o[i[1]] = s.add),
										r &&
											s.add(
												function () {
													n = r;
												},
												t[3 - e][2].disable,
												t[3 - e][3].disable,
												t[0][2].lock,
												t[0][3].lock
											),
										s.add(i[3].fire),
										(a[i[0]] = function () {
											return (
												a[i[0] + "With"](
													this === a ? void 0 : this,
													arguments
												),
												this
											);
										}),
										(a[i[0] + "With"] = s.fireWith);
								}),
								o.promise(a),
								e && e.call(a, a),
								a
							);
						},
						when: function (e) {
							var t = arguments.length,
								n = t,
								o = Array(n),
								a = fe.call(arguments),
								s = Ae.Deferred(),
								i = function (e) {
									return function (n) {
										(o[e] = this),
											(a[e] =
												1 < arguments.length
													? fe.call(arguments)
													: n),
											--t || s.resolveWith(o, a);
									};
								};
							if (
								1 >= t &&
								(y(e, s.done(i(n)).resolve, s.reject, !t),
								"pending" === s.state() ||
									Te(a[n] && a[n].then))
							)
								return s.then();
							for (; n--; ) y(a[n], i(n), s.reject);
							return s.promise();
						},
					});
				var We =
					/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
				(Ae.Deferred.exceptionHook = function (e, t) {
					r.console &&
						r.console.warn &&
						e &&
						We.test(e.name) &&
						r.console.warn(
							"jQuery.Deferred exception: " + e.message,
							e.stack,
							t
						);
				}),
					(Ae.readyException = function (e) {
						r.setTimeout(function () {
							throw e;
						});
					});
				var Be = Ae.Deferred();
				(Ae.fn.ready = function (e) {
					return (
						Be.then(e).catch(function (e) {
							Ae.readyException(e);
						}),
						this
					);
				}),
					Ae.extend({
						isReady: !1,
						readyWait: 1,
						ready: function (e) {
							(!0 === e ? !--Ae.readyWait : !Ae.isReady) &&
								((Ae.isReady = !0),
								(!0 !== e && 0 < --Ae.readyWait) ||
									Be.resolveWith(ge, [Ae]));
						},
					}),
					(Ae.ready.then = Be.then),
					"complete" !== ge.readyState &&
					("loading" === ge.readyState || ge.documentElement.doScroll)
						? (ge.addEventListener("DOMContentLoaded", b),
						  r.addEventListener("load", b))
						: r.setTimeout(Ae.ready);
				var Ue = function (e, t, n, o, a, s, r) {
						var l = 0,
							i = e.length,
							d = null == n;
						if ("object" === c(n))
							for (l in ((a = !0), n))
								Ue(e, t, l, n[l], !0, s, r);
						else if (
							void 0 !== o &&
							((a = !0),
							Te(o) || (r = !0),
							d &&
								(r
									? (t.call(e, o), (t = null))
									: ((d = t),
									  (t = function (e, t, n) {
											return d.call(Ae(e), n);
									  }))),
							t)
						)
							for (; l < i; l++)
								t(e[l], n, r ? o : o.call(e[l], l, t(e[l], n)));
						return a ? e : d ? t.call(e) : i ? t(e[0], n) : s;
					},
					Ge = /^-ms-/,
					Xe = /-([a-z])/g,
					Ye = function (e) {
						return (
							1 === e.nodeType || 9 === e.nodeType || !+e.nodeType
						);
					};
				(k.uid = 1),
					(k.prototype = {
						cache: function (e) {
							var t = e[this.expando];
							return (
								t ||
									((t = {}),
									Ye(e) &&
										(e.nodeType
											? (e[this.expando] = t)
											: Object.defineProperty(
													e,
													this.expando,
													{
														value: t,
														configurable: !0,
													}
											  ))),
								t
							);
						},
						set: function (e, t, n) {
							var o = this.cache(e),
								a;
							if ("string" == typeof t) o[x(t)] = n;
							else for (a in t) o[x(a)] = t[a];
							return o;
						},
						get: function (e, t) {
							return void 0 === t
								? this.cache(e)
								: e[this.expando] && e[this.expando][x(t)];
						},
						access: function (e, t, n) {
							return void 0 === t ||
								(t && "string" == typeof t && void 0 === n)
								? this.get(e, t)
								: (this.set(e, t, n), void 0 === n ? t : n);
						},
						remove: function (e, t) {
							var n = e[this.expando],
								o;
							if (void 0 !== n) {
								if (void 0 !== t)
									for (
										Array.isArray(t)
											? (t = t.map(x))
											: ((t = x(t)),
											  (t =
													(t in n)
														? [t]
														: t.match(qe) || [])),
											o = t.length;
										o--;

									)
										delete n[t[o]];
								(void 0 === t || Ae.isEmptyObject(n)) &&
									(e.nodeType
										? (e[this.expando] = void 0)
										: delete e[this.expando]);
							}
						},
						hasData: function (e) {
							var t = e[this.expando];
							return void 0 !== t && !Ae.isEmptyObject(t);
						},
					});
				var Ve = new k(),
					Ze = new k(),
					Ke = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
					Je = /[A-Z]/g;
				Ae.extend({
					hasData: function (e) {
						return Ze.hasData(e) || Ve.hasData(e);
					},
					data: function (e, t, n) {
						return Ze.access(e, t, n);
					},
					removeData: function (e, t) {
						Ze.remove(e, t);
					},
					_data: function (e, t, n) {
						return Ve.access(e, t, n);
					},
					_removeData: function (e, t) {
						Ve.remove(e, t);
					},
				}),
					Ae.fn.extend({
						data: function (e, t) {
							var n = this[0],
								o = n && n.attributes,
								a,
								i,
								s;
							if (void 0 === e) {
								if (
									this.length &&
									((s = Ze.get(n)),
									1 === n.nodeType &&
										!Ve.get(n, "hasDataAttrs"))
								) {
									for (a = o.length; a--; )
										o[a] &&
											((i = o[a].name),
											0 === i.indexOf("data-") &&
												((i = x(i.slice(5))),
												I(n, i, s[i])));
									Ve.set(n, "hasDataAttrs", !0);
								}
								return s;
							}
							return "object" == typeof e
								? this.each(function () {
										Ze.set(this, e);
								  })
								: Ue(
										this,
										function (t) {
											var o;
											return n && void 0 === t
												? ((o = Ze.get(n, e)),
												  void 0 !== o)
													? o
													: ((o = I(n, e)),
													  void 0 === o ? void 0 : o)
												: void this.each(function () {
														Ze.set(this, e, t);
												  });
										},
										null,
										t,
										1 < arguments.length,
										null,
										!0
								  );
						},
						removeData: function (e) {
							return this.each(function () {
								Ze.remove(this, e);
							});
						},
					}),
					Ae.extend({
						queue: function (e, t, n) {
							var o;
							if (e)
								return (
									(t = (t || "fx") + "queue"),
									(o = Ve.get(e, t)),
									n &&
										(!o || Array.isArray(n)
											? (o = Ve.access(
													e,
													t,
													Ae.makeArray(n)
											  ))
											: o.push(n)),
									o || []
								);
						},
						dequeue: function (e, t) {
							t = t || "fx";
							var n = Ae.queue(e, t),
								o = n.length,
								a = n.shift(),
								i = Ae._queueHooks(e, t);
							"inprogress" === a && ((a = n.shift()), o--),
								a &&
									("fx" === t && n.unshift("inprogress"),
									delete i.stop,
									a.call(
										e,
										function () {
											Ae.dequeue(e, t);
										},
										i
									)),
								!o && i && i.empty.fire();
						},
						_queueHooks: function (e, t) {
							var n = t + "queueHooks";
							return (
								Ve.get(e, n) ||
								Ve.access(e, n, {
									empty: Ae.Callbacks("once memory").add(
										function () {
											Ve.remove(e, [t + "queue", n]);
										}
									),
								})
							);
						},
					}),
					Ae.fn.extend({
						queue: function (e, t) {
							var n = 2;
							return (
								"string" != typeof e &&
									((t = e), (e = "fx"), n--),
								arguments.length < n
									? Ae.queue(this[0], e)
									: void 0 === t
									? this
									: this.each(function () {
											var n = Ae.queue(this, e, t);
											Ae._queueHooks(this, e),
												"fx" === e &&
													"inprogress" !== n[0] &&
													Ae.dequeue(this, e);
									  })
							);
						},
						dequeue: function (e) {
							return this.each(function () {
								Ae.dequeue(this, e);
							});
						},
						clearQueue: function (e) {
							return this.queue(e || "fx", []);
						},
						promise: function (e, t) {
							var n = 1,
								o = Ae.Deferred(),
								a = this,
								s = this.length,
								i = function () {
									--n || o.resolveWith(a, [a]);
								},
								r;
							for (
								"string" != typeof e && ((t = e), (e = void 0)),
									e = e || "fx";
								s--;

							)
								(r = Ve.get(a[s], e + "queueHooks")),
									r && r.empty && (n++, r.empty.add(i));
							return i(), o.promise(t);
						},
					});
				var Qe = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
					et = new RegExp("^(?:([+-])=|)(" + Qe + ")([a-z%]*)$", "i"),
					tt = ["Top", "Right", "Bottom", "Left"],
					nt = ge.documentElement,
					ot = function (e) {
						return Ae.contains(e.ownerDocument, e);
					},
					at = { composed: !0 };
				nt.getRootNode &&
					(ot = function (e) {
						return (
							Ae.contains(e.ownerDocument, e) ||
							e.getRootNode(at) === e.ownerDocument
						);
					});
				var it = function (e, t) {
						return (
							(e = t || e),
							"none" === e.style.display ||
								("" === e.style.display &&
									ot(e) &&
									"none" === Ae.css(e, "display"))
						);
					},
					st = function (e, t, n, o) {
						var a = {},
							i,
							s;
						for (s in t) (a[s] = e.style[s]), (e.style[s] = t[s]);
						for (s in ((i = n.apply(e, o || [])), t))
							e.style[s] = a[s];
						return i;
					},
					rt = {};
				Ae.fn.extend({
					show: function () {
						return S(this, !0);
					},
					hide: function () {
						return S(this);
					},
					toggle: function (e) {
						return "boolean" == typeof e
							? e
								? this.show()
								: this.hide()
							: this.each(function () {
									it(this)
										? Ae(this).show()
										: Ae(this).hide();
							  });
					},
				});
				var lt = /^(?:checkbox|radio)$/i,
					dt = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
					ct = /^$|^module$|\/(?:java|ecma)script/i,
					pt = {
						option: [
							1,
							"<select multiple='multiple'>",
							"</select>",
						],
						thead: [1, "<table>", "</table>"],
						col: [2, "<table><colgroup>", "</colgroup></table>"],
						tr: [2, "<table><tbody>", "</tbody></table>"],
						td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
						_default: [0, "", ""],
					};
				(pt.optgroup = pt.option),
					(pt.tbody = pt.tfoot = pt.colgroup = pt.caption = pt.thead),
					(pt.th = pt.td);
				var mt = /<|&#?\w+;/;
				(function () {
					var e = ge.createDocumentFragment(),
						t = e.appendChild(ge.createElement("div")),
						n = ge.createElement("input");
					n.setAttribute("type", "radio"),
						n.setAttribute("checked", "checked"),
						n.setAttribute("name", "t"),
						t.appendChild(n),
						(Ce.checkClone = t
							.cloneNode(!0)
							.cloneNode(!0).lastChild.checked),
						(t.innerHTML = "<textarea>x</textarea>"),
						(Ce.noCloneChecked = !!t.cloneNode(!0).lastChild
							.defaultValue);
				})();
				var ut = /^key/,
					gt = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
					ht = /^([^.]*)(?:\.(.+)|)/;
				(Ae.event = {
					global: {},
					add: function (n, e, o, a, i) {
						var s = Ve.get(n),
							r,
							l,
							d,
							c,
							p,
							t,
							m,
							u,
							g,
							h,
							f;
						if (s)
							for (
								o.handler &&
									((r = o),
									(o = r.handler),
									(i = r.selector)),
									i && Ae.find.matchesSelector(nt, i),
									o.guid || (o.guid = Ae.guid++),
									(c = s.events) || (c = s.events = {}),
									(l = s.handle) ||
										(l = s.handle =
											function (t) {
												return "undefined" !=
													typeof Ae &&
													Ae.event.triggered !==
														t.type
													? Ae.event.dispatch.apply(
															n,
															arguments
													  )
													: void 0;
											}),
									e = (e || "").match(qe) || [""],
									p = e.length;
								p--;

							)
								((d = ht.exec(e[p]) || []),
								(g = f = d[1]),
								(h = (d[2] || "").split(".").sort()),
								!!g) &&
									((m = Ae.event.special[g] || {}),
									(g =
										(i ? m.delegateType : m.bindType) || g),
									(m = Ae.event.special[g] || {}),
									(t = Ae.extend(
										{
											type: g,
											origType: f,
											data: a,
											handler: o,
											guid: o.guid,
											selector: i,
											needsContext:
												i &&
												Ae.expr.match.needsContext.test(
													i
												),
											namespace: h.join("."),
										},
										r
									)),
									(u = c[g]) ||
										((u = c[g] = []),
										(u.delegateCount = 0),
										(!m.setup ||
											!1 === m.setup.call(n, a, h, l)) &&
											n.addEventListener &&
											n.addEventListener(g, l)),
									m.add &&
										(m.add.call(n, t),
										!t.handler.guid &&
											(t.handler.guid = o.guid)),
									i
										? u.splice(u.delegateCount++, 0, t)
										: u.push(t),
									(Ae.event.global[g] = !0));
					},
					remove: function (e, n, o, a, i) {
						var s = Ve.hasData(e) && Ve.get(e),
							r,
							l,
							d,
							c,
							p,
							t,
							m,
							u,
							g,
							h,
							f;
						if (s && (c = s.events)) {
							for (
								n = (n || "").match(qe) || [""], p = n.length;
								p--;

							) {
								if (
									((d = ht.exec(n[p]) || []),
									(g = f = d[1]),
									(h = (d[2] || "").split(".").sort()),
									!g)
								) {
									for (g in c)
										Ae.event.remove(e, g + n[p], o, a, !0);
									continue;
								}
								for (
									m = Ae.event.special[g] || {},
										g =
											(a ? m.delegateType : m.bindType) ||
											g,
										u = c[g] || [],
										d =
											d[2] &&
											new RegExp(
												"(^|\\.)" +
													h.join("\\.(?:.*\\.|)") +
													"(\\.|$)"
											),
										l = r = u.length;
									r--;

								)
									(t = u[r]),
										(i || f === t.origType) &&
											(!o || o.guid === t.guid) &&
											(!d || d.test(t.namespace)) &&
											(!a ||
												a === t.selector ||
												("**" === a && t.selector)) &&
											(u.splice(r, 1),
											t.selector && u.delegateCount--,
											m.remove && m.remove.call(e, t));
								l &&
									!u.length &&
									((!m.teardown ||
										!1 ===
											m.teardown.call(e, h, s.handle)) &&
										Ae.removeEvent(e, g, s.handle),
									delete c[g]);
							}
							Ae.isEmptyObject(c) &&
								Ve.remove(e, "handle events");
						}
					},
					dispatch: function (e) {
						var t = Ae.event.fix(e),
							n = Array(arguments.length),
							o = (Ve.get(this, "events") || {})[t.type] || [],
							a = Ae.event.special[t.type] || {},
							s,
							i,
							r,
							l,
							d,
							c;
						for (n[0] = t, s = 1; s < arguments.length; s++)
							n[s] = arguments[s];
						if (
							((t.delegateTarget = this),
							!(
								a.preDispatch &&
								!1 === a.preDispatch.call(this, t)
							))
						) {
							for (
								c = Ae.event.handlers.call(this, t, o), s = 0;
								(l = c[s++]) && !t.isPropagationStopped();

							)
								for (
									t.currentTarget = l.elem, i = 0;
									(d = l.handlers[i++]) &&
									!t.isImmediatePropagationStopped();

								)
									(!t.rnamespace ||
										!1 === d.namespace ||
										t.rnamespace.test(d.namespace)) &&
										((t.handleObj = d),
										(t.data = d.data),
										(r = (
											(Ae.event.special[d.origType] || {})
												.handle || d.handler
										).apply(l.elem, n)),
										void 0 !== r &&
											!1 === (t.result = r) &&
											(t.preventDefault(),
											t.stopPropagation()));
							return (
								a.postDispatch && a.postDispatch.call(this, t),
								t.result
							);
						}
					},
					handlers: function (e, t) {
						var n = [],
							o = t.delegateCount,
							a = e.target,
							s,
							i,
							r,
							l,
							d;
						if (
							o &&
							a.nodeType &&
							!("click" === e.type && 1 <= e.button)
						)
							for (; a !== this; a = a.parentNode || this)
								if (
									1 === a.nodeType &&
									("click" !== e.type || !0 !== a.disabled)
								) {
									for (l = [], d = {}, s = 0; s < o; s++)
										(i = t[s]),
											(r = i.selector + " "),
											void 0 === d[r] &&
												(d[r] = i.needsContext
													? -1 < Ae(r, this).index(a)
													: Ae.find(r, this, null, [
															a,
													  ]).length),
											d[r] && l.push(i);
									l.length &&
										n.push({ elem: a, handlers: l });
								}
						return (
							(a = this),
							o < t.length &&
								n.push({ elem: a, handlers: t.slice(o) }),
							n
						);
					},
					addProp: function (e, t) {
						Object.defineProperty(Ae.Event.prototype, e, {
							enumerable: !0,
							configurable: !0,
							get: Te(t)
								? function () {
										if (this.originalEvent)
											return t(this.originalEvent);
								  }
								: function () {
										if (this.originalEvent)
											return this.originalEvent[e];
								  },
							set: function (t) {
								Object.defineProperty(this, e, {
									enumerable: !0,
									configurable: !0,
									writable: !0,
									value: t,
								});
							},
						});
					},
					fix: function (e) {
						return e[Ae.expando] ? e : new Ae.Event(e);
					},
					special: {
						load: { noBubble: !0 },
						click: {
							setup: function (e) {
								var t = this || e;
								return (
									lt.test(t.type) &&
										t.click &&
										m(t, "input") &&
										O(t, "click", j),
									!1
								);
							},
							trigger: function (e) {
								var t = this || e;
								return (
									lt.test(t.type) &&
										t.click &&
										m(t, "input") &&
										O(t, "click"),
									!0
								);
							},
							_default: function (e) {
								var t = e.target;
								return (
									(lt.test(t.type) &&
										t.click &&
										m(t, "input") &&
										Ve.get(t, "click")) ||
									m(t, "a")
								);
							},
						},
						beforeunload: {
							postDispatch: function (e) {
								void 0 !== e.result &&
									e.originalEvent &&
									(e.originalEvent.returnValue = e.result);
							},
						},
					},
				}),
					(Ae.removeEvent = function (e, t, n) {
						e.removeEventListener && e.removeEventListener(t, n);
					}),
					(Ae.Event = function (e, t) {
						return this instanceof Ae.Event
							? void (e && e.type
									? ((this.originalEvent = e),
									  (this.type = e.type),
									  (this.isDefaultPrevented =
											e.defaultPrevented ||
											(void 0 === e.defaultPrevented &&
												!1 === e.returnValue)
												? j
												: P),
									  (this.target =
											e.target && 3 === e.target.nodeType
												? e.target.parentNode
												: e.target),
									  (this.currentTarget = e.currentTarget),
									  (this.relatedTarget = e.relatedTarget))
									: (this.type = e),
							  t && Ae.extend(this, t),
							  (this.timeStamp =
									(e && e.timeStamp) || Date.now()),
							  (this[Ae.expando] = !0))
							: new Ae.Event(e, t);
					}),
					(Ae.Event.prototype = {
						constructor: Ae.Event,
						isDefaultPrevented: P,
						isPropagationStopped: P,
						isImmediatePropagationStopped: P,
						isSimulated: !1,
						preventDefault: function () {
							var t = this.originalEvent;
							(this.isDefaultPrevented = j),
								t && !this.isSimulated && t.preventDefault();
						},
						stopPropagation: function () {
							var t = this.originalEvent;
							(this.isPropagationStopped = j),
								t && !this.isSimulated && t.stopPropagation();
						},
						stopImmediatePropagation: function () {
							var t = this.originalEvent;
							(this.isImmediatePropagationStopped = j),
								t &&
									!this.isSimulated &&
									t.stopImmediatePropagation(),
								this.stopPropagation();
						},
					}),
					Ae.each(
						{
							altKey: !0,
							bubbles: !0,
							cancelable: !0,
							changedTouches: !0,
							ctrlKey: !0,
							detail: !0,
							eventPhase: !0,
							metaKey: !0,
							pageX: !0,
							pageY: !0,
							shiftKey: !0,
							view: !0,
							char: !0,
							code: !0,
							charCode: !0,
							key: !0,
							keyCode: !0,
							button: !0,
							buttons: !0,
							clientX: !0,
							clientY: !0,
							offsetX: !0,
							offsetY: !0,
							pointerId: !0,
							pointerType: !0,
							screenX: !0,
							screenY: !0,
							targetTouches: !0,
							toElement: !0,
							touches: !0,
							which: function (e) {
								var t = e.button;
								return null == e.which && ut.test(e.type)
									? null == e.charCode
										? e.keyCode
										: e.charCode
									: !e.which &&
									  void 0 !== t &&
									  gt.test(e.type)
									? 1 & t
										? 1
										: 2 & t
										? 3
										: 4 & t
										? 2
										: 0
									: e.which;
							},
						},
						Ae.event.addProp
					),
					Ae.each(
						{ focus: "focusin", blur: "focusout" },
						function (e, t) {
							Ae.event.special[e] = {
								setup: function () {
									return O(this, e, N), !1;
								},
								trigger: function () {
									return O(this, e), !0;
								},
								delegateType: t,
							};
						}
					),
					Ae.each(
						{
							mouseenter: "mouseover",
							mouseleave: "mouseout",
							pointerenter: "pointerover",
							pointerleave: "pointerout",
						},
						function (e, t) {
							Ae.event.special[e] = {
								delegateType: t,
								bindType: t,
								handle: function (e) {
									var n = this,
										o = e.relatedTarget,
										a = e.handleObj,
										i;
									return (
										(o && (o === n || Ae.contains(n, o))) ||
											((e.type = a.origType),
											(i = a.handler.apply(
												this,
												arguments
											)),
											(e.type = t)),
										i
									);
								},
							};
						}
					),
					Ae.fn.extend({
						on: function (e, t, n, o) {
							return M(this, e, t, n, o);
						},
						one: function (e, t, n, o) {
							return M(this, e, t, n, o, 1);
						},
						off: function (e, t, n) {
							var o, a;
							if (e && e.preventDefault && e.handleObj)
								return (
									(o = e.handleObj),
									Ae(e.delegateTarget).off(
										o.namespace
											? o.origType + "." + o.namespace
											: o.origType,
										o.selector,
										o.handler
									),
									this
								);
							if ("object" == typeof e) {
								for (a in e) this.off(a, t, e[a]);
								return this;
							}
							return (
								(!1 === t || "function" == typeof t) &&
									((n = t), (t = void 0)),
								!1 === n && (n = P),
								this.each(function () {
									Ae.event.remove(this, e, n, t);
								})
							);
						},
					});
				var ft =
						/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
					_t = /<script|<style|<link/i,
					yt = /checked\s*(?:[^=]|=\s*.checked.)/i,
					bt = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
				Ae.extend({
					htmlPrefilter: function (e) {
						return e.replace(ft, "<$1></$2>");
					},
					clone: function (e, t, n) {
						var o = e.cloneNode(!0),
							a = ot(e),
							s,
							i,
							r,
							l;
						if (
							!Ce.noCloneChecked &&
							(1 === e.nodeType || 11 === e.nodeType) &&
							!Ae.isXMLDoc(e)
						)
							for (
								l = E(o), r = E(e), ((s = 0), (i = r.length));
								s < i;
								s++
							)
								F(r[s], l[s]);
						if (t)
							if (n)
								for (
									r = r || E(e),
										l = l || E(o),
										((s = 0), (i = r.length));
									s < i;
									s++
								)
									H(r[s], l[s]);
							else H(e, o);
						return (
							(l = E(o, "script")),
							0 < l.length && D(l, !a && E(e, "script")),
							o
						);
					},
					cleanData: function (e) {
						for (
							var t = Ae.event.special, n = 0, o, a, i;
							void 0 !== (a = e[n]);
							n++
						)
							if (Ye(a)) {
								if ((o = a[Ve.expando])) {
									if (o.events)
										for (i in o.events)
											t[i]
												? Ae.event.remove(a, i)
												: Ae.removeEvent(
														a,
														i,
														o.handle
												  );
									a[Ve.expando] = void 0;
								}
								a[Ze.expando] && (a[Ze.expando] = void 0);
							}
					},
				}),
					Ae.fn.extend({
						detach: function (e) {
							return W(this, e, !0);
						},
						remove: function (e) {
							return W(this, e);
						},
						text: function (e) {
							return Ue(
								this,
								function (e) {
									return void 0 === e
										? Ae.text(this)
										: this.empty().each(function () {
												(1 === this.nodeType ||
													11 === this.nodeType ||
													9 === this.nodeType) &&
													(this.textContent = e);
										  });
								},
								null,
								e,
								arguments.length
							);
						},
						append: function () {
							return q(this, arguments, function (e) {
								if (
									1 === this.nodeType ||
									11 === this.nodeType ||
									9 === this.nodeType
								) {
									var t = L(this, e);
									t.appendChild(e);
								}
							});
						},
						prepend: function () {
							return q(this, arguments, function (e) {
								if (
									1 === this.nodeType ||
									11 === this.nodeType ||
									9 === this.nodeType
								) {
									var t = L(this, e);
									t.insertBefore(e, t.firstChild);
								}
							});
						},
						before: function () {
							return q(this, arguments, function (e) {
								this.parentNode &&
									this.parentNode.insertBefore(e, this);
							});
						},
						after: function () {
							return q(this, arguments, function (e) {
								this.parentNode &&
									this.parentNode.insertBefore(
										e,
										this.nextSibling
									);
							});
						},
						empty: function () {
							for (var e = 0, t; null != (t = this[e]); e++)
								1 === t.nodeType &&
									(Ae.cleanData(E(t, !1)),
									(t.textContent = ""));
							return this;
						},
						clone: function (e, t) {
							return (
								(e = null != e && e),
								(t = null == t ? e : t),
								this.map(function () {
									return Ae.clone(this, e, t);
								})
							);
						},
						html: function (e) {
							return Ue(
								this,
								function (e) {
									var t = this[0] || {},
										n = 0,
										o = this.length;
									if (void 0 === e && 1 === t.nodeType)
										return t.innerHTML;
									if (
										"string" == typeof e &&
										!_t.test(e) &&
										!pt[
											(dt.exec(e) || [
												"",
												"",
											])[1].toLowerCase()
										]
									) {
										e = Ae.htmlPrefilter(e);
										try {
											for (; n < o; n++)
												(t = this[n] || {}),
													1 === t.nodeType &&
														(Ae.cleanData(E(t, !1)),
														(t.innerHTML = e));
											t = 0;
										} catch (t) {}
									}
									t && this.empty().append(e);
								},
								null,
								e,
								arguments.length
							);
						},
						replaceWith: function () {
							var e = [];
							return q(
								this,
								arguments,
								function (t) {
									var n = this.parentNode;
									0 > Ae.inArray(this, e) &&
										(Ae.cleanData(E(this)),
										n && n.replaceChild(t, this));
								},
								e
							);
						},
					}),
					Ae.each(
						{
							appendTo: "append",
							prependTo: "prepend",
							insertBefore: "before",
							insertAfter: "after",
							replaceAll: "replaceWith",
						},
						function (e, t) {
							Ae.fn[e] = function (e) {
								for (
									var n = [],
										o = Ae(e),
										a = o.length - 1,
										s = 0,
										i;
									s <= a;
									s++
								)
									(i = s == a ? this : this.clone(!0)),
										Ae(o[s])[t](i),
										ye.apply(n, i.get());
								return this.pushStack(n);
							};
						}
					);
				var vt = new RegExp("^(" + Qe + ")(?!px)[a-z%]+$", "i"),
					xt = function (e) {
						var t = e.ownerDocument.defaultView;
						return (
							(t && t.opener) || (t = r), t.getComputedStyle(e)
						);
					},
					kt = new RegExp(tt.join("|"), "i");
				(function () {
					function e() {
						if (o) {
							(n.style.cssText =
								"position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
								(o.style.cssText =
									"position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
								nt.appendChild(n).appendChild(o);
							var e = r.getComputedStyle(o);
							(i = "1%" !== e.top),
								(c = 12 === t(e.marginLeft)),
								(o.style.right = "60%"),
								(d = 36 === t(e.right)),
								(s = 36 === t(e.width)),
								(o.style.position = "absolute"),
								(l = 12 === t(o.offsetWidth / 3)),
								nt.removeChild(n),
								(o = null);
						}
					}
					function t(e) {
						return a(parseFloat(e));
					}
					var n = ge.createElement("div"),
						o = ge.createElement("div"),
						i,
						s,
						l,
						d,
						c;
					o.style &&
						((o.style.backgroundClip = "content-box"),
						(o.cloneNode(!0).style.backgroundClip = ""),
						(Ce.clearCloneStyle =
							"content-box" === o.style.backgroundClip),
						Ae.extend(Ce, {
							boxSizingReliable: function () {
								return e(), s;
							},
							pixelBoxStyles: function () {
								return e(), d;
							},
							pixelPosition: function () {
								return e(), i;
							},
							reliableMarginLeft: function () {
								return e(), c;
							},
							scrollboxSize: function () {
								return e(), l;
							},
						}));
				})();
				var wt = ["Webkit", "Moz", "ms"],
					It = ge.createElement("div").style,
					Ct = {},
					Tt = /^(none|table(?!-c[ea]).+)/,
					St = /^--/,
					Et = {
						position: "absolute",
						visibility: "hidden",
						display: "block",
					},
					Dt = { letterSpacing: "0", fontWeight: "400" };
				Ae.extend({
					cssHooks: {
						opacity: {
							get: function (e, t) {
								if (t) {
									var n = B(e, "opacity");
									return "" === n ? "1" : n;
								}
							},
						},
					},
					cssNumber: {
						animationIterationCount: !0,
						columnCount: !0,
						fillOpacity: !0,
						flexGrow: !0,
						flexShrink: !0,
						fontWeight: !0,
						gridArea: !0,
						gridColumn: !0,
						gridColumnEnd: !0,
						gridColumnStart: !0,
						gridRow: !0,
						gridRowEnd: !0,
						gridRowStart: !0,
						lineHeight: !0,
						opacity: !0,
						order: !0,
						orphans: !0,
						widows: !0,
						zIndex: !0,
						zoom: !0,
					},
					cssProps: {},
					style: function (e, t, n, o) {
						if (
							e &&
							3 !== e.nodeType &&
							8 !== e.nodeType &&
							e.style
						) {
							var a = x(t),
								i = St.test(t),
								s = e.style,
								r,
								l,
								d;
							if (
								(i || (t = X(a)),
								(d = Ae.cssHooks[t] || Ae.cssHooks[a]),
								void 0 !== n)
							) {
								if (
									((l = typeof n),
									"string" === l &&
										(r = et.exec(n)) &&
										r[1] &&
										((n = C(e, t, r)), (l = "number")),
									null == n || n !== n)
								)
									return;
								"number" !== l ||
									i ||
									(n +=
										(r && r[3]) ||
										(Ae.cssNumber[a] ? "" : "px")),
									Ce.clearCloneStyle ||
										"" !== n ||
										0 !== t.indexOf("background") ||
										(s[t] = "inherit"),
									(d &&
										"set" in d &&
										void 0 === (n = d.set(e, n, o))) ||
										(i ? s.setProperty(t, n) : (s[t] = n));
							} else
								return d &&
									"get" in d &&
									void 0 !== (r = d.get(e, !1, o))
									? r
									: s[t];
						}
					},
					css: function (e, t, n, o) {
						var a = x(t),
							i = St.test(t),
							s,
							r,
							l;
						return (
							i || (t = X(a)),
							(l = Ae.cssHooks[t] || Ae.cssHooks[a]),
							l && "get" in l && (s = l.get(e, !0, n)),
							void 0 === s && (s = B(e, t, o)),
							"normal" === s && t in Dt && (s = Dt[t]),
							"" === n || n
								? ((r = parseFloat(s)),
								  !0 === n || isFinite(r) ? r || 0 : s)
								: s
						);
					},
				}),
					Ae.each(["height", "width"], function (e, t) {
						Ae.cssHooks[t] = {
							get: function (e, n, o) {
								if (n)
									return !Tt.test(Ae.css(e, "display")) ||
										(e.getClientRects().length &&
											e.getBoundingClientRect().width)
										? Z(e, t, o)
										: st(e, Et, function () {
												return Z(e, t, o);
										  });
							},
							set: function (e, o, a) {
								var i = xt(e),
									s =
										!Ce.scrollboxSize() &&
										"absolute" === i.position,
									r =
										(s || a) &&
										"border-box" ===
											Ae.css(e, "boxSizing", !1, i),
									l = a ? V(e, t, a, r, i) : 0,
									d;
								return (
									r &&
										s &&
										(l -= n(
											e[
												"offset" +
													t[0].toUpperCase() +
													t.slice(1)
											] -
												parseFloat(i[t]) -
												V(e, t, "border", !1, i) -
												0.5
										)),
									l &&
										(d = et.exec(o)) &&
										"px" !== (d[3] || "px") &&
										((e.style[t] = o), (o = Ae.css(e, t))),
									Y(e, o, l)
								);
							},
						};
					}),
					(Ae.cssHooks.marginLeft = U(
						Ce.reliableMarginLeft,
						function (e, t) {
							if (t)
								return (
									(parseFloat(B(e, "marginLeft")) ||
										e.getBoundingClientRect().left -
											st(
												e,
												{ marginLeft: 0 },
												function () {
													return e.getBoundingClientRect()
														.left;
												}
											)) + "px"
								);
						}
					)),
					Ae.each(
						{ margin: "", padding: "", border: "Width" },
						function (e, t) {
							(Ae.cssHooks[e + t] = {
								expand: function (n) {
									for (
										var o = 0,
											a = {},
											i =
												"string" == typeof n
													? n.split(" ")
													: [n];
										4 > o;
										o++
									)
										a[e + tt[o] + t] =
											i[o] || i[o - 2] || i[0];
									return a;
								},
							}),
								"margin" !== e && (Ae.cssHooks[e + t].set = Y);
						}
					),
					Ae.fn.extend({
						css: function (e, t) {
							return Ue(
								this,
								function (e, t, n) {
									var o = {},
										a = 0,
										i,
										s;
									if (Array.isArray(t)) {
										for (
											i = xt(e), s = t.length;
											a < s;
											a++
										)
											o[t[a]] = Ae.css(e, t[a], !1, i);
										return o;
									}
									return void 0 === n
										? Ae.css(e, t)
										: Ae.style(e, t, n);
								},
								e,
								t,
								1 < arguments.length
							);
						},
					}),
					(Ae.Tween = K),
					(K.prototype = {
						constructor: K,
						init: function (e, t, n, o, a, i) {
							(this.elem = e),
								(this.prop = n),
								(this.easing = a || Ae.easing._default),
								(this.options = t),
								(this.start = this.now = this.cur()),
								(this.end = o),
								(this.unit =
									i || (Ae.cssNumber[n] ? "" : "px"));
						},
						cur: function () {
							var e = K.propHooks[this.prop];
							return e && e.get
								? e.get(this)
								: K.propHooks._default.get(this);
						},
						run: function (e) {
							var t = K.propHooks[this.prop],
								n;
							return (
								(this.pos = this.options.duration
									? (n = Ae.easing[this.easing](
											e,
											this.options.duration * e,
											0,
											1,
											this.options.duration
									  ))
									: (n = e)),
								(this.now =
									(this.end - this.start) * n + this.start),
								this.options.step &&
									this.options.step.call(
										this.elem,
										this.now,
										this
									),
								t && t.set
									? t.set(this)
									: K.propHooks._default.set(this),
								this
							);
						},
					}),
					(K.prototype.init.prototype = K.prototype),
					(K.propHooks = {
						_default: {
							get: function (e) {
								var t;
								return 1 !== e.elem.nodeType ||
									(null != e.elem[e.prop] &&
										null == e.elem.style[e.prop])
									? e.elem[e.prop]
									: ((t = Ae.css(e.elem, e.prop, "")),
									  t && "auto" !== t ? t : 0);
							},
							set: function (e) {
								Ae.fx.step[e.prop]
									? Ae.fx.step[e.prop](e)
									: 1 === e.elem.nodeType &&
									  (Ae.cssHooks[e.prop] ||
											null != e.elem.style[X(e.prop)])
									? Ae.style(e.elem, e.prop, e.now + e.unit)
									: (e.elem[e.prop] = e.now);
							},
						},
					}),
					(K.propHooks.scrollTop = K.propHooks.scrollLeft =
						{
							set: function (e) {
								e.elem.nodeType &&
									e.elem.parentNode &&
									(e.elem[e.prop] = e.now);
							},
						}),
					(Ae.easing = {
						linear: function (e) {
							return e;
						},
						swing: function (e) {
							return 0.5 - Math.cos(e * Math.PI) / 2;
						},
						_default: "swing",
					}),
					(Ae.fx = K.prototype.init),
					(Ae.fx.step = {});
				var At = /^(?:toggle|show|hide)$/,
					jt = /queueHooks$/,
					Pt,
					Nt;
				(Ae.Animation = Ae.extend(oe, {
					tweeners: {
						"*": [
							function (e, t) {
								var n = this.createTween(e, t);
								return C(n.elem, e, et.exec(t), n), n;
							},
						],
					},
					tweener: function (e, t) {
						Te(e) ? ((t = e), (e = ["*"])) : (e = e.match(qe));
						for (var n = 0, o = e.length, a; n < o; n++)
							(a = e[n]),
								(oe.tweeners[a] = oe.tweeners[a] || []),
								oe.tweeners[a].unshift(t);
					},
					prefilters: [
						function (e, t, n) {
							var o = this,
								a = {},
								i = e.style,
								s = e.nodeType && it(e),
								r = Ve.get(e, "fxshow"),
								l,
								d,
								c,
								p,
								m,
								u,
								g,
								h;
							for (l in (n.queue ||
								((p = Ae._queueHooks(e, "fx")),
								null == p.unqueued &&
									((p.unqueued = 0),
									(m = p.empty.fire),
									(p.empty.fire = function () {
										p.unqueued || m();
									})),
								p.unqueued++,
								o.always(function () {
									o.always(function () {
										p.unqueued--,
											Ae.queue(e, "fx").length ||
												p.empty.fire();
									});
								})),
							t))
								if (((d = t[l]), At.test(d))) {
									if (
										(delete t[l],
										(c = c || "toggle" === d),
										d === (s ? "hide" : "show"))
									)
										if (
											"show" === d &&
											r &&
											void 0 !== r[l]
										)
											s = !0;
										else continue;
									a[l] = (r && r[l]) || Ae.style(e, l);
								}
							if (
								((u = !Ae.isEmptyObject(t)),
								u || !Ae.isEmptyObject(a))
							)
								for (l in (("width" in t || "height" in t) &&
									1 === e.nodeType &&
									((n.overflow = [
										i.overflow,
										i.overflowX,
										i.overflowY,
									]),
									(g = r && r.display),
									null == g && (g = Ve.get(e, "display")),
									(h = Ae.css(e, "display")),
									"none" === h &&
										(g
											? (h = g)
											: (S([e], !0),
											  (g = e.style.display || g),
											  (h = Ae.css(e, "display")),
											  S([e]))),
									("inline" === h ||
										("inline-block" === h && null != g)) &&
										"none" === Ae.css(e, "float") &&
										(!u &&
											(o.done(function () {
												i.display = g;
											}),
											null == g &&
												((h = i.display),
												(g = "none" === h ? "" : h))),
										(i.display = "inline-block"))),
								n.overflow &&
									((i.overflow = "hidden"),
									o.always(function () {
										(i.overflow = n.overflow[0]),
											(i.overflowX = n.overflow[1]),
											(i.overflowY = n.overflow[2]);
									})),
								(u = !1),
								a))
									u ||
										(r
											? "hidden" in r && (s = r.hidden)
											: (r = Ve.access(e, "fxshow", {
													display: g,
											  })),
										c && (r.hidden = !s),
										s && S([e], !0),
										o.done(function () {
											for (l in (s || S([e]),
											Ve.remove(e, "fxshow"),
											a))
												Ae.style(e, l, a[l]);
										})),
										(u = te(s ? r[l] : 0, l, o)),
										l in r ||
											((r[l] = u.start),
											s &&
												((u.end = u.start),
												(u.start = 0)));
						},
					],
					prefilter: function (e, t) {
						t ? oe.prefilters.unshift(e) : oe.prefilters.push(e);
					},
				})),
					(Ae.speed = function (e, t, n) {
						var o =
							e && "object" == typeof e
								? Ae.extend({}, e)
								: {
										complete:
											n || (!n && t) || (Te(e) && e),
										duration: e,
										easing: (n && t) || (t && !Te(t) && t),
								  };
						return (
							Ae.fx.off
								? (o.duration = 0)
								: "number" != typeof o.duration &&
								  (o.duration in Ae.fx.speeds
										? (o.duration =
												Ae.fx.speeds[o.duration])
										: (o.duration = Ae.fx.speeds._default)),
							(null == o.queue || !0 === o.queue) &&
								(o.queue = "fx"),
							(o.old = o.complete),
							(o.complete = function () {
								Te(o.old) && o.old.call(this),
									o.queue && Ae.dequeue(this, o.queue);
							}),
							o
						);
					}),
					Ae.fn.extend({
						fadeTo: function (e, t, n, o) {
							return this.filter(it)
								.css("opacity", 0)
								.show()
								.end()
								.animate({ opacity: t }, e, n, o);
						},
						animate: function (e, t, n, o) {
							var a = Ae.isEmptyObject(e),
								i = Ae.speed(t, n, o),
								s = function () {
									var t = oe(this, Ae.extend({}, e), i);
									(a || Ve.get(this, "finish")) && t.stop(!0);
								};
							return (
								(s.finish = s),
								a || !1 === i.queue
									? this.each(s)
									: this.queue(i.queue, s)
							);
						},
						stop: function (e, t, n) {
							var o = function (e) {
								var t = e.stop;
								delete e.stop, t(n);
							};
							return (
								"string" != typeof e &&
									((n = t), (t = e), (e = void 0)),
								t && !1 !== e && this.queue(e || "fx", []),
								this.each(function () {
									var t = !0,
										a = null != e && e + "queueHooks",
										i = Ae.timers,
										s = Ve.get(this);
									if (a) s[a] && s[a].stop && o(s[a]);
									else
										for (a in s)
											s[a] &&
												s[a].stop &&
												jt.test(a) &&
												o(s[a]);
									for (a = i.length; a--; )
										i[a].elem === this &&
											(null == e || i[a].queue === e) &&
											(i[a].anim.stop(n),
											(t = !1),
											i.splice(a, 1));
									(t || !n) && Ae.dequeue(this, e);
								})
							);
						},
						finish: function (e) {
							return (
								!1 !== e && (e = e || "fx"),
								this.each(function () {
									var t = Ve.get(this),
										n = t[e + "queue"],
										o = t[e + "queueHooks"],
										a = Ae.timers,
										i = n ? n.length : 0,
										s;
									for (
										t.finish = !0,
											Ae.queue(this, e, []),
											o &&
												o.stop &&
												o.stop.call(this, !0),
											s = a.length;
										s--;

									)
										a[s].elem === this &&
											a[s].queue === e &&
											(a[s].anim.stop(!0),
											a.splice(s, 1));
									for (s = 0; s < i; s++)
										n[s] &&
											n[s].finish &&
											n[s].finish.call(this);
									delete t.finish;
								})
							);
						},
					}),
					Ae.each(["toggle", "show", "hide"], function (e, t) {
						var n = Ae.fn[t];
						Ae.fn[t] = function (e, o, a) {
							return null == e || "boolean" == typeof e
								? n.apply(this, arguments)
								: this.animate(ee(t, !0), e, o, a);
						};
					}),
					Ae.each(
						{
							slideDown: ee("show"),
							slideUp: ee("hide"),
							slideToggle: ee("toggle"),
							fadeIn: { opacity: "show" },
							fadeOut: { opacity: "hide" },
							fadeToggle: { opacity: "toggle" },
						},
						function (e, t) {
							Ae.fn[e] = function (e, n, o) {
								return this.animate(t, e, n, o);
							};
						}
					),
					(Ae.timers = []),
					(Ae.fx.tick = function () {
						var e = 0,
							t = Ae.timers,
							n;
						for (Pt = Date.now(); e < t.length; e++)
							(n = t[e]), n() || t[e] !== n || t.splice(e--, 1);
						t.length || Ae.fx.stop(), (Pt = void 0);
					}),
					(Ae.fx.timer = function (e) {
						Ae.timers.push(e), Ae.fx.start();
					}),
					(Ae.fx.interval = 13),
					(Ae.fx.start = function () {
						Nt || ((Nt = !0), J());
					}),
					(Ae.fx.stop = function () {
						Nt = null;
					}),
					(Ae.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
					(Ae.fn.delay = function (e, t) {
						return (
							(e = Ae.fx ? Ae.fx.speeds[e] || e : e),
							(t = t || "fx"),
							this.queue(t, function (t, n) {
								var o = r.setTimeout(t, e);
								n.stop = function () {
									r.clearTimeout(o);
								};
							})
						);
					}),
					(function () {
						var e = ge.createElement("input"),
							t = ge.createElement("select"),
							n = t.appendChild(ge.createElement("option"));
						(e.type = "checkbox"),
							(Ce.checkOn = "" !== e.value),
							(Ce.optSelected = n.selected),
							(e = ge.createElement("input")),
							(e.value = "t"),
							(e.type = "radio"),
							(Ce.radioValue = "t" === e.value);
					})();
				var $t = Ae.expr.attrHandle,
					Mt;
				Ae.fn.extend({
					attr: function (e, t) {
						return Ue(this, Ae.attr, e, t, 1 < arguments.length);
					},
					removeAttr: function (e) {
						return this.each(function () {
							Ae.removeAttr(this, e);
						});
					},
				}),
					Ae.extend({
						attr: function (e, t, n) {
							var o = e.nodeType,
								a,
								i;
							if (3 !== o && 8 !== o && 2 !== o)
								return "undefined" == typeof e.getAttribute
									? Ae.prop(e, t, n)
									: ((1 === o && Ae.isXMLDoc(e)) ||
											(i =
												Ae.attrHooks[t.toLowerCase()] ||
												(Ae.expr.match.bool.test(t)
													? Mt
													: void 0)),
									  void 0 !== n)
									? null === n
										? void Ae.removeAttr(e, t)
										: i &&
										  "set" in i &&
										  void 0 !== (a = i.set(e, n, t))
										? a
										: (e.setAttribute(t, n + ""), n)
									: i &&
									  "get" in i &&
									  null !== (a = i.get(e, t))
									? a
									: ((a = Ae.find.attr(e, t)),
									  null == a ? void 0 : a);
						},
						attrHooks: {
							type: {
								set: function (e, t) {
									if (
										!Ce.radioValue &&
										"radio" === t &&
										m(e, "input")
									) {
										var n = e.value;
										return (
											e.setAttribute("type", t),
											n && (e.value = n),
											t
										);
									}
								},
							},
						},
						removeAttr: function (e, t) {
							var n = 0,
								o = t && t.match(qe),
								a;
							if (o && 1 === e.nodeType)
								for (; (a = o[n++]); ) e.removeAttribute(a);
						},
					}),
					(Mt = {
						set: function (e, t, n) {
							return (
								!1 === t
									? Ae.removeAttr(e, n)
									: e.setAttribute(n, n),
								n
							);
						},
					}),
					Ae.each(
						Ae.expr.match.bool.source.match(/\w+/g),
						function (e, t) {
							var n = $t[t] || Ae.find.attr;
							$t[t] = function (e, t, o) {
								var a = t.toLowerCase(),
									i,
									s;
								return (
									o ||
										((s = $t[a]),
										($t[a] = i),
										(i = null == n(e, t, o) ? null : a),
										($t[a] = s)),
									i
								);
							};
						}
					);
				var Ot = /^(?:input|select|textarea|button)$/i,
					Lt = /^(?:a|area)$/i;
				Ae.fn.extend({
					prop: function (e, t) {
						return Ue(this, Ae.prop, e, t, 1 < arguments.length);
					},
					removeProp: function (e) {
						return this.each(function () {
							delete this[Ae.propFix[e] || e];
						});
					},
				}),
					Ae.extend({
						prop: function (e, t, n) {
							var o = e.nodeType,
								a,
								i;
							if (3 !== o && 8 !== o && 2 !== o)
								return (
									(1 === o && Ae.isXMLDoc(e)) ||
										((t = Ae.propFix[t] || t),
										(i = Ae.propHooks[t])),
									void 0 === n
										? i &&
										  "get" in i &&
										  null !== (a = i.get(e, t))
											? a
											: e[t]
										: i &&
										  "set" in i &&
										  void 0 !== (a = i.set(e, n, t))
										? a
										: (e[t] = n)
								);
						},
						propHooks: {
							tabIndex: {
								get: function (e) {
									var t = Ae.find.attr(e, "tabindex");
									return t
										? parseInt(t, 10)
										: Ot.test(e.nodeName) ||
										  (Lt.test(e.nodeName) && e.href)
										? 0
										: -1;
								},
							},
						},
						propFix: { for: "htmlFor", class: "className" },
					}),
					Ce.optSelected ||
						(Ae.propHooks.selected = {
							get: function (e) {
								var t = e.parentNode;
								return (
									t &&
										t.parentNode &&
										t.parentNode.selectedIndex,
									null
								);
							},
							set: function (e) {
								var t = e.parentNode;
								t &&
									(t.selectedIndex,
									t.parentNode && t.parentNode.selectedIndex);
							},
						}),
					Ae.each(
						[
							"tabIndex",
							"readOnly",
							"maxLength",
							"cellSpacing",
							"cellPadding",
							"rowSpan",
							"colSpan",
							"useMap",
							"frameBorder",
							"contentEditable",
						],
						function () {
							Ae.propFix[this.toLowerCase()] = this;
						}
					),
					Ae.fn.extend({
						addClass: function (e) {
							var t = 0,
								n,
								o,
								a,
								i,
								s,
								r,
								l;
							if (Te(e))
								return this.each(function (t) {
									Ae(this).addClass(
										e.call(this, t, ie(this))
									);
								});
							if (((n = se(e)), n.length))
								for (; (o = this[t++]); )
									if (
										((i = ie(o)),
										(a =
											1 === o.nodeType &&
											" " + ae(i) + " "),
										a)
									) {
										for (r = 0; (s = n[r++]); )
											0 > a.indexOf(" " + s + " ") &&
												(a += s + " ");
										(l = ae(a)),
											i !== l &&
												o.setAttribute("class", l);
									}
							return this;
						},
						removeClass: function (e) {
							var t = 0,
								n,
								o,
								a,
								i,
								s,
								r,
								l;
							if (Te(e))
								return this.each(function (t) {
									Ae(this).removeClass(
										e.call(this, t, ie(this))
									);
								});
							if (!arguments.length)
								return this.attr("class", "");
							if (((n = se(e)), n.length))
								for (; (o = this[t++]); )
									if (
										((i = ie(o)),
										(a =
											1 === o.nodeType &&
											" " + ae(i) + " "),
										a)
									) {
										for (r = 0; (s = n[r++]); )
											for (
												;
												-1 < a.indexOf(" " + s + " ");

											)
												a = a.replace(
													" " + s + " ",
													" "
												);
										(l = ae(a)),
											i !== l &&
												o.setAttribute("class", l);
									}
							return this;
						},
						toggleClass: function (e, t) {
							var n = typeof e,
								o = "string" == n || Array.isArray(e);
							return "boolean" == typeof t && o
								? t
									? this.addClass(e)
									: this.removeClass(e)
								: Te(e)
								? this.each(function (n) {
										Ae(this).toggleClass(
											e.call(this, n, ie(this), t),
											t
										);
								  })
								: this.each(function () {
										var t, a, i, s;
										if (o)
											for (
												a = 0, i = Ae(this), s = se(e);
												(t = s[a++]);

											)
												i.hasClass(t)
													? i.removeClass(t)
													: i.addClass(t);
										else
											(void 0 === e || "boolean" == n) &&
												((t = ie(this)),
												t &&
													Ve.set(
														this,
														"__className__",
														t
													),
												this.setAttribute &&
													this.setAttribute(
														"class",
														t || !1 === e
															? ""
															: Ve.get(
																	this,
																	"__className__"
															  ) || ""
													));
								  });
						},
						hasClass: function (e) {
							var t = 0,
								n,
								o;
							for (n = " " + e + " "; (o = this[t++]); )
								if (
									1 === o.nodeType &&
									-1 < (" " + ae(ie(o)) + " ").indexOf(n)
								)
									return !0;
							return !1;
						},
					});
				var zt = /\r/g;
				Ae.fn.extend({
					val: function (e) {
						var t = this[0],
							n,
							o,
							a;
						return arguments.length
							? ((a = Te(e)),
							  this.each(function (t) {
									var o;
									1 !== this.nodeType ||
										((o = a
											? e.call(this, t, Ae(this).val())
											: e),
										null == o
											? (o = "")
											: "number" == typeof o
											? (o += "")
											: Array.isArray(o) &&
											  (o = Ae.map(o, function (e) {
													return null == e
														? ""
														: e + "";
											  })),
										(n =
											Ae.valHooks[this.type] ||
											Ae.valHooks[
												this.nodeName.toLowerCase()
											]),
										(!n ||
											!("set" in n) ||
											void 0 ===
												n.set(this, o, "value")) &&
											(this.value = o));
							  }))
							: t
							? ((n =
									Ae.valHooks[t.type] ||
									Ae.valHooks[t.nodeName.toLowerCase()]),
							  n &&
									"get" in n &&
									void 0 !== (o = n.get(t, "value")))
								? o
								: ((o = t.value),
								  "string" == typeof o
										? o.replace(zt, "")
										: null == o
										? ""
										: o)
							: void 0;
					},
				}),
					Ae.extend({
						valHooks: {
							option: {
								get: function (e) {
									var t = Ae.find.attr(e, "value");
									return null == t ? ae(Ae.text(e)) : t;
								},
							},
							select: {
								get: function (e) {
									var t = e.options,
										n = e.selectedIndex,
										o = "select-one" === e.type,
										a = o ? null : [],
										s = o ? n + 1 : t.length,
										r,
										l,
										d;
									for (d = 0 > n ? s : o ? n : 0; d < s; d++)
										if (
											((l = t[d]),
											(l.selected || d === n) &&
												!l.disabled &&
												(!l.parentNode.disabled ||
													!m(
														l.parentNode,
														"optgroup"
													)))
										) {
											if (((r = Ae(l).val()), o))
												return r;
											a.push(r);
										}
									return a;
								},
								set: function (e, t) {
									for (
										var n = e.options,
											o = Ae.makeArray(t),
											a = n.length,
											i,
											s;
										a--;

									)
										(s = n[a]),
											(s.selected =
												-1 <
												Ae.inArray(
													Ae.valHooks.option.get(s),
													o
												)) && (i = !0);
									return i || (e.selectedIndex = -1), o;
								},
							},
						},
					}),
					Ae.each(["radio", "checkbox"], function () {
						(Ae.valHooks[this] = {
							set: function (e, t) {
								if (Array.isArray(t))
									return (e.checked =
										-1 < Ae.inArray(Ae(e).val(), t));
							},
						}),
							Ce.checkOn ||
								(Ae.valHooks[this].get = function (e) {
									return null === e.getAttribute("value")
										? "on"
										: e.value;
								});
					}),
					(Ce.focusin = "onfocusin" in r);
				var Rt = /^(?:focusinfocus|focusoutblur)$/,
					Ht = function (t) {
						t.stopPropagation();
					};
				Ae.extend(Ae.event, {
					trigger: function (e, t, n, o) {
						var a = [n || ge],
							s = ke.call(e, "type") ? e.type : e,
							l = ke.call(e, "namespace")
								? e.namespace.split(".")
								: [],
							d,
							i,
							c,
							p,
							m,
							u,
							g,
							h;
						if (
							((i = h = c = n = n || ge),
							3 !== n.nodeType && 8 !== n.nodeType) &&
							!Rt.test(s + Ae.event.triggered) &&
							(-1 < s.indexOf(".") &&
								((l = s.split(".")), (s = l.shift()), l.sort()),
							(m = 0 > s.indexOf(":") && "on" + s),
							(e = e[Ae.expando]
								? e
								: new Ae.Event(s, "object" == typeof e && e)),
							(e.isTrigger = o ? 2 : 3),
							(e.namespace = l.join(".")),
							(e.rnamespace = e.namespace
								? new RegExp(
										"(^|\\.)" +
											l.join("\\.(?:.*\\.|)") +
											"(\\.|$)"
								  )
								: null),
							(e.result = void 0),
							e.target || (e.target = n),
							(t = null == t ? [e] : Ae.makeArray(t, [e])),
							(g = Ae.event.special[s] || {}),
							o || !g.trigger || !1 !== g.trigger.apply(n, t))
						) {
							if (!o && !g.noBubble && !Se(n)) {
								for (
									p = g.delegateType || s,
										Rt.test(p + s) || (i = i.parentNode);
									i;
									i = i.parentNode
								)
									a.push(i), (c = i);
								c === (n.ownerDocument || ge) &&
									a.push(
										c.defaultView || c.parentWindow || r
									);
							}
							for (
								d = 0;
								(i = a[d++]) && !e.isPropagationStopped();

							)
								(h = i),
									(e.type = 1 < d ? p : g.bindType || s),
									(u =
										(Ve.get(i, "events") || {})[e.type] &&
										Ve.get(i, "handle")),
									u && u.apply(i, t),
									(u = m && i[m]),
									u &&
										u.apply &&
										Ye(i) &&
										((e.result = u.apply(i, t)),
										!1 === e.result && e.preventDefault());
							return (
								(e.type = s),
								o ||
									e.isDefaultPrevented() ||
									(g._default &&
										!1 !== g._default.apply(a.pop(), t)) ||
									!Ye(n) ||
									!m ||
									!Te(n[s]) ||
									Se(n) ||
									((c = n[m]),
									c && (n[m] = null),
									(Ae.event.triggered = s),
									e.isPropagationStopped() &&
										h.addEventListener(s, Ht),
									n[s](),
									e.isPropagationStopped() &&
										h.removeEventListener(s, Ht),
									(Ae.event.triggered = void 0),
									c && (n[m] = c)),
								e.result
							);
						}
					},
					simulate: function (t, n, o) {
						var a = Ae.extend(new Ae.Event(), o, {
							type: t,
							isSimulated: !0,
						});
						Ae.event.trigger(a, null, n);
					},
				}),
					Ae.fn.extend({
						trigger: function (e, t) {
							return this.each(function () {
								Ae.event.trigger(e, t, this);
							});
						},
						triggerHandler: function (e, t) {
							var n = this[0];
							if (n) return Ae.event.trigger(e, t, n, !0);
						},
					}),
					Ce.focusin ||
						Ae.each(
							{ focus: "focusin", blur: "focusout" },
							function (e, t) {
								var n = function (e) {
									Ae.event.simulate(
										t,
										e.target,
										Ae.event.fix(e)
									);
								};
								Ae.event.special[t] = {
									setup: function () {
										var o = this.ownerDocument || this,
											a = Ve.access(o, t);
										a || o.addEventListener(e, n, !0),
											Ve.access(o, t, (a || 0) + 1);
									},
									teardown: function () {
										var o = this.ownerDocument || this,
											a = Ve.access(o, t) - 1;
										a
											? Ve.access(o, t, a)
											: (o.removeEventListener(e, n, !0),
											  Ve.remove(o, t));
									},
								};
							}
						);
				var Ft = r.location,
					qt = Date.now(),
					Wt = /\?/;
				Ae.parseXML = function (e) {
					var t;
					if (!e || "string" != typeof e) return null;
					try {
						t = new r.DOMParser().parseFromString(e, "text/xml");
					} catch (n) {
						t = void 0;
					}
					return (
						(!t || t.getElementsByTagName("parsererror").length) &&
							Ae.error("Invalid XML: " + e),
						t
					);
				};
				var Bt = /\[\]$/,
					Ut = /\r?\n/g,
					Gt = /^(?:submit|button|image|reset|file)$/i,
					Xt = /^(?:input|select|textarea|keygen)/i;
				(Ae.param = function (e, t) {
					var n = [],
						o = function (e, t) {
							var o = Te(t) ? t() : t;
							n[n.length] =
								encodeURIComponent(e) +
								"=" +
								encodeURIComponent(null == o ? "" : o);
						},
						a;
					if (null == e) return "";
					if (Array.isArray(e) || (e.jquery && !Ae.isPlainObject(e)))
						Ae.each(e, function () {
							o(this.name, this.value);
						});
					else for (a in e) re(a, e[a], t, o);
					return n.join("&");
				}),
					Ae.fn.extend({
						serialize: function () {
							return Ae.param(this.serializeArray());
						},
						serializeArray: function () {
							return this.map(function () {
								var e = Ae.prop(this, "elements");
								return e ? Ae.makeArray(e) : this;
							})
								.filter(function () {
									var e = this.type;
									return (
										this.name &&
										!Ae(this).is(":disabled") &&
										Xt.test(this.nodeName) &&
										!Gt.test(e) &&
										(this.checked || !lt.test(e))
									);
								})
								.map(function (e, t) {
									var n = Ae(this).val();
									return null == n
										? null
										: Array.isArray(n)
										? Ae.map(n, function (e) {
												return {
													name: t.name,
													value: e.replace(
														Ut,
														"\r\n"
													),
												};
										  })
										: {
												name: t.name,
												value: n.replace(Ut, "\r\n"),
										  };
								})
								.get();
						},
					});
				var Yt = /%20/g,
					Vt = /#.*$/,
					Zt = /([?&])_=[^&]*/,
					Kt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
					Jt =
						/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
					Qt = /^(?:GET|HEAD)$/,
					en = /^\/\//,
					tn = {},
					nn = {},
					on = "*/".concat("*"),
					an = ge.createElement("a");
				(an.href = Ft.href),
					Ae.extend({
						active: 0,
						lastModified: {},
						etag: {},
						ajaxSettings: {
							url: Ft.href,
							type: "GET",
							isLocal: Jt.test(Ft.protocol),
							global: !0,
							processData: !0,
							async: !0,
							contentType:
								"application/x-www-form-urlencoded; charset=UTF-8",
							accepts: {
								"*": on,
								text: "text/plain",
								html: "text/html",
								xml: "application/xml, text/xml",
								json: "application/json, text/javascript",
							},
							contents: {
								xml: /\bxml\b/,
								html: /\bhtml/,
								json: /\bjson\b/,
							},
							responseFields: {
								xml: "responseXML",
								text: "responseText",
								json: "responseJSON",
							},
							converters: {
								"* text": String,
								"text html": !0,
								"text json": JSON.parse,
								"text xml": Ae.parseXML,
							},
							flatOptions: { url: !0, context: !0 },
						},
						ajaxSetup: function (e, t) {
							return t
								? ce(ce(e, Ae.ajaxSettings), t)
								: ce(Ae.ajaxSettings, e);
						},
						ajaxPrefilter: le(tn),
						ajaxTransport: le(nn),
						ajax: function (e, t) {
							function n(e, t, n, i) {
								var p = t,
									m,
									u,
									y,
									v,
									w;
								x ||
									((x = !0),
									b && r.clearTimeout(b),
									(h = void 0),
									(_ = i || ""),
									(g.readyState = 0 < e ? 4 : 0),
									(m = (200 <= e && 300 > e) || 304 === e),
									n && (v = pe(o, g, n)),
									(v = me(o, v, g, m)),
									m
										? (o.ifModified &&
												((w =
													g.getResponseHeader(
														"Last-Modified"
													)),
												w && (Ae.lastModified[f] = w),
												(w =
													g.getResponseHeader(
														"etag"
													)),
												w && (Ae.etag[f] = w)),
										  204 === e || "HEAD" === o.type
												? (p = "nocontent")
												: 304 === e
												? (p = "notmodified")
												: ((p = v.state),
												  (u = v.data),
												  (y = v.error),
												  (m = !y)))
										: ((y = p),
										  (e || !p) &&
												((p = "error"),
												0 > e && (e = 0))),
									(g.status = e),
									(g.statusText = (t || p) + ""),
									m
										? l.resolveWith(a, [u, p, g])
										: l.rejectWith(a, [g, p, y]),
									g.statusCode(c),
									(c = void 0),
									k &&
										s.trigger(
											m ? "ajaxSuccess" : "ajaxError",
											[g, o, m ? u : y]
										),
									d.fireWith(a, [g, p]),
									k &&
										(s.trigger("ajaxComplete", [g, o]),
										!--Ae.active &&
											Ae.event.trigger("ajaxStop")));
							}
							"object" == typeof e && ((t = e), (e = void 0)),
								(t = t || {});
							var o = Ae.ajaxSetup({}, t),
								a = o.context || o,
								s =
									o.context && (a.nodeType || a.jquery)
										? Ae(a)
										: Ae.event,
								l = Ae.Deferred(),
								d = Ae.Callbacks("once memory"),
								c = o.statusCode || {},
								p = {},
								m = {},
								u = "canceled",
								g = {
									readyState: 0,
									getResponseHeader: function (e) {
										var t;
										if (x) {
											if (!y)
												for (y = {}; (t = Kt.exec(_)); )
													y[
														t[1].toLowerCase() + " "
													] = (
														y[
															t[1].toLowerCase() +
																" "
														] || []
													).concat(t[2]);
											t = y[e.toLowerCase() + " "];
										}
										return null == t ? null : t.join(", ");
									},
									getAllResponseHeaders: function () {
										return x ? _ : null;
									},
									setRequestHeader: function (e, t) {
										return (
											null == x &&
												((e = m[e.toLowerCase()] =
													m[e.toLowerCase()] || e),
												(p[e] = t)),
											this
										);
									},
									overrideMimeType: function (e) {
										return (
											null == x && (o.mimeType = e), this
										);
									},
									statusCode: function (e) {
										if (e)
											if (x) g.always(e[g.status]);
											else
												for (var t in e)
													c[t] = [c[t], e[t]];
										return this;
									},
									abort: function (e) {
										var t = e || u;
										return h && h.abort(t), n(0, t), this;
									},
								},
								h,
								f,
								_,
								y,
								b,
								v,
								x,
								k,
								w,
								i;
							if (
								(l.promise(g),
								(o.url = ((e || o.url || Ft.href) + "").replace(
									en,
									Ft.protocol + "//"
								)),
								(o.type =
									t.method || t.type || o.method || o.type),
								(o.dataTypes = (o.dataType || "*")
									.toLowerCase()
									.match(qe) || [""]),
								null == o.crossDomain)
							) {
								v = ge.createElement("a");
								try {
									(v.href = o.url),
										(v.href = v.href),
										(o.crossDomain =
											an.protocol + "//" + an.host !=
											v.protocol + "//" + v.host);
								} catch (t) {
									o.crossDomain = !0;
								}
							}
							if (
								(o.data &&
									o.processData &&
									"string" != typeof o.data &&
									(o.data = Ae.param(o.data, o.traditional)),
								de(tn, o, t, g),
								x)
							)
								return g;
							for (w in ((k = Ae.event && o.global),
							k &&
								0 == Ae.active++ &&
								Ae.event.trigger("ajaxStart"),
							(o.type = o.type.toUpperCase()),
							(o.hasContent = !Qt.test(o.type)),
							(f = o.url.replace(Vt, "")),
							o.hasContent
								? o.data &&
								  o.processData &&
								  0 ===
										(o.contentType || "").indexOf(
											"application/x-www-form-urlencoded"
										) &&
								  (o.data = o.data.replace(Yt, "+"))
								: ((i = o.url.slice(f.length)),
								  o.data &&
										(o.processData ||
											"string" == typeof o.data) &&
										((f +=
											(Wt.test(f) ? "&" : "?") + o.data),
										delete o.data),
								  !1 === o.cache &&
										((f = f.replace(Zt, "$1")),
										(i =
											(Wt.test(f) ? "&" : "?") +
											"_=" +
											qt++ +
											i)),
								  (o.url = f + i)),
							o.ifModified &&
								(Ae.lastModified[f] &&
									g.setRequestHeader(
										"If-Modified-Since",
										Ae.lastModified[f]
									),
								Ae.etag[f] &&
									g.setRequestHeader(
										"If-None-Match",
										Ae.etag[f]
									)),
							((o.data && o.hasContent && !1 !== o.contentType) ||
								t.contentType) &&
								g.setRequestHeader(
									"Content-Type",
									o.contentType
								),
							g.setRequestHeader(
								"Accept",
								o.dataTypes[0] && o.accepts[o.dataTypes[0]]
									? o.accepts[o.dataTypes[0]] +
											("*" === o.dataTypes[0]
												? ""
												: ", " + on + "; q=0.01")
									: o.accepts["*"]
							),
							o.headers))
								g.setRequestHeader(w, o.headers[w]);
							if (
								o.beforeSend &&
								(!1 === o.beforeSend.call(a, g, o) || x)
							)
								return g.abort();
							if (
								((u = "abort"),
								d.add(o.complete),
								g.done(o.success),
								g.fail(o.error),
								(h = de(nn, o, t, g)),
								!h)
							)
								n(-1, "No Transport");
							else {
								if (
									((g.readyState = 1),
									k && s.trigger("ajaxSend", [g, o]),
									x)
								)
									return g;
								o.async &&
									0 < o.timeout &&
									(b = r.setTimeout(function () {
										g.abort("timeout");
									}, o.timeout));
								try {
									(x = !1), h.send(p, n);
								} catch (t) {
									if (x) throw t;
									n(-1, t);
								}
							}
							return g;
						},
						getJSON: function (e, t, n) {
							return Ae.get(e, t, n, "json");
						},
						getScript: function (e, t) {
							return Ae.get(e, void 0, t, "script");
						},
					}),
					Ae.each(["get", "post"], function (e, t) {
						Ae[t] = function (e, n, o, a) {
							return (
								Te(n) && ((a = a || o), (o = n), (n = void 0)),
								Ae.ajax(
									Ae.extend(
										{
											url: e,
											type: t,
											dataType: a,
											data: n,
											success: o,
										},
										Ae.isPlainObject(e) && e
									)
								)
							);
						};
					}),
					(Ae._evalUrl = function (e, t) {
						return Ae.ajax({
							url: e,
							type: "GET",
							dataType: "script",
							cache: !0,
							async: !1,
							global: !1,
							converters: { "text script": function () {} },
							dataFilter: function (e) {
								Ae.globalEval(e, t);
							},
						});
					}),
					Ae.fn.extend({
						wrapAll: function (e) {
							var t;
							return (
								this[0] &&
									(Te(e) && (e = e.call(this[0])),
									(t = Ae(e, this[0].ownerDocument)
										.eq(0)
										.clone(!0)),
									this[0].parentNode &&
										t.insertBefore(this[0]),
									t
										.map(function () {
											for (
												var e = this;
												e.firstElementChild;

											)
												e = e.firstElementChild;
											return e;
										})
										.append(this)),
								this
							);
						},
						wrapInner: function (e) {
							return Te(e)
								? this.each(function (t) {
										Ae(this).wrapInner(e.call(this, t));
								  })
								: this.each(function () {
										var t = Ae(this),
											n = t.contents();
										n.length ? n.wrapAll(e) : t.append(e);
								  });
						},
						wrap: function (e) {
							var t = Te(e);
							return this.each(function (n) {
								Ae(this).wrapAll(t ? e.call(this, n) : e);
							});
						},
						unwrap: function (e) {
							return (
								this.parent(e)
									.not("body")
									.each(function () {
										Ae(this).replaceWith(this.childNodes);
									}),
								this
							);
						},
					}),
					(Ae.expr.pseudos.hidden = function (e) {
						return !Ae.expr.pseudos.visible(e);
					}),
					(Ae.expr.pseudos.visible = function (e) {
						return !!(
							e.offsetWidth ||
							e.offsetHeight ||
							e.getClientRects().length
						);
					}),
					(Ae.ajaxSettings.xhr = function () {
						try {
							return new r.XMLHttpRequest();
						} catch (t) {}
					});
				var sn = { 0: 200, 1223: 204 },
					rn = Ae.ajaxSettings.xhr();
				(Ce.cors = !!rn && "withCredentials" in rn),
					(Ce.ajax = rn = !!rn),
					Ae.ajaxTransport(function (e) {
						var t, n;
						if (Ce.cors || (rn && !e.crossDomain))
							return {
								send: function (o, a) {
									var s = e.xhr(),
										l;
									if (
										(s.open(
											e.type,
											e.url,
											e.async,
											e.username,
											e.password
										),
										e.xhrFields)
									)
										for (l in e.xhrFields)
											s[l] = e.xhrFields[l];
									for (l in (e.mimeType &&
										s.overrideMimeType &&
										s.overrideMimeType(e.mimeType),
									e.crossDomain ||
										o["X-Requested-With"] ||
										(o["X-Requested-With"] =
											"XMLHttpRequest"),
									o))
										s.setRequestHeader(l, o[l]);
									(t = function (e) {
										return function () {
											t &&
												((t =
													n =
													s.onload =
													s.onerror =
													s.onabort =
													s.ontimeout =
													s.onreadystatechange =
														null),
												"abort" === e
													? s.abort()
													: "error" === e
													? "number" ==
													  typeof s.status
														? a(
																s.status,
																s.statusText
														  )
														: a(0, "error")
													: a(
															sn[s.status] ||
																s.status,
															s.statusText,
															"text" !==
																(s.responseType ||
																	"text") ||
																"string" !=
																	typeof s.responseText
																? {
																		binary: s.response,
																  }
																: {
																		text: s.responseText,
																  },
															s.getAllResponseHeaders()
													  ));
										};
									}),
										(s.onload = t()),
										(n =
											s.onerror =
											s.ontimeout =
												t("error")),
										void 0 === s.onabort
											? (s.onreadystatechange =
													function () {
														4 === s.readyState &&
															r.setTimeout(
																function () {
																	t && n();
																}
															);
													})
											: (s.onabort = n),
										(t = t("abort"));
									try {
										s.send(
											(e.hasContent && e.data) || null
										);
									} catch (n) {
										if (t) throw n;
									}
								},
								abort: function () {
									t && t();
								},
							};
					}),
					Ae.ajaxPrefilter(function (e) {
						e.crossDomain && (e.contents.script = !1);
					}),
					Ae.ajaxSetup({
						accepts: {
							script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
						},
						contents: { script: /\b(?:java|ecma)script\b/ },
						converters: {
							"text script": function (e) {
								return Ae.globalEval(e), e;
							},
						},
					}),
					Ae.ajaxPrefilter("script", function (e) {
						void 0 === e.cache && (e.cache = !1),
							e.crossDomain && (e.type = "GET");
					}),
					Ae.ajaxTransport("script", function (e) {
						if (e.crossDomain || e.scriptAttrs) {
							var t, n;
							return {
								send: function (o, a) {
									(t = Ae("<script>")
										.attr(e.scriptAttrs || {})
										.prop({
											charset: e.scriptCharset,
											src: e.url,
										})
										.on(
											"load error",
											(n = function (e) {
												t.remove(),
													(n = null),
													e &&
														a(
															"error" === e.type
																? 404
																: 200,
															e.type
														);
											})
										)),
										ge.head.appendChild(t[0]);
								},
								abort: function () {
									n && n();
								},
							};
						}
					});
				var ln = [],
					dn = /(=)\?(?=&|$)|\?\?/;
				Ae.ajaxSetup({
					jsonp: "callback",
					jsonpCallback: function () {
						var e = ln.pop() || Ae.expando + "_" + qt++;
						return (this[e] = !0), e;
					},
				}),
					Ae.ajaxPrefilter("json jsonp", function (e, t, n) {
						var o =
								!1 !== e.jsonp &&
								(dn.test(e.url)
									? "url"
									: "string" == typeof e.data &&
									  0 ===
											(e.contentType || "").indexOf(
												"application/x-www-form-urlencoded"
											) &&
									  dn.test(e.data) &&
									  "data"),
							a,
							i,
							s;
						if (o || "jsonp" === e.dataTypes[0])
							return (
								(a = e.jsonpCallback =
									Te(e.jsonpCallback)
										? e.jsonpCallback()
										: e.jsonpCallback),
								o
									? (e[o] = e[o].replace(dn, "$1" + a))
									: !1 !== e.jsonp &&
									  (e.url +=
											(Wt.test(e.url) ? "&" : "?") +
											e.jsonp +
											"=" +
											a),
								(e.converters["script json"] = function () {
									return (
										s || Ae.error(a + " was not called"),
										s[0]
									);
								}),
								(e.dataTypes[0] = "json"),
								(i = r[a]),
								(r[a] = function () {
									s = arguments;
								}),
								n.always(function () {
									void 0 === i
										? Ae(r).removeProp(a)
										: (r[a] = i),
										e[a] &&
											((e.jsonpCallback =
												t.jsonpCallback),
											ln.push(a)),
										s && Te(i) && i(s[0]),
										(s = i = void 0);
								}),
								"script"
							);
					}),
					(Ce.createHTMLDocument = (function () {
						var e = ge.implementation.createHTMLDocument("").body;
						return (
							(e.innerHTML = "<form></form><form></form>"),
							2 === e.childNodes.length
						);
					})()),
					(Ae.parseHTML = function (e, t, n) {
						if ("string" != typeof e) return [];
						"boolean" == typeof t && ((n = t), (t = !1));
						var o, a, i;
						return (t ||
							(Ce.createHTMLDocument
								? ((t =
										ge.implementation.createHTMLDocument(
											""
										)),
								  (o = t.createElement("base")),
								  (o.href = ge.location.href),
								  t.head.appendChild(o))
								: (t = ge)),
						(a = Oe.exec(e)),
						(i = !n && []),
						a)
							? [t.createElement(a[1])]
							: ((a = A([e], t, i)),
							  i && i.length && Ae(i).remove(),
							  Ae.merge([], a.childNodes));
					}),
					(Ae.fn.load = function (e, t, n) {
						var o = this,
							a = e.indexOf(" "),
							i,
							s,
							r;
						return (
							-1 < a &&
								((i = ae(e.slice(a))), (e = e.slice(0, a))),
							Te(t)
								? ((n = t), (t = void 0))
								: t && "object" == typeof t && (s = "POST"),
							0 < o.length &&
								Ae.ajax({
									url: e,
									type: s || "GET",
									dataType: "html",
									data: t,
								})
									.done(function (e) {
										(r = arguments),
											o.html(
												i
													? Ae("<div>")
															.append(
																Ae.parseHTML(e)
															)
															.find(i)
													: e
											);
									})
									.always(
										n &&
											function (e, t) {
												o.each(function () {
													n.apply(
														this,
														r || [
															e.responseText,
															t,
															e,
														]
													);
												});
											}
									),
							this
						);
					}),
					Ae.each(
						[
							"ajaxStart",
							"ajaxStop",
							"ajaxComplete",
							"ajaxError",
							"ajaxSuccess",
							"ajaxSend",
						],
						function (e, t) {
							Ae.fn[t] = function (e) {
								return this.on(t, e);
							};
						}
					),
					(Ae.expr.pseudos.animated = function (e) {
						return Ae.grep(Ae.timers, function (t) {
							return e === t.elem;
						}).length;
					}),
					(Ae.offset = {
						setOffset: function (e, t, n) {
							var o = Ae.css(e, "position"),
								a = Ae(e),
								i = {},
								s,
								r,
								l,
								d,
								c,
								p,
								m;
							"static" === o && (e.style.position = "relative"),
								(c = a.offset()),
								(l = Ae.css(e, "top")),
								(p = Ae.css(e, "left")),
								(m =
									("absolute" === o || "fixed" === o) &&
									-1 < (l + p).indexOf("auto")),
								m
									? ((s = a.position()),
									  (d = s.top),
									  (r = s.left))
									: ((d = parseFloat(l) || 0),
									  (r = parseFloat(p) || 0)),
								Te(t) && (t = t.call(e, n, Ae.extend({}, c))),
								null != t.top && (i.top = t.top - c.top + d),
								null != t.left &&
									(i.left = t.left - c.left + r),
								"using" in t ? t.using.call(e, i) : a.css(i);
						},
					}),
					Ae.fn.extend({
						offset: function (e) {
							if (arguments.length)
								return void 0 === e
									? this
									: this.each(function (t) {
											Ae.offset.setOffset(this, e, t);
									  });
							var t = this[0],
								n,
								o;
							if (t)
								return t.getClientRects().length
									? ((n = t.getBoundingClientRect()),
									  (o = t.ownerDocument.defaultView),
									  {
											top: n.top + o.pageYOffset,
											left: n.left + o.pageXOffset,
									  })
									: { top: 0, left: 0 };
						},
						position: function () {
							if (this[0]) {
								var e = this[0],
									t = { top: 0, left: 0 },
									n,
									o,
									a;
								if ("fixed" === Ae.css(e, "position"))
									o = e.getBoundingClientRect();
								else {
									for (
										o = this.offset(),
											a = e.ownerDocument,
											n =
												e.offsetParent ||
												a.documentElement;
										n &&
										(n === a.body ||
											n === a.documentElement) &&
										"static" === Ae.css(n, "position");

									)
										n = n.parentNode;
									n &&
										n !== e &&
										1 === n.nodeType &&
										((t = Ae(n).offset()),
										(t.top += Ae.css(
											n,
											"borderTopWidth",
											!0
										)),
										(t.left += Ae.css(
											n,
											"borderLeftWidth",
											!0
										)));
								}
								return {
									top:
										o.top -
										t.top -
										Ae.css(e, "marginTop", !0),
									left:
										o.left -
										t.left -
										Ae.css(e, "marginLeft", !0),
								};
							}
						},
						offsetParent: function () {
							return this.map(function () {
								for (
									var e = this.offsetParent;
									e && "static" === Ae.css(e, "position");

								)
									e = e.offsetParent;
								return e || nt;
							});
						},
					}),
					Ae.each(
						{ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
						function (e, t) {
							var n = "pageYOffset" === t;
							Ae.fn[e] = function (o) {
								return Ue(
									this,
									function (e, o, a) {
										var i;
										return (
											Se(e)
												? (i = e)
												: 9 === e.nodeType &&
												  (i = e.defaultView),
											void 0 === a
												? i
													? i[t]
													: e[o]
												: void (i
														? i.scrollTo(
																n
																	? i.pageXOffset
																	: a,
																n
																	? a
																	: i.pageYOffset
														  )
														: (e[o] = a))
										);
									},
									e,
									o,
									arguments.length
								);
							};
						}
					),
					Ae.each(["top", "left"], function (e, t) {
						Ae.cssHooks[t] = U(Ce.pixelPosition, function (e, n) {
							if (n)
								return (
									(n = B(e, t)),
									vt.test(n) ? Ae(e).position()[t] + "px" : n
								);
						});
					}),
					Ae.each(
						{ Height: "height", Width: "width" },
						function (e, t) {
							Ae.each(
								{
									padding: "inner" + e,
									content: t,
									"": "outer" + e,
								},
								function (n, a) {
									Ae.fn[a] = function (i, s) {
										var r =
												arguments.length &&
												(n || "boolean" != typeof i),
											l =
												n ||
												(!0 === i || !0 === s
													? "margin"
													: "border");
										return Ue(
											this,
											function (t, n, i) {
												var s;
												return Se(t)
													? 0 === a.indexOf("outer")
														? t["inner" + e]
														: t.document
																.documentElement[
																"client" + e
														  ]
													: 9 === t.nodeType
													? ((s = t.documentElement),
													  o(
															t.body[
																"scroll" + e
															],
															s["scroll" + e],
															t.body[
																"offset" + e
															],
															s["offset" + e],
															s["client" + e]
													  ))
													: void 0 === i
													? Ae.css(t, n, l)
													: Ae.style(t, n, i, l);
											},
											t,
											r ? i : void 0,
											r
										);
									};
								}
							);
						}
					),
					Ae.each(
						[
							"blur",
							"focus",
							"focusin",
							"focusout",
							"resize",
							"scroll",
							"click",
							"dblclick",
							"mousedown",
							"mouseup",
							"mousemove",
							"mouseover",
							"mouseout",
							"mouseenter",
							"mouseleave",
							"change",
							"select",
							"submit",
							"keydown",
							"keypress",
							"keyup",
							"contextmenu",
						],
						function (e, t) {
							Ae.fn[t] = function (e, n) {
								return 0 < arguments.length
									? this.on(t, null, e, n)
									: this.trigger(t);
							};
						}
					),
					Ae.fn.extend({
						hover: function (e, t) {
							return this.mouseenter(e).mouseleave(t || e);
						},
					}),
					Ae.fn.extend({
						bind: function (e, t, n) {
							return this.on(e, null, t, n);
						},
						unbind: function (e, t) {
							return this.off(e, null, t);
						},
						delegate: function (e, t, n, o) {
							return this.on(t, e, n, o);
						},
						undelegate: function (e, t, n) {
							return 1 === arguments.length
								? this.off(e, "**")
								: this.off(t, e || "**", n);
						},
					}),
					(Ae.proxy = function (e, t) {
						var n, o, a;
						if (
							("string" == typeof t &&
								((n = e[t]), (t = e), (e = n)),
							!!Te(e))
						)
							return (
								(o = fe.call(arguments, 2)),
								(a = function () {
									return e.apply(
										t || this,
										o.concat(fe.call(arguments))
									);
								}),
								(a.guid = e.guid = e.guid || Ae.guid++),
								a
							);
					}),
					(Ae.holdReady = function (e) {
						e ? Ae.readyWait++ : Ae.ready(!0);
					}),
					(Ae.isArray = Array.isArray),
					(Ae.parseJSON = JSON.parse),
					(Ae.nodeName = m),
					(Ae.isFunction = Te),
					(Ae.isWindow = Se),
					(Ae.camelCase = x),
					(Ae.type = c),
					(Ae.now = Date.now),
					(Ae.isNumeric = function (e) {
						var t = Ae.type(e);
						return (
							("number" === t || "string" === t) &&
							!isNaN(e - parseFloat(e))
						);
					}),
					(i = []),
					(s = function () {
						return Ae;
					}.apply(t, i)),
					!(void 0 !== s && (e.exports = s));
				var cn = r.jQuery,
					pn = r.$;
				return (
					(Ae.noConflict = function (e) {
						return (
							r.$ === Ae && (r.$ = pn),
							e && r.jQuery === Ae && (r.jQuery = cn),
							Ae
						);
					}),
					l || (r.jQuery = r.$ = Ae),
					Ae
				);
			});
		},
		function (e, t, n) {
			"use strict";
			(function (e) {
				function o(e) {
					var t = location.hash.match(new RegExp(e + "=([^&]*)"));
					return t ? t[1] : null;
				}
				(t.e = function (t) {
					return e.zepto
						? t.touches
							? t.targetTouches[0]
							: t
						: t.originalEvent && t.originalEvent.touches
						? t.originalEvent.touches[0]
						: t;
				}),
					(t.j = function (e) {
						var t, n;
						if ("function" == typeof i.a) return i()(e);
						for (n in ((t = []), e)) t.push(n);
						return t;
					}),
					(t.d = function (e) {
						if (window.location.hash) return o(e);
						if (!window.location.search) return null;
						var t = window.location.search.substr(1).split("&"),
							n = {},
							a,
							s;
						for (s = 0; s < t.length; s++)
							(a = t[s].split("=")), (n[a[0]] = a[1]);
						return n[e] || null;
					}),
					(t.b = function (e, t) {
						for (var n in t) e[n] = t[n];
						return e;
					}),
					(t.a = function (e) {
						return (
							window.requestAnimationFrame ||
							window.webkitRequestAnimationFrame ||
							window.mozRequestAnimationFrame ||
							function (e) {
								window.setTimeout(e, 1e3 / 60);
							}
						)(function () {
							e();
						});
					}),
					(t.g = function (e, t) {
						if (!(t instanceof Array))
							throw new Error("Haystack is not an Array");
						if (t.indexOf) return t.indexOf(e);
						for (var n = 0; n < t.length; n++)
							if (t[n] === e) return n;
						return -1;
					}),
					n.d(t, "h", function () {
						return l;
					}),
					(t.c = function (e, t, n) {
						if (void 0 !== Function.prototype.bind)
							return Function.prototype.bind.apply(
								e,
								[t].concat(n || [])
							);
						var o = function () {
							var a = (n || []).concat(
								Array.prototype.slice.call(arguments, 0)
							);
							return this instanceof o
								? void e.apply(this, a)
								: e.apply(t, a);
						};
						return (o.prototype = e.prototype), o;
					}),
					(t.i = function () {
						return "function" == typeof Date.now
							? Date.now()
							: new Date().getTime();
					}),
					(t.f = function () {
						return (1e15 * Math.random())
							.toString(36)
							.replace(".", "");
					}),
					(t.k = function (t) {
						return e.trim(t.replace(/(<([^>]+)>)/gi, ""));
					});
				var a = n(41),
					i = n.n(a),
					s = n(61),
					r = n.n(s),
					l =
						"function" != typeof /./ && "object" != typeof Int8Array
							? function (e) {
									return "function" == typeof e || !1;
							  }
							: function (e) {
									return (
										"[object Function]" === toString.call(e)
									);
							  };
			}).call(t, n(0));
		},
		function (e, t, n) {
			"use strict";
			var o = n(1);
			const a = "__all";
			t.a = a;
			t.b = class {
				constructor() {
					(this._mSubscriptions = {}),
						(this._mSubscriptions[a] = []),
						(this.on = function (e, t, n) {
							if (!Object(o.h)(t))
								throw new Error(
									"Tried to listen to event " +
										e +
										" with non-function callback " +
										t
								);
							this._mSubscriptions[e] ||
								(this._mSubscriptions[e] = []),
								this._mSubscriptions[e].push({ fn: t, ctx: n });
						}),
						(this.emit = function (e) {
							var t, n, o;
							o = Array.prototype.slice.call(arguments, 1);
							var i = this._mSubscriptions[e];
							if (i)
								for (i = i.slice(), t = 0; t < i.length; t++)
									(n = i[t].ctx || {}), i[t].fn.apply(n, o);
							o.unshift(e);
							var s = this._mSubscriptions[a].slice();
							for (t = 0; t < s.length; t++)
								(n = s[t].ctx || {}), s[t].fn.apply(n, o);
						}),
						(this.unbind = function (e, t, n) {
							if (!this._mSubscriptions[e])
								throw new Error(
									"No subscribtions to unsubscribe for event " +
										e
								);
							var o = !1,
								a;
							for (a = 0; a < this._mSubscriptions[e].length; a++)
								(t && this._mSubscriptions[e][a].fn !== t) ||
									(n &&
										n !== this._mSubscriptions[e][a].ctx) ||
									(this._mSubscriptions[e].splice(a, 1),
									(o = !0));
							if (!1 == o)
								throw new Error("Nothing to unbind for " + e);
						}),
						(this.off = this.unbind),
						(this.trigger = this.emit);
				}
			};
		},
		function (e) {
			var t = (e.exports = { version: "2.6.11" });
			"number" == typeof __e && (__e = t);
		},
		function (e, t, n) {
			"use strict";
			var o = n(2),
				a = n(27),
				i = n(13),
				s = n(28),
				r = n(67),
				l = n(1);
			class d extends o.b {
				constructor(e, t, n) {
					super(),
						(this.config = this._extendItemNode(t)),
						(this.type = t.type),
						(this.contentItems = []),
						(this.parent = n),
						(this.isInitialised = !1),
						(this.isMaximised = !1),
						(this.isRoot = !1),
						(this.isRow = !1),
						(this.isColumn = !1),
						(this.isStack = !1),
						(this.isComponent = !1),
						(this.layoutManager = e),
						(this._pendingEventPropagations = {}),
						(this._throttledEvents = ["stateChanged"]),
						this.on(o.a, this._propagateEvent, this),
						t.content && this._createContentItems(t);
				}
				setSize() {
					throw new Error("Abstract Method");
				}
				callDownwards(e, t, n, o) {
					var a;
					for (
						!0 !== n && !0 !== o && this[e].apply(this, t || []),
							a = 0;
						a < this.contentItems.length;
						a++
					)
						this.contentItems[a].callDownwards(e, t, n);
					!0 === n && !0 !== o && this[e].apply(this, t || []);
				}
				removeChild(e, t) {
					var n = Object(l.g)(e, this.contentItems);
					if (-1 === n)
						throw new Error(
							"Can't remove child item. Unknown content item"
						);
					!0 !== t &&
						(this.contentItems[n]._$destroy(),
						this.contentItems[n].callDownwards(
							"_$destroy",
							[],
							!0,
							!0
						)),
						this.contentItems.splice(n, 1),
						this.config.content.splice(n, 1),
						0 < this.contentItems.length
							? this.callDownwards("setSize")
							: !(this instanceof i.a) &&
							  !0 === this.config.isClosable &&
							  this.parent.removeChild(this);
				}
				undisplayChild(e) {
					var t = Object(l.g)(e, this.contentItems);
					if (-1 === t)
						throw new Error(
							"Can't remove child item. Unknown content item"
						);
					this instanceof i.a ||
						!0 !== this.config.isClosable ||
						this.parent.undisplayChild(this);
				}
				addChild(e, t) {
					t === void 0 && (t = this.contentItems.length),
						this.contentItems.splice(t, 0, e),
						this.config.content === void 0 &&
							(this.config.content = []),
						this.config.content.splice(t, 0, e.config),
						(e.parent = this),
						!0 === e.parent.isInitialised &&
							!1 === e.isInitialised &&
							e._$init();
				}
				replaceChild(e, t, n) {
					t = this.layoutManager._$normalizeContentItem(t);
					var o = Object(l.g)(e, this.contentItems),
						a = e.element[0].parentNode;
					if (-1 === o)
						throw new Error(
							"Can't replace child. oldChild is not child of this"
						);
					a.replaceChild(t.element[0], e.element[0]),
						!0 === n && ((e.parent = null), e._$destroy()),
						(this.contentItems[o] = t),
						(t.parent = this),
						this.isStack && (this.header.tabs[o].contentItem = t),
						!0 === t.parent.isInitialised &&
							!1 === t.isInitialised &&
							t._$init(),
						this.callDownwards("setSize");
				}
				remove() {
					this.parent.removeChild(this);
				}
				popout() {
					var e = this.layoutManager.createPopout(this);
					return this.emitBubblingEvent("stateChanged"), e;
				}
				toggleMaximise(t) {
					t && t.preventDefault(),
						!0 === this.isMaximised
							? this.layoutManager._$minimiseItem(this)
							: this.layoutManager._$maximiseItem(this),
						(this.isMaximised = !this.isMaximised),
						this.emitBubblingEvent("stateChanged");
				}
				select() {
					this.layoutManager.selectedItem !== this &&
						(this.layoutManager.selectItem(this, !0),
						this.element.addClass("lm_selected"));
				}
				deselect() {
					this.layoutManager.selectedItem === this &&
						((this.layoutManager.selectedItem = null),
						this.element.removeClass("lm_selected"));
				}
				setTitle(e) {
					(this.config.title = e),
						this.emit("titleChanged", e),
						this.emit("stateChanged");
				}
				hasId(e) {
					if (!this.config.id) return !1;
					return "string" == typeof this.config.id
						? this.config.id === e
						: this.config.id instanceof Array
						? -1 !== Object(l.g)(e, this.config.id)
						: void 0;
				}
				addId(e) {
					this.hasId(e) ||
						(this.config.id
							? "string" == typeof this.config.id
								? (this.config.id = [this.config.id, e])
								: this.config.id instanceof Array &&
								  this.config.id.push(e)
							: (this.config.id = e));
				}
				removeId(e) {
					if (!this.hasId(e)) throw new Error("Id not found");
					if ("string" == typeof this.config.id)
						delete this.config.id;
					else if (this.config.id instanceof Array) {
						var t = Object(l.g)(e, this.config.id);
						this.config.id.splice(t, 1);
					}
				}
				getItemsByFilter(e) {
					var t = [],
						n = function (o) {
							for (var a = 0; a < o.contentItems.length; a++)
								!0 === e(o.contentItems[a]) &&
									t.push(o.contentItems[a]),
									n(o.contentItems[a]);
						};
					return n(this), t;
				}
				getItemsById(e) {
					return this.getItemsByFilter(function (t) {
						return t.config.id instanceof Array
							? -1 !== Object(l.g)(e, t.config.id)
							: t.config.id === e;
					});
				}
				getItemsByType(e) {
					return this._$getItemsByProperty("type", e);
				}
				getComponentsByName(e) {
					var t = this._$getItemsByProperty("componentName", e),
						n = [],
						o;
					for (o = 0; o < t.length; o++) n.push(t[o].instance);
					return n;
				}
				_$getItemsByProperty(e, t) {
					return this.getItemsByFilter(function (n) {
						return n[e] === t;
					});
				}
				_$setParent(e) {
					this.parent = e;
				}
				_$highlightDropZone(e, t, n) {
					this.layoutManager.dropTargetIndicator.highlightArea(n);
				}
				_$onDrop(e) {
					this.addChild(e);
				}
				_$hide() {
					this._callOnActiveComponents("hide"),
						this.element.hide(),
						this.layoutManager.updateSize();
				}
				_$show() {
					this._callOnActiveComponents("show"),
						this.element.show(),
						this.layoutManager.updateSize();
				}
				_callOnActiveComponents(e) {
					var t = this.getItemsByType("stack"),
						n,
						o;
					for (o = 0; o < t.length; o++)
						(n = t[o].getActiveContentItem()),
							n && n.isComponent && n.container[e]();
				}
				_$destroy() {
					this.emitBubblingEvent("beforeItemDestroyed"),
						this.element.remove(),
						this.emitBubblingEvent("itemDestroyed");
				}
				_$getArea(e) {
					e = e || this.element;
					var t = e.offset(),
						n = e.width(),
						o = e.height();
					return {
						x1: t.left,
						y1: t.top,
						x2: t.left + n,
						y2: t.top + o,
						surface: n * o,
						contentItem: this,
					};
				}
				_$init() {
					var e;
					for (
						this.setSize(), e = 0;
						e < this.contentItems.length;
						e++
					)
						this.childElementContainer.append(
							this.contentItems[e].element
						);
					(this.isInitialised = !0),
						this.emitBubblingEvent("itemCreated"),
						this.emitBubblingEvent(this.type + "Created");
				}
				emitBubblingEvent(e) {
					var t = new a.a(e, this);
					this.emit(e, t);
				}
				_createContentItems(e) {
					var t, n;
					if (!(e.content instanceof Array))
						throw new s.a("content must be an Array", e);
					for (n = 0; n < e.content.length; n++)
						(t = this.layoutManager.createContentItem(
							e.content[n],
							this
						)),
							this.contentItems.push(t);
				}
				_extendItemNode(e) {
					for (var t in r.a) void 0 === e[t] && (e[t] = r.a[t]);
					return e;
				}
				_propagateEvent(e, t) {
					t instanceof a.a &&
						!1 === t.isPropagationStopped &&
						!0 === this.isInitialised &&
						(!1 === this.isRoot && this.parent
							? this.parent.emit.apply(
									this.parent,
									Array.prototype.slice.call(arguments, 0)
							  )
							: this._scheduleEventPropagationToLayoutManager(
									e,
									t
							  ));
				}
				_scheduleEventPropagationToLayoutManager(e, t) {
					-1 === Object(l.g)(e, this._throttledEvents)
						? this.layoutManager.emit(e, t.origin)
						: !0 !== this._pendingEventPropagations[e] &&
						  ((this._pendingEventPropagations[e] = !0),
						  Object(l.a)(
								Object(l.c)(
									this._propagateEventToLayoutManager,
									this,
									[e, t]
								)
						  ));
				}
				_propagateEventToLayoutManager(e, t) {
					(this._pendingEventPropagations[e] = !1),
						this.layoutManager.emit(e, t);
				}
			}
			t.a = d;
		},
		function (e) {
			var t = (e.exports =
				"undefined" != typeof window && window.Math == Math
					? window
					: "undefined" != typeof self && self.Math == Math
					? self
					: Function("return this")());
			"number" == typeof __g && (__g = t);
		},
		function (e, t, n) {
			e.exports = !n(11)(function () {
				return (
					7 !=
					Object.defineProperty({}, "a", {
						get: function () {
							return 7;
						},
					}).a
				);
			});
		},
		function (e, n, i) {
			"use strict";
			(function (e) {
				var s = i(4),
					r = i(14),
					l = i(68),
					d = i(1);
				class c extends s.a {
					constructor(t, n, o, a) {
						super(n, o, a),
							(this.isRow = !t),
							(this.isColumn = t),
							(this.element = e(
								'<div class="lm_item lm_' +
									(t ? "column" : "row") +
									'"></div>'
							)),
							(this.childElementContainer = this.element),
							(this._splitterSize =
								n.config.dimensions.borderWidth),
							(this._splitterGrabSize =
								n.config.dimensions.borderGrabWidth),
							(this._isColumn = t),
							(this._dimension = t ? "height" : "width"),
							(this._splitter = []),
							(this._splitterPosition = null),
							(this._splitterMinPosition = null),
							(this._splitterMaxPosition = null);
					}
					addChild(e, t, n) {
						var a, r, l, i;
						if (
							((e = this.layoutManager._$normalizeContentItem(
								e,
								this
							)),
							void 0 === t && (t = this.contentItems.length),
							0 < this.contentItems.length
								? ((i = this._createSplitter(
										o(0, t - 1)
								  ).element),
								  0 < t
										? (this.contentItems[
												t - 1
										  ].element.after(i),
										  i.after(e.element),
										  this._isDocked(t - 1) &&
												(this._splitter[
													t - 1
												].element.hide(),
												this._splitter[
													t
												].element.show()))
										: (this.contentItems[0].element.before(
												i
										  ),
										  i.before(e.element)))
								: this.childElementContainer.append(e.element),
							s.a.prototype.addChild.call(this, e, t),
							(a = 100 * (1 / this.contentItems.length)),
							!0 === n)
						)
							return void this.emitBubblingEvent("stateChanged");
						for (l = 0; l < this.contentItems.length; l++)
							this.contentItems[l] === e
								? (e.config[this._dimension] = a)
								: ((r = this.contentItems[l].config[
										this._dimension
								  ] *=
										(100 - a) / 100),
								  (this.contentItems[l].config[
										this._dimension
								  ] = r));
						this.callDownwards("setSize"),
							this.emitBubblingEvent("stateChanged"),
							this._validateDocking();
					}
					undisplayChild(e) {
						var t = e.config[this._dimension],
							n = Object(d.g)(e, this.contentItems),
							a = o(n - 1, 0),
							r;
						if (-1 === n)
							throw new Error(
								"Can't undisplay child. ContentItem is not child of this Row or Column"
							);
						this._splitter[a] && this._splitter[a].element.hide(),
							a < this._splitter.length &&
								this._isDocked(a) &&
								this._splitter[a].element.hide();
						var i = this._isDocked();
						for (r = 0; r < this.contentItems.length; r++)
							this.contentItems[r] === e
								? (this.contentItems[r].config[
										this._dimension
								  ] = 0)
								: this._isDocked(r) ||
								  (this.contentItems[r].config[
										this._dimension
								  ] += t / (this.contentItems.length - 1 - i));
						1 === this.contentItems.length &&
							s.a.prototype.undisplayChild.call(this, e),
							this.callDownwards("setSize"),
							this.emitBubblingEvent("stateChanged");
					}
					removeChild(e, t) {
						var n = e.config[this._dimension],
							a = Object(d.g)(e, this.contentItems),
							r = o(a - 1, 0),
							l,
							i;
						if (-1 === a)
							throw new Error(
								"Can't remove child. ContentItem is not child of this Row or Column"
							);
						this._splitter[r] &&
							(this._splitter[r]._$destroy(),
							this._splitter.splice(r, 1)),
							r < this._splitter.length &&
								this._isDocked(r) &&
								this._splitter[r].element.hide();
						var c = this._isDocked();
						for (l = 0; l < this.contentItems.length; l++)
							this.contentItems[l] !== e &&
								(this._isDocked(l) ||
									(this.contentItems[l].config[
										this._dimension
									] +=
										n /
										(this.contentItems.length - 1 - c)));
						s.a.prototype.removeChild.call(this, e, t),
							1 === this.contentItems.length &&
							!0 === this.config.isClosable
								? ((i = this.contentItems[0]),
								  (this.contentItems = []),
								  this.parent.replaceChild(this, i, !0),
								  this._validateDocking(this.parent))
								: (this.callDownwards("setSize"),
								  this.emitBubblingEvent("stateChanged"),
								  this._validateDocking());
					}
					replaceChild(e, t) {
						var n = e.config[this._dimension];
						s.a.prototype.replaceChild.call(this, e, t),
							(t.config[this._dimension] = n),
							this.callDownwards("setSize"),
							this.emitBubblingEvent("stateChanged");
					}
					setSize() {
						0 < this.contentItems.length &&
							(this._calculateRelativeSizes(),
							this._setAbsoluteSizes()),
							this.emitBubblingEvent("stateChanged"),
							this.emit("resize");
					}
					dock(e, t, n) {
						if (1 === this.contentItems.length)
							throw new Error("Can't dock child when it single");
						var a = e.config[this._dimension],
							s =
								this.layoutManager.config.dimensions
									.headerHeight,
							r = Object(d.g)(e, this.contentItems),
							l = o(r - 1, 0);
						if (-1 === r)
							throw new Error(
								"Can't dock child. ContentItem is not child of this Row or Column"
							);
						var c = e._docker && e._docker.docked,
							p;
						if ("undefined" == typeof t || t != c) {
							if (c) {
								for (
									this._splitter[l].element.show(), p = 0;
									p < this.contentItems.length;
									p++
								) {
									var i = e._docker.size;
									this.contentItems[p] === e
										? (e.config[this._dimension] = i)
										: ((itemSize = this.contentItems[
												p
										  ].config[this._dimension] *=
												(100 - i) / 100),
										  (this.contentItems[p].config[
												this._dimension
										  ] = itemSize));
								}
								e._docker = { docked: !1 };
							} else {
								if (
									2 >
									this.contentItems.length - this._isDocked()
								)
									throw new Error(
										"Can't dock child when it is last in " +
											this.config.type
									);
								var m = {
									column: { first: "top", last: "bottom" },
									row: { first: "left", last: "right" },
								}[this.config.type][r ? "last" : "first"];
								e.header.position() != m &&
									e.header.position(m),
									this._splitter[l] &&
										this._splitter[l].element.hide();
								var u = this._isDocked();
								for (p = 0; p < this.contentItems.length; p++)
									this.contentItems[p] === e
										? (this.contentItems[p].config[
												this._dimension
										  ] = 0)
										: this._isDocked(p) ||
										  (this.contentItems[p].config[
												this._dimension
										  ] +=
												a /
												(this.contentItems.length -
													1 -
													u));
								(e._docker = {
									dimension: this._dimension,
									size: a,
									realSize: e.element[this._dimension]() - s,
									docked: !0,
								}),
									n &&
										e.childElementContainer[
											this._dimension
										](0);
							}
							e.element.toggleClass(
								"lm_docked",
								e._docker.docked
							),
								this.callDownwards("setSize"),
								this.emitBubblingEvent("stateChanged"),
								this._validateDocking();
						}
					}
					_$init() {
						if (!0 !== this.isInitialised) {
							var e;
							for (
								s.a.prototype._$init.call(this), e = 0;
								e < this.contentItems.length - 1;
								e++
							)
								this.contentItems[e].element.after(
									this._createSplitter(e).element
								);
							for (e = 0; e < this.contentItems.length; e++)
								this.contentItems[e]._header &&
									this.contentItems[e]._header.docked &&
									this.dock(this.contentItems[e], !0, !0);
						}
					}
					_setAbsoluteSizes() {
						var e = this._calculateAbsoluteSizes(),
							t;
						for (t = 0; t < this.contentItems.length; t++)
							0 < e.additionalPixel - t && e.itemSizes[t]++,
								this._isColumn
									? (this.contentItems[t].element.width(
											e.totalWidth
									  ),
									  this.contentItems[t].element.height(
											e.itemSizes[t]
									  ))
									: (this.contentItems[t].element.width(
											e.itemSizes[t]
									  ),
									  this.contentItems[t].element.height(
											e.totalHeight
									  ));
					}
					_calculateAbsoluteSizes() {
						var e =
								(this.contentItems.length - 1) *
								this._splitterSize,
							n =
								this.layoutManager.config.dimensions
									.headerHeight,
							o = this.element.width(),
							a = this.element.height(),
							s = 0,
							r = [],
							l,
							i,
							d;
						for (
							this._isColumn ? (a -= e) : (o -= e), l = 0;
							l < this.contentItems.length;
							l++
						)
							this._isDocked(l) &&
								(this._isColumn
									? (a -= n - this._splitterSize)
									: (o -= n - this._splitterSize));
						for (l = 0; l < this.contentItems.length; l++)
							(d = this._isColumn
								? t(
										a *
											(this.contentItems[l].config
												.height /
												100)
								  )
								: t(
										o *
											(this.contentItems[l].config.width /
												100)
								  )),
								this._isDocked(l) && (d = n),
								(s += d),
								r.push(d);
						return (
							(i = t((this._isColumn ? a : o) - s)),
							{
								itemSizes: r,
								additionalPixel: i,
								totalWidth: o,
								totalHeight: a,
							}
						);
					}
					_calculateRelativeSizes() {
						var e = 0,
							t = [],
							n = this._isColumn ? "height" : "width",
							o;
						for (o = 0; o < this.contentItems.length; o++)
							void 0 === this.contentItems[o].config[n]
								? t.push(this.contentItems[o])
								: (e += this.contentItems[o].config[n]);
						if (100 === a(e))
							return void this._respectMinItemWidth();
						if (100 > a(e) && 0 < t.length) {
							for (o = 0; o < t.length; o++)
								t[o].config[n] = (100 - e) / t.length;
							return void this._respectMinItemWidth();
						}
						if (100 < a(e))
							for (o = 0; o < t.length; o++)
								(t[o].config[n] = 50), (e += 50);
						for (o = 0; o < this.contentItems.length; o++)
							this.contentItems[o].config[n] =
								100 * (this.contentItems[o].config[n] / e);
						this._respectMinItemWidth();
					}
					_respectMinItemWidth() {
						var e = this.layoutManager.config.dimensions
								? this.layoutManager.config.dimensions
										.minItemWidth || 0
								: 0,
							t = null,
							n = [],
							o = 0,
							s = 0,
							r = 0,
							l = 0,
							d = null,
							c = [],
							p,
							m,
							u;
						if (
							!(
								this._isColumn ||
								!e ||
								1 >= this.contentItems.length
							)
						) {
							t = this._calculateAbsoluteSizes();
							for (var g = 0; g < this.contentItems.length; g++)
								(d = this.contentItems[g]),
									(l = t.itemSizes[g]),
									l < e
										? ((s += e - l), (u = { width: e }))
										: ((o += l - e),
										  (u = { width: l }),
										  n.push(u)),
									c.push(u);
							if (!(0 == s || s > o)) {
								for (p = s / o, r = s, g = 0; g < n.length; g++)
									(u = n[g]),
										(m = a((u.width - e) * p)),
										(r -= m),
										(u.width -= m);
								for (
									0 !== r && (c[c.length - 1].width -= r),
										g = 0;
									g < this.contentItems.length;
									g++
								)
									this.contentItems[g].config.width =
										100 * (c[g].width / t.totalWidth);
							}
						}
					}
					_createSplitter(e) {
						var t;
						return (
							(t = new l.a(
								this._isColumn,
								this._splitterSize,
								this._splitterGrabSize,
								this.layoutManager.container
							)),
							t.on(
								"drag",
								Object(d.c)(this._onSplitterDrag, this, [t]),
								this
							),
							t.on(
								"dragStop",
								Object(d.c)(this._onSplitterDragStop, this, [
									t,
								]),
								this
							),
							t.on(
								"dragStart",
								Object(d.c)(this._onSplitterDragStart, this, [
									t,
								]),
								this
							),
							this._splitter.splice(e, 0, t),
							t
						);
					}
					_getItemsForSplitter(e) {
						var t = Object(d.g)(e, this._splitter);
						return {
							before: this.contentItems[t],
							after: this.contentItems[t + 1],
						};
					}
					_isDocked(e) {
						if ("undefined" == typeof e) {
							for (
								var t = 0, n = 0;
								n < this.contentItems.length;
								++n
							)
								this._isDocked(n) && t++;
							return t;
						}
						return e < this.contentItems.length
							? this.contentItems[e]._docker &&
									this.contentItems[e]._docker.docked
							: void 0;
					}
					_validateDocking(e) {
						e = e || this;
						for (
							var t = 1 < e.contentItems.length - e._isDocked(),
								n = 0;
							n < e.contentItems.length;
							++n
						)
							e.contentItems[n] instanceof r.a &&
								(e.contentItems[n].header._setDockable(
									e._isDocked(n) || t
								),
								e.contentItems[n].header._$setClosable(t));
					}
					_getMinimumDimensions(e) {
						for (var t = 0, n = 0, a = 0; a < e.length; ++a)
							(t = o(e[a].minWidth || 0, t)),
								(n = o(e[a].minHeight || 0, n));
						return { horizontal: t, vertical: n };
					}
					_onSplitterDragStart(e) {
						var t = this._getItemsForSplitter(e),
							n =
								this.layoutManager.config.dimensions[
									this._isColumn
										? "minItemHeight"
										: "minItemWidth"
								],
							o = this._getMinimumDimensions(
								t.before.config.content
							),
							a = this._isColumn ? o.vertical : o.horizontal,
							i = this._getMinimumDimensions(
								t.after.config.content
							),
							s = this._isColumn ? i.vertical : i.horizontal;
						(this._splitterPosition = 0),
							(this._splitterMinPosition =
								-1 *
								(t.before.element[this._dimension]() -
									(a || n))),
							(this._splitterMaxPosition =
								t.after.element[this._dimension]() - (s || n));
					}
					_onSplitterDrag(e, t, n) {
						var o = this._isColumn ? n : t;
						o > this._splitterMinPosition &&
							o < this._splitterMaxPosition &&
							((this._splitterPosition = o),
							e.element.css(this._isColumn ? "top" : "left", o));
					}
					_onSplitterDragStop(e) {
						var t = this._getItemsForSplitter(e),
							n = t.before.element[this._dimension](),
							o = t.after.element[this._dimension](),
							a = (this._splitterPosition + n) / (n + o),
							i =
								t.before.config[this._dimension] +
								t.after.config[this._dimension];
						(t.before.config[this._dimension] = a * i),
							(t.after.config[this._dimension] = (1 - a) * i),
							e.element.css({ top: 0, left: 0 }),
							Object(d.a)(
								Object(d.c)(this.callDownwards, this, [
									"setSize",
								])
							);
					}
				}
				n.a = c;
			}).call(n, i(0));
		},
		function (e, t, n) {
			"use strict";
			(function (e) {
				var o = n(2),
					a = n(1);
				class i extends o.b {
					constructor(t, n) {
						super(),
							(this._timeout = null),
							(this._eElement = e(t)),
							(this._oDocument = e(document)),
							(this._eBody = n),
							(this._nButtonCode = 0),
							(this._nDelay = 200),
							(this._nDistance = 10),
							(this._nX = 0),
							(this._nY = 0),
							(this._nOriginalX = 0),
							(this._nOriginalY = 0),
							(this._bDragging = !1),
							(this._fMove = Object(a.c)(this.onMouseMove, this)),
							(this._fUp = Object(a.c)(this.onMouseUp, this)),
							(this._fDown = Object(a.c)(this.onMouseDown, this)),
							this._eElement.on(
								"mousedown touchstart",
								this._fDown
							);
					}
					destroy() {
						this._eElement.unbind(
							"mousedown touchstart",
							this._fDown
						),
							this._oDocument.unbind(
								"mouseup touchend",
								this._fUp
							),
							(this._eElement = null),
							(this._oDocument = null),
							(this._eBody = null);
					}
					onMouseDown(e) {
						if (
							(e.preventDefault(),
							0 == e.button || "touchstart" === e.type)
						) {
							var t = this._getCoordinates(e);
							(this._nOriginalX = t.x),
								(this._nOriginalY = t.y),
								this._oDocument.on(
									"mousemove touchmove",
									this._fMove
								),
								this._oDocument.one(
									"mouseup touchend",
									this._fUp
								),
								(this._timeout = setTimeout(
									Object(a.c)(this._startDrag, this),
									this._nDelay
								));
						}
					}
					onMouseMove(e) {
						var t = Math.abs;
						if (null != this._timeout) {
							e.preventDefault();
							var n = this._getCoordinates(e);
							(this._nX = n.x - this._nOriginalX),
								(this._nY = n.y - this._nOriginalY),
								!1 === this._bDragging &&
									(t(this._nX) > this._nDistance ||
										t(this._nY) > this._nDistance) &&
									(clearTimeout(this._timeout),
									this._startDrag()),
								this._bDragging &&
									this.emit("drag", this._nX, this._nY, e);
						}
					}
					onMouseUp(e) {
						null != this._timeout &&
							(clearTimeout(this._timeout),
							this._eBody.removeClass("lm_dragging"),
							this._eElement.removeClass("lm_dragging"),
							this._oDocument
								.find("iframe")
								.css("pointer-events", ""),
							this._oDocument.unbind(
								"mousemove touchmove",
								this._fMove
							),
							this._oDocument.unbind(
								"mouseup touchend",
								this._fUp
							),
							!0 === this._bDragging &&
								((this._bDragging = !1),
								this.emit(
									"dragStop",
									e,
									this._nOriginalX + this._nX
								)));
					}
					_startDrag() {
						(this._bDragging = !0),
							this._eBody.addClass("lm_dragging"),
							this._eElement.addClass("lm_dragging"),
							this._oDocument
								.find("iframe")
								.css("pointer-events", "none"),
							this.emit(
								"dragStart",
								this._nOriginalX,
								this._nOriginalY
							);
					}
					_getCoordinates(e) {
						return (e = Object(a.e)(e)), { x: e.pageX, y: e.pageY };
					}
				}
				t.a = i;
			}).call(t, n(0));
		},
		function (e, t, n) {
			var o = n(10);
			e.exports = function (e) {
				if (!o(e)) throw TypeError(e + " is not an object!");
				return e;
			};
		},
		function (e) {
			e.exports = function (e) {
				return "object" == typeof e
					? null !== e
					: "function" == typeof e;
			};
		},
		function (e) {
			e.exports = function (e) {
				try {
					return !!e();
				} catch (t) {
					return !0;
				}
			};
		},
		function (e, t, n) {
			"use strict";
			var o = n(1);
			t.a = class {
				constructor() {
					if (
						((this._keys = [
							"settings",
							"hasHeaders",
							"constrainDragToContainer",
							"selectionEnabled",
							"dimensions",
							"borderWidth",
							"minItemHeight",
							"minItemWidth",
							"headerHeight",
							"dragProxyWidth",
							"dragProxyHeight",
							"labels",
							"close",
							"maximise",
							"minimise",
							"popout",
							"content",
							"componentName",
							"componentState",
							"id",
							"width",
							"type",
							"height",
							"isClosable",
							"title",
							"popoutWholeStack",
							"openPopouts",
							"parentId",
							"activeItemIndex",
							"reorderEnabled",
							"borderGrabWidth",
						]),
						36 < this._keys.length)
					)
						throw new Error("Too many keys in config minifier map");
					this._values = [
						!0,
						!1,
						"row",
						"column",
						"stack",
						"component",
						"close",
						"maximise",
						"minimise",
						"open in new window",
					];
				}
				minifyConfig(e) {
					var t = {};
					return this._nextLevel(e, t, "_min"), t;
				}
				unminifyConfig(e) {
					var t = {};
					return this._nextLevel(e, t, "_max"), t;
				}
				_nextLevel(e, t, n) {
					var o, a;
					for (o in e)
						e instanceof Array && (o = parseInt(o, 10)),
							e.hasOwnProperty(o) &&
								((a = this[n](o, this._keys)),
								"object" == typeof e[o]
									? ((t[a] = e[o] instanceof Array ? [] : {}),
									  this._nextLevel(e[o], t[a], n))
									: (t[a] = this[n](e[o], this._values)));
				}
				_min(e, t) {
					if ("string" == typeof e && 1 === e.length)
						return "___" + e;
					var n = Object(o.g)(e, t);
					return -1 === n ? e : n.toString(36);
				}
				_max(e, t) {
					return "string" == typeof e && 1 === e.length
						? t[parseInt(e, 36)]
						: "string" == typeof e && "___" === e.substr(0, 3)
						? e[3]
						: e;
				}
			};
		},
		function (e, t, n) {
			"use strict";
			(function (e) {
				var o = n(4),
					a = n(7);
				class i extends o.a {
					constructor(t, n, o) {
						super(t, n, null),
							(this.isRoot = !0),
							(this.type = "root"),
							(this.element = e(
								'<div class="lm_goldenlayout lm_item lm_root"></div>'
							)),
							(this.childElementContainer = this.element),
							(this._containerElement = o),
							this._containerElement.append(this.element);
					}
					addChild(e) {
						if (0 < this.contentItems.length)
							throw new Error(
								"Root node can only have a single child"
							);
						(e = this.layoutManager._$normalizeContentItem(
							e,
							this
						)),
							this.childElementContainer.append(e.element),
							o.a.prototype.addChild.call(this, e),
							this.callDownwards("setSize"),
							this.emitBubblingEvent("stateChanged");
					}
					setSize(e, t) {
						(e =
							"undefined" == typeof e
								? this._containerElement.width()
								: e),
							(t =
								"undefined" == typeof t
									? this._containerElement.height()
									: t),
							this.element.width(e),
							this.element.height(t),
							this.contentItems[0] &&
								(this.contentItems[0].element.width(e),
								this.contentItems[0].element.height(t));
					}
					_$highlightDropZone() {
						this.layoutManager.tabDropPlaceholder.remove(),
							o.a.prototype._$highlightDropZone.apply(
								this,
								arguments
							);
					}
					_$onDrop(e, t) {
						var n;
						if (
							(e.isComponent &&
								((n = this.layoutManager.createContentItem(
									{
										type: "stack",
										header: e.config.header || {},
									},
									this
								)),
								n._$init(),
								n.addChild(e),
								(e = n)),
							!this.contentItems.length)
						)
							this.addChild(e);
						else {
							("row" === e.config.type ||
								"column" === e.config.type) &&
								((n = this.layoutManager.createContentItem(
									{ type: "stack" },
									this
								)),
								n.addChild(e),
								(e = n));
							var o = "x" == t.side[0] ? "row" : "column",
								i = "x" == t.side[0] ? "width" : "height",
								s = "2" == t.side[1],
								r = this.contentItems[0];
							if (!(r instanceof a.a) || r.type != o) {
								var l = this.layoutManager.createContentItem(
									{ type: o },
									this
								);
								this.replaceChild(r, l),
									l.addChild(e, s ? 0 : void 0, !0),
									l.addChild(r, s ? void 0 : 0, !0),
									(r.config[i] = 50),
									(e.config[i] = 50),
									l.callDownwards("setSize");
							} else {
								var d =
									r.contentItems[
										s ? 0 : r.contentItems.length - 1
									];
								r.addChild(e, s ? 0 : void 0, !0),
									(d.config[i] *= 0.5),
									(e.config[i] = d.config[i]),
									r.callDownwards("setSize");
							}
						}
					}
				}
				t.a = i;
			}).call(t, n(0));
		},
		function (t, n, a) {
			"use strict";
			(function (t) {
				var s = a(4),
					r = a(7),
					i = a(29),
					l = a(1);
				class d extends s.a {
					constructor(e, n, o) {
						super(e, n, o),
							(this.element = t(
								'<div class="lm_item lm_stack"></div>'
							)),
							(this._activeContentItem = null);
						var a = e.config;
						(this._header = {
							show:
								!0 === a.settings.hasHeaders &&
								!1 !== n.hasHeaders,
							popout:
								a.settings.showPopoutIcon && a.labels.popout,
							maximise:
								a.settings.showMaximiseIcon &&
								a.labels.maximise,
							close: a.settings.showCloseIcon && a.labels.close,
							minimise: a.labels.minimise,
						}),
							a.header && Object(l.b)(this._header, a.header),
							n.header && Object(l.b)(this._header, n.header),
							n.content &&
								n.content[0] &&
								n.content[0].header &&
								Object(l.b)(this._header, n.content[0].header),
							(this._dropZones = {}),
							(this._dropSegment = null),
							(this._contentAreaDimensions = null),
							(this._dropIndex = null),
							(this.isStack = !0),
							(this.childElementContainer = t(
								'<div class="lm_items"></div>'
							)),
							(this.header = new i.a(e, this)),
							this.element.on(
								"mouseleave mouseenter",
								Object(l.c)(function (e) {
									this._docker &&
										this._docker.docked &&
										this.childElementContainer[
											this._docker.dimension
										](
											"mouseenter" == e.type
												? this._docker.realSize
												: 0
										);
								}, this)
							),
							this.element.append(this.header.element),
							this.element.append(this.childElementContainer),
							this._setupHeaderPosition(),
							this._$validateClosability();
					}
					dock(e) {
						this._header.dock &&
							this.parent instanceof r.a &&
							this.parent.dock(this, e);
					}
					setSize() {
						if ("none" !== this.element.css("display")) {
							var e = this._docker && this._docker.docked,
								t = {
									width: this.element.width(),
									height: this.element.height(),
								};
							this._header.show &&
								(t[this._sided ? "width" : "height"] -=
									this.layoutManager.config.dimensions.headerHeight),
								e &&
									(t[this._docker.dimension] =
										this._docker.realSize),
								(e && "height" != this._docker.dimension) ||
									this.childElementContainer.width(t.width),
								(e && "width" != this._docker.dimension) ||
									this.childElementContainer.height(t.height);
							for (var n = 0; n < this.contentItems.length; n++)
								this.contentItems[n].element.width(t.width),
									this.contentItems[n].element.height(
										t.height
									);
							this.emit("resize"),
								this.emitBubblingEvent("stateChanged");
						}
					}
					_$init() {
						var e, t;
						if (!0 !== this.isInitialised) {
							for (
								s.a.prototype._$init.call(this), e = 0;
								e < this.contentItems.length;
								e++
							)
								this.header.createTab(this.contentItems[e]),
									this.contentItems[e]._$hide();
							if (0 < this.contentItems.length) {
								if (
									((t =
										this.contentItems[
											this.config.activeItemIndex || 0
										]),
									!t)
								)
									throw new Error(
										"Configured activeItemIndex out of bounds"
									);
								this.setActiveContentItem(t);
							}
							this._$validateClosability(),
								this.parent instanceof r.a &&
									this.parent._validateDocking();
						}
					}
					setActiveContentItem(e) {
						if (this._activeContentItem !== e) {
							if (-1 === Object(l.g)(e, this.contentItems))
								throw new Error(
									"contentItem is not a child of this stack"
								);
							null !== this._activeContentItem &&
								this._activeContentItem._$hide(),
								(this._activeContentItem = e),
								this.header.setActiveContentItem(e),
								e._$show(),
								this.emit("activeContentItemChanged", e),
								this.layoutManager.emit(
									"activeContentItemChanged",
									e
								),
								this.emitBubblingEvent("stateChanged");
						}
					}
					getActiveContentItem() {
						return this.header.activeContentItem;
					}
					addChild(e, t) {
						t > this.contentItems.length && (t -= 1),
							(e = this.layoutManager._$normalizeContentItem(
								e,
								this
							)),
							s.a.prototype.addChild.call(this, e, t),
							this.childElementContainer.append(e.element),
							this.header.createTab(e, t),
							this.setActiveContentItem(e),
							this.callDownwards("setSize"),
							this._$validateClosability(),
							this.parent instanceof r.a &&
								this.parent._validateDocking(),
							this.emitBubblingEvent("stateChanged");
					}
					removeChild(e, t) {
						var n = Object(l.g)(e, this.contentItems);
						if (
							(s.a.prototype.removeChild.call(this, e, t),
							this.header.removeTab(e),
							this.header.activeContentItem === e)
						)
							0 < this.contentItems.length
								? this.setActiveContentItem(
										this.contentItems[o(n - 1, 0)]
								  )
								: (this._activeContentItem = null);
						else if (
							this.config.activeItemIndex >=
								this.contentItems.length &&
							0 < this.contentItems.length
						) {
							var a = Object(l.g)(
								this.getActiveContentItem(),
								this.contentItems
							);
							this.config.activeItemIndex = o(a, 0);
						}
						this._$validateClosability(),
							this.parent instanceof r.a &&
								this.parent._validateDocking(),
							this.emitBubblingEvent("stateChanged");
					}
					undisplayChild(e) {
						if (1 < this.contentItems.length) {
							var t = Object(l.g)(e, this.contentItems);
							e._$hide && e._$hide(),
								this.setActiveContentItem(
									this.contentItems[0 === t ? t + 1 : t - 1]
								);
						} else
							this.header.hideTab(e),
								e._$hide && e._$hide(),
								s.a.prototype.undisplayChild.call(this, e),
								this.parent instanceof r.a &&
									this.parent._validateDocking();
						this.emitBubblingEvent("stateChanged");
					}
					_$validateClosability() {
						var e, t, n;
						for (
							e = this.header._isClosable(),
								n = 0,
								t = this.contentItems.length;
							n < t && !!e;
							n++
						)
							e = this.contentItems[n].config.isClosable;
						this.header._$setClosable(e);
					}
					_$destroy() {
						s.a.prototype._$destroy.call(this),
							this.header._$destroy(),
							this.element.off("mouseenter mouseleave");
					}
					_$onDrop(e) {
						if ("header" === this._dropSegment)
							return (
								this._resetHeaderDropZone(),
								void this.addChild(e, this._dropIndex)
							);
						if ("body" === this._dropSegment)
							return void this.addChild(e);
						var t =
								"top" === this._dropSegment ||
								"bottom" === this._dropSegment,
							n =
								"left" === this._dropSegment ||
								"right" === this._dropSegment,
							o =
								"top" === this._dropSegment ||
								"left" === this._dropSegment,
							a =
								(t && this.parent.isColumn) ||
								(n && this.parent.isRow),
							i = t ? "column" : "row",
							s = t ? "height" : "width",
							r,
							d,
							c;
						e.isComponent &&
							((d = this.layoutManager.createContentItem(
								{
									type: "stack",
									header: e.config.header || {},
								},
								this
							)),
							d._$init(),
							d.addChild(e),
							(e = d)),
							("row" === e.config.type ||
								"column" === e.config.type) &&
								((d = this.layoutManager.createContentItem(
									{ type: "stack" },
									this
								)),
								d.addChild(e),
								(e = d)),
							a
								? ((r = Object(l.g)(
										this,
										this.parent.contentItems
								  )),
								  this.parent.addChild(e, o ? r : r + 1, !0),
								  (this.config[s] *= 0.5),
								  (e.config[s] = this.config[s]),
								  this.parent.callDownwards("setSize"))
								: ((i = t ? "column" : "row"),
								  (c = this.layoutManager.createContentItem(
										{ type: i },
										this
								  )),
								  this.parent.replaceChild(this, c),
								  c.addChild(e, o ? 0 : void 0, !0),
								  c.addChild(this, o ? void 0 : 0, !0),
								  (this.config[s] = 50),
								  (e.config[s] = 50),
								  c.callDownwards("setSize")),
							this.parent._validateDocking();
					}
					_$highlightDropZone(e, t) {
						var n, o;
						for (n in this._contentAreaDimensions)
							if (
								((o = this._contentAreaDimensions[n].hoverArea),
								o.x1 < e && o.x2 > e && o.y1 < t && o.y2 > t)
							)
								return void ("header" === n
									? ((this._dropSegment = "header"),
									  this._highlightHeaderDropZone(
											this._sided ? t : e
									  ))
									: (this._resetHeaderDropZone(),
									  this._highlightBodyDropZone(n)));
					}
					_$getArea() {
						if ("none" === this.element.css("display")) return null;
						var e = s.a.prototype._$getArea,
							t = e.call(this, this.header.element),
							n = e.call(this, this.childElementContainer),
							o = n.x2 - n.x1,
							a = n.y2 - n.y1;
						return ((this._contentAreaDimensions = {
							header: {
								hoverArea: {
									x1: t.x1,
									y1: t.y1,
									x2: t.x2,
									y2: t.y2,
								},
								highlightArea: {
									x1: t.x1,
									y1: t.y1,
									x2: t.x2,
									y2: t.y2,
								},
							},
						}),
						this._activeContentItem &&
							!1 === this._activeContentItem.isComponent)
							? t
							: 0 === this.contentItems.length
							? ((this._contentAreaDimensions.body = {
									hoverArea: {
										x1: n.x1,
										y1: n.y1,
										x2: n.x2,
										y2: n.y2,
									},
									highlightArea: {
										x1: n.x1,
										y1: n.y1,
										x2: n.x2,
										y2: n.y2,
									},
							  }),
							  e.call(this, this.element))
							: ((this._contentAreaDimensions.left = {
									hoverArea: {
										x1: n.x1,
										y1: n.y1,
										x2: n.x1 + 0.25 * o,
										y2: n.y2,
									},
									highlightArea: {
										x1: n.x1,
										y1: n.y1,
										x2: n.x1 + 0.5 * o,
										y2: n.y2,
									},
							  }),
							  (this._contentAreaDimensions.top = {
									hoverArea: {
										x1: n.x1 + 0.25 * o,
										y1: n.y1,
										x2: n.x1 + 0.75 * o,
										y2: n.y1 + 0.5 * a,
									},
									highlightArea: {
										x1: n.x1,
										y1: n.y1,
										x2: n.x2,
										y2: n.y1 + 0.5 * a,
									},
							  }),
							  (this._contentAreaDimensions.right = {
									hoverArea: {
										x1: n.x1 + 0.75 * o,
										y1: n.y1,
										x2: n.x2,
										y2: n.y2,
									},
									highlightArea: {
										x1: n.x1 + 0.5 * o,
										y1: n.y1,
										x2: n.x2,
										y2: n.y2,
									},
							  }),
							  (this._contentAreaDimensions.bottom = {
									hoverArea: {
										x1: n.x1 + 0.25 * o,
										y1: n.y1 + 0.5 * a,
										x2: n.x1 + 0.75 * o,
										y2: n.y2,
									},
									highlightArea: {
										x1: n.x1,
										y1: n.y1 + 0.5 * a,
										x2: n.x2,
										y2: n.y2,
									},
							  }),
							  e.call(this, this.element));
					}
					_highlightHeaderDropZone(t) {
						var n = this.header.tabs.length,
							o = !1,
							a,
							i,
							s,
							r,
							l,
							d,
							c,
							p,
							m;
						if (0 === n)
							return (
								(c = this.header.element.offset()),
								void this.layoutManager.dropTargetIndicator.highlightArea(
									{
										x1: c.left,
										x2: c.left + 100,
										y1:
											c.top +
											this.header.element.height() -
											20,
										y2:
											c.top +
											this.header.element.height(),
									}
								)
							);
						for (a = 0; a < n; a++)
							if (
								((i = this.header.tabs[a].element),
								(l = i.offset()),
								this._sided
									? ((r = l.top),
									  (s = l.left),
									  (p = i.height()))
									: ((r = l.left),
									  (s = l.top),
									  (p = i.width())),
								t > r && t < r + p)
							) {
								o = !0;
								break;
							}
						if (!(!1 == o && t < r)) {
							if (
								((m = r + p / 2),
								t < m
									? ((this._dropIndex = a),
									  i.before(
											this.layoutManager
												.tabDropPlaceholder
									  ))
									: ((this._dropIndex = e(a + 1, n)),
									  i.after(
											this.layoutManager
												.tabDropPlaceholder
									  )),
								this._sided)
							) {
								var u =
									this.layoutManager.tabDropPlaceholder.offset()
										.top;
								return void this.layoutManager.dropTargetIndicator.highlightArea(
									{
										x1: s,
										x2: s + i.innerHeight(),
										y1: u,
										y2:
											u +
											this.layoutManager.tabDropPlaceholder.width(),
									}
								);
							}
							(d =
								this.layoutManager.tabDropPlaceholder.offset()
									.left),
								this.layoutManager.dropTargetIndicator.highlightArea(
									{
										x1: d,
										x2:
											d +
											this.layoutManager.tabDropPlaceholder.width(),
										y1: s,
										y2: s + i.innerHeight(),
									}
								);
						}
					}
					_resetHeaderDropZone() {
						this.layoutManager.tabDropPlaceholder.remove();
					}
					toggleMaximise(t) {
						this.isMaximised || this.dock(!1),
							s.a.prototype.toggleMaximise.call(this, t);
					}
					_setupHeaderPosition() {
						var e =
							0 <=
								["right", "left", "bottom"].indexOf(
									this._header.show
								) && this._header.show;
						if (
							(this.header.element.toggle(!!this._header.show),
							(this._side = e),
							(this._sided =
								0 <= ["right", "left"].indexOf(this._side)),
							this.element.removeClass(
								"lm_left lm_right lm_bottom"
							),
							this._side &&
								this.element.addClass("lm_" + this._side),
							this.element.find(".lm_header").length &&
								this.childElementContainer)
						) {
							var t =
								0 <= ["right", "bottom"].indexOf(this._side)
									? "before"
									: "after";
							this.header.element[t](this.childElementContainer),
								this.callDownwards("setSize");
						}
					}
					_highlightBodyDropZone(e) {
						var t = this._contentAreaDimensions[e].highlightArea;
						this.layoutManager.dropTargetIndicator.highlightArea(t),
							(this._dropSegment = e);
					}
				}
				n.a = d;
			}).call(n, a(0));
		},
		function (e) {
			e.exports = function (e) {
				if (e == void 0) throw TypeError("Can't call method on  " + e);
				return e;
			};
		},
		function (e, t, n) {
			var o = n(45),
				a = n(21);
			e.exports =
				Object.keys ||
				function (e) {
					return o(e, a);
				};
		},
		function (e) {
			var t = {}.hasOwnProperty;
			e.exports = function (e, n) {
				return t.call(e, n);
			};
		},
		function (e, t, n) {
			var o = n(46),
				a = n(15);
			e.exports = function (e) {
				return o(a(e));
			};
		},
		function (e) {
			e.exports = function (e) {
				return isNaN((e = +e)) ? 0 : (0 < e ? t : n)(e);
			};
		},
		function (e, t, n) {
			var o = n(51)("keys"),
				a = n(53);
			e.exports = function (e) {
				return o[e] || (o[e] = a(e));
			};
		},
		function (e) {
			e.exports = [
				"constructor",
				"hasOwnProperty",
				"isPrototypeOf",
				"propertyIsEnumerable",
				"toLocaleString",
				"toString",
				"valueOf",
			];
		},
		function (e, t, n) {
			var o = n(5),
				a = n(3),
				i = n(55),
				s = n(57),
				r = n(17),
				l = "prototype",
				d = function (e, t, n) {
					var c = e & d.F,
						p = e & d.G,
						m = e & d.S,
						u = e & d.P,
						g = e & d.B,
						h = e & d.W,
						f = p ? a : a[t] || (a[t] = {}),
						_ = f[l],
						y = p ? o : m ? o[t] : (o[t] || {})[l],
						b,
						v,
						x;
					for (b in (p && (n = t), n))
						(v = !c && y && void 0 !== y[b]),
							(v && r(f, b)) ||
								((x = v ? y[b] : n[b]),
								(f[b] =
									p && "function" != typeof y[b]
										? n[b]
										: g && v
										? i(x, o)
										: h && y[b] == x
										? (function (e) {
												var t = function (t, n, o) {
													if (this instanceof e) {
														switch (
															arguments.length
														) {
															case 0:
																return new e();
															case 1:
																return new e(t);
															case 2:
																return new e(
																	t,
																	n
																);
														}
														return new e(t, n, o);
													}
													return e.apply(
														this,
														arguments
													);
												};
												return (t[l] = e[l]), t;
										  })(x)
										: u && "function" == typeof x
										? i(Function.call, x)
										: x),
								u &&
									(((f.virtual || (f.virtual = {}))[b] = x),
									e & d.R && _ && !_[b] && s(_, b, x)));
				};
			(d.F = 1),
				(d.G = 2),
				(d.S = 4),
				(d.P = 8),
				(d.B = 16),
				(d.W = 32),
				(d.U = 64),
				(d.R = 128),
				(e.exports = d);
		},
		function (e, t, n) {
			var o = n(9),
				a = n(58),
				i = n(59),
				s = Object.defineProperty;
			t.f = n(6)
				? Object.defineProperty
				: function (e, t, n) {
						if ((o(e), (t = i(t, !0)), o(n), a))
							try {
								return s(e, t, n);
							} catch (t) {}
						if ("get" in n || "set" in n)
							throw TypeError("Accessors not supported!");
						return "value" in n && (e[t] = n.value), e;
				  };
		},
		function (e, t, n) {
			var o = n(10),
				a = n(5).document,
				i = o(a) && o(a.createElement);
			e.exports = function (e) {
				return i ? a.createElement(e) : {};
			};
		},
		function (e, t, n) {
			"use strict";
			(function (e) {
				t.a = class {
					constructor(e, t) {
						(this._reactComponent = null),
							(this._originalComponentWillUpdate = null),
							(this._container = e),
							(this._initialState = t),
							(this._reactClass = this._getReactClass()),
							this._container.on("open", this._render, this),
							this._container.on("destroy", this._destroy, this);
					}
					_render() {
						ReactDOM.render(
							this._getReactComponent(),
							this._container.getElement()[0]
						);
					}
					_gotReactComponent(e) {
						(this._reactComponent = e),
							(this._originalComponentWillUpdate =
								this._reactComponent.componentWillUpdate ||
								function () {}),
							(this._reactComponent.componentWillUpdate =
								this._onUpdate.bind(this)),
							this._container.getState() &&
								this._reactComponent.setState(
									this._container.getState()
								);
					}
					_destroy() {
						ReactDOM.unmountComponentAtNode(
							this._container.getElement()[0]
						),
							this._container.off("open", this._render, this),
							this._container.off("destroy", this._destroy, this);
					}
					_onUpdate(e, t) {
						this._container.setState(t),
							this._originalComponentWillUpdate.call(
								this._reactComponent,
								e,
								t
							);
					}
					_getReactClass() {
						var e = this._container._config.component,
							t;
						if (!e)
							throw new Error(
								"No react component name. type: react-component needs a field `component`"
							);
						if (
							((t =
								this._container.layoutManager.getComponent(e)),
							!t)
						)
							throw new Error(
								'React component "' +
									e +
									'" not found. Please register all components with GoldenLayout using `registerComponent(name, component)`'
							);
						return t;
					}
					_getReactComponent() {
						var t = {
								glEventHub:
									this._container.layoutManager.eventHub,
								glContainer: this._container,
								ref: this._gotReactComponent.bind(this),
							},
							n = e.extend(t, this._container._config.props);
						return React.createElement(this._reactClass, n);
					}
				};
			}).call(t, n(0));
		},
		function (e, t, n) {
			"use strict";
			(function (e) {
				var o = n(2),
					a = n(1);
				class i extends o.b {
					constructor(t) {
						super(),
							(this._layoutManager = t),
							(this._dontPropagateToParent = null),
							(this._childEventSource = null),
							this.on(
								o.a,
								Object(a.c)(this._onEventFromThis, this)
							),
							(this._boundOnEventFromChild = Object(a.c)(
								this._onEventFromChild,
								this
							)),
							e(window).on(
								"gl_child_event",
								this._boundOnEventFromChild
							);
					}
					_onEventFromThis() {
						var e = Array.prototype.slice.call(arguments);
						this._layoutManager.isSubWindow &&
							e[0] !== this._dontPropagateToParent &&
							this._propagateToParent(e),
							this._propagateToChildren(e),
							(this._dontPropagateToParent = null),
							(this._childEventSource = null);
					}
					_$onEventFromParent(e) {
						(this._dontPropagateToParent = e[0]),
							this.emit.apply(this, e);
					}
					_onEventFromChild(e) {
						(this._childEventSource = e.originalEvent.__gl),
							this.emit.apply(this, e.originalEvent.__glArgs);
					}
					_propagateToParent(e) {
						var t = "gl_child_event",
							n;
						document.createEvent
							? ((n =
									window.opener.document.createEvent(
										"HTMLEvents"
									)),
							  n.initEvent(t, !0, !0))
							: ((n = window.opener.document.createEventObject()),
							  (n.eventType = t)),
							(n.eventName = t),
							(n.__glArgs = e),
							(n.__gl = this._layoutManager),
							document.createEvent
								? window.opener.dispatchEvent(n)
								: window.opener.fireEvent(
										"on" + n.eventType,
										n
								  );
					}
					_propagateToChildren(e) {
						var t, n;
						for (
							n = 0;
							n < this._layoutManager.openPopouts.length;
							n++
						)
							(t =
								this._layoutManager.openPopouts[
									n
								].getGlInstance()),
								t &&
									t !== this._childEventSource &&
									t.eventHub._$onEventFromParent(e);
					}
					destroy() {
						e(window).off(
							"gl_child_event",
							this._boundOnEventFromChild
						);
					}
				}
				t.a = i;
			}).call(t, n(0));
		},
		function (e, t) {
			"use strict";
			t.a = class {
				constructor(e, t) {
					(this.name = e),
						(this.origin = t),
						(this.isPropagationStopped = !1);
				}
				stopPropagation() {
					this.isPropagationStopped = !0;
				}
			};
		},
		function (e, t) {
			"use strict";
			class n extends Error {
				constructor(e, t) {
					super(),
						(this.name = "Configuration Error"),
						(this.message = e),
						(this.node = t);
				}
			}
			t.a = n;
		},
		function (e, t, n) {
			"use strict";
			(function (e) {
				var o = n(2),
					a = n(30),
					i = n(32),
					s = n(1);
				class r extends o.b {
					constructor(t, n) {
						super(),
							(this.layoutManager = t),
							(this.element = e(
								'<div class="lm_header"><ul class="lm_tabs"></ul><ul class="lm_controls"></ul><ul class="lm_tabdropdown_list"></ul></div>'
							)),
							!0 ===
								this.layoutManager.config.settings
									.selectionEnabled &&
								(this.element.addClass("lm_selectable"),
								this.element.on(
									"click touchend",
									Object(s.c)(this._onHeaderClick, this)
								)),
							(this.tabsContainer =
								this.element.find(".lm_tabs")),
							(this.tabDropdownContainer = this.element.find(
								".lm_tabdropdown_list"
							)),
							this.tabDropdownContainer.hide(),
							(this.controlsContainer =
								this.element.find(".lm_controls")),
							(this.parent = n),
							this.parent.on(
								"resize",
								this._updateTabSizes,
								this
							),
							(this.tabs = []),
							(this.tabsMarkedForRemoval = []),
							(this.activeContentItem = null),
							(this.closeButton = null),
							(this.dockButton = null),
							(this.tabDropdownButton = null),
							(this.hideAdditionalTabsDropdown = Object(s.c)(
								this._hideAdditionalTabsDropdown,
								this
							)),
							e(document).mouseup(
								this.hideAdditionalTabsDropdown
							),
							(this._lastVisibleTabIndex = -1),
							(this._tabControlOffset =
								this.layoutManager.config.settings.tabControlOffset),
							this._createControls();
					}
					createTab(e, t) {
						var n, o;
						for (o = 0; o < this.tabs.length; o++)
							if (this.tabs[o].contentItem === e) return;
						return (
							(n = new a.a(this, e)),
							0 === this.tabs.length
								? (this.tabs.push(n),
								  void this.tabsContainer.append(n.element))
								: void (void 0 === t && (t = this.tabs.length),
								  0 < t
										? this.tabs[t - 1].element.after(
												n.element
										  )
										: this.tabs[0].element.before(
												n.element
										  ),
								  this.tabs.splice(t, 0, n),
								  this._updateTabSizes())
						);
					}
					removeTab(e) {
						for (var t = 0; t < this.tabs.length; t++)
							if (this.tabs[t].contentItem === e)
								return (
									this.tabs[t]._$destroy(),
									void this.tabs.splice(t, 1)
								);
						for (t = 0; t < this.tabsMarkedForRemoval.length; t++)
							if (this.tabsMarkedForRemoval[t].contentItem === e)
								return (
									this.tabsMarkedForRemoval[t]._$destroy(),
									void this.tabsMarkedForRemoval.splice(t, 1)
								);
						throw new Error(
							"contentItem is not controlled by this header"
						);
					}
					hideTab(e) {
						for (var t = 0; t < this.tabs.length; t++)
							if (this.tabs[t].contentItem === e)
								return (
									this.tabs[t].element.hide(),
									this.tabsMarkedForRemoval.push(
										this.tabs[t]
									),
									void this.tabs.splice(t, 1)
								);
						throw new Error(
							"contentItem is not controlled by this header"
						);
					}
					setActiveContentItem(e) {
						var t, n, o, a;
						if (this.activeContentItem !== e) {
							for (t = 0; t < this.tabs.length; t++)
								(o = this.tabs[t].contentItem === e),
									this.tabs[t].setActive(o),
									!0 === o &&
										((this.activeContentItem = e),
										(this.parent.config.activeItemIndex =
											t));
							if (
								this.layoutManager.config.settings
									.reorderOnTabMenuClick &&
								-1 !== this._lastVisibleTabIndex &&
								this.parent.config.activeItemIndex >
									this._lastVisibleTabIndex
							) {
								for (
									a =
										this.tabs[
											this.parent.config.activeItemIndex
										],
										n = this.parent.config.activeItemIndex;
									0 < n;
									n--
								)
									this.tabs[n] = this.tabs[n - 1];
								(this.tabs[0] = a),
									(this.parent.config.activeItemIndex = 0);
							}
							this._updateTabSizes(),
								this.parent.emitBubblingEvent("stateChanged");
						}
					}
					position(e) {
						var t = this.parent._header.show;
						if (this.parent._docker && this.parent._docker.docked)
							throw new Error(
								"Can't change header position in docked stack"
							);
						return (
							t && !this.parent._side && (t = "top"),
							void 0 !== e &&
								this.parent._header.show != e &&
								((this.parent._header.show = e),
								this.parent.config.header
									? (this.parent.config.header.show = e)
									: (this.parent.config.header = { show: e }),
								this.parent._setupHeaderPosition()),
							t
						);
					}
					_$setClosable(e) {
						return (
							(this._canDestroy = e || 1 < this.tabs.length),
							this.closeButton &&
								this._isClosable() &&
								(this.closeButton.element[
									e ? "show" : "hide"
								](),
								!0)
						);
					}
					_setDockable(e) {
						return (
							this.dockButton &&
							this.parent._header &&
							this.parent._header.dock &&
							(this.dockButton.element.toggle(!!e), !0)
						);
					}
					_$destroy() {
						this.emit("destroy", this);
						for (var t = 0; t < this.tabs.length; t++)
							this.tabs[t]._$destroy();
						e(document).off(
							"mouseup",
							this.hideAdditionalTabsDropdown
						),
							this.element.remove();
					}
					_getHeaderSetting(e) {
						if (e in this.parent._header)
							return this.parent._header[e];
					}
					_createControls() {
						var e, t, n, o, a, r, l, d, c;
						if (
							((c = Object(s.c)(
								this._showAdditionalTabsDropdown,
								this
							)),
							(d = this.layoutManager.config.labels.tabDropdown),
							(this.tabDropdownButton = new i.a(
								this,
								d,
								"lm_tabdropdown",
								c
							)),
							this.tabDropdownButton.element.hide(),
							this.parent._header && this.parent._header.dock)
						) {
							var p = Object(s.c)(this.parent.dock, this.parent);
							(n = this._getHeaderSetting("dock")),
								(this.dockButton = new i.a(
									this,
									n,
									"lm_dock",
									p
								));
						}
						this._getHeaderSetting("popout") &&
							((t = Object(s.c)(this._onPopoutClick, this)),
							(n = this._getHeaderSetting("popout")),
							new i.a(this, n, "lm_popout", t)),
							this._getHeaderSetting("maximise") &&
								((r = Object(s.c)(
									this.parent.toggleMaximise,
									this.parent
								)),
								(o = this._getHeaderSetting("maximise")),
								(a = this._getHeaderSetting("minimise")),
								(l = new i.a(this, o, "lm_maximise", r)),
								this.parent.on("maximised", function () {
									l.element.attr("title", a);
								}),
								this.parent.on("minimised", function () {
									l.element.attr("title", o);
								})),
							this._isClosable() &&
								((e = Object(s.c)(
									this.parent.remove,
									this.parent
								)),
								(n = this._getHeaderSetting("close")),
								(this.closeButton = new i.a(
									this,
									n,
									"lm_close",
									e
								)));
					}
					_showAdditionalTabsDropdown() {
						this.tabDropdownContainer.show();
					}
					_hideAdditionalTabsDropdown() {
						this.tabDropdownContainer.hide();
					}
					_isClosable() {
						return (
							this.parent.config.isClosable &&
							this.layoutManager.config.settings.showCloseIcon
						);
					}
					_onPopoutClick() {
						!0 ===
						this.layoutManager.config.settings.popoutWholeStack
							? this.parent.popout()
							: this.activeContentItem.popout();
					}
					_onHeaderClick(e) {
						e.target === this.element[0] && this.parent.select();
					}
					_updateTabSizes(e) {
						if (0 !== this.tabs.length) {
							this.tabDropdownButton.element.toggle(!0 === e);
							var t = function (e) {
								return e ? "width" : "height";
							};
							this.element.css(t(!this.parent._sided), ""),
								this.element[t(this.parent._sided)](
									this.layoutManager.config.dimensions
										.headerHeight
								);
							var n =
									this.element.outerWidth() -
									this.controlsContainer.outerWidth() -
									this._tabControlOffset,
								o = 0,
								a = 0,
								s = 0,
								r =
									this.layoutManager.config.settings
										.tabOverlapAllowance,
								l = !1,
								d = this.activeContentItem
									? this.tabs.indexOf(
											this.activeContentItem.tab
									  )
									: 0,
								c = this.tabs[d],
								p,
								m,
								i,
								u,
								g;
							for (
								this.parent._sided &&
									(n =
										this.element.outerHeight() -
										this.controlsContainer.outerHeight() -
										this._tabControlOffset),
									this._lastVisibleTabIndex = -1,
									m = 0;
								m < this.tabs.length;
								m++
							)
								if (
									((p = this.tabs[m].element),
									this.tabsContainer.append(p),
									(g =
										p.outerWidth() +
										parseInt(p.css("margin-right"), 10)),
									(o += g),
									(a =
										d <= m
											? o
											: o +
											  c.element.outerWidth() +
											  parseInt(
													c.element.css(
														"margin-right"
													),
													10
											  )),
									a > n)
								) {
									if (!!l)
										m === d &&
											(p.css({
												"z-index": "auto",
												"margin-left": "",
											}),
											this.tabsContainer.append(p));
									else if (
										((s =
											0 < d && d <= m
												? (a - n) / (m - 1)
												: (a - n) / m),
										s < r)
									) {
										for (i = 0; i <= m; i++)
											(u =
												i !== d && 0 !== i
													? "-" + s + "px"
													: ""),
												this.tabs[i].element.css({
													"z-index": m - i,
													"margin-left": u,
												});
										(this._lastVisibleTabIndex = m),
											this.tabsContainer.append(p);
									} else l = !0;
									if (l && m !== d)
										if (e)
											p.css({
												"z-index": "auto",
												"margin-left": "",
											}),
												this.tabDropdownContainer.append(
													p
												);
										else
											return void this._updateTabSizes(
												!0
											);
								} else
									(this._lastVisibleTabIndex = m),
										p.css({
											"z-index": "auto",
											"margin-left": "",
										}),
										this.tabsContainer.append(p);
						}
					}
				}
				t.a = r;
			}).call(t, n(0));
		},
		function (e, t, n) {
			"use strict";
			(function (e) {
				var o = n(8),
					a = n(31),
					i = n(1);
				t.a = class {
					constructor(t, n) {
						(this.header = t),
							(this.contentItem = n),
							(this.element = e(
								'<li class="lm_tab"><i class="lm_left"></i><span class="lm_title"></span><div class="lm_close_tab"></div><i class="lm_right"></i></li>'
							)),
							(this.titleElement =
								this.element.find(".lm_title")),
							(this.closeElement =
								this.element.find(".lm_close_tab")),
							this.closeElement[
								n.config.isClosable ? "show" : "hide"
							](),
							(this.isActive = !1),
							this.setTitle(n.config.title),
							this.contentItem.on(
								"titleChanged",
								this.setTitle,
								this
							),
							(this._layoutManager =
								this.contentItem.layoutManager),
							!0 ===
								this._layoutManager.config.settings
									.reorderEnabled &&
								!0 === n.config.reorderEnabled &&
								((this._dragListener = new o.a(
									this.element,
									this._layoutManager.container
								)),
								this._dragListener.on(
									"dragStart",
									this._onDragStart,
									this
								),
								this.contentItem.on(
									"destroy",
									this._dragListener.destroy,
									this._dragListener
								)),
							(this._onTabClickFn = Object(i.c)(
								this._onTabClick,
								this
							)),
							(this._onCloseClickFn = Object(i.c)(
								this._onCloseClick,
								this
							)),
							this.element.on(
								"click touchend",
								this._onTabClickFn
							),
							this.contentItem.config.isClosable
								? (this.closeElement.on(
										"click touchend",
										this._onCloseClickFn
								  ),
								  this.closeElement.on(
										"mousedown",
										this._onCloseMousedown
								  ))
								: this.closeElement.remove(),
							(this.contentItem.tab = this),
							this.contentItem.emit("tab", this),
							this.contentItem.layoutManager.emit(
								"tabCreated",
								this
							),
							this.contentItem.isComponent &&
								((this.contentItem.container.tab = this),
								this.contentItem.container.emit("tab", this));
					}
					setTitle(e) {
						this.element.attr("title", Object(i.k)(e)),
							this.titleElement.html(e);
					}
					setActive(e) {
						e === this.isActive ||
							((this.isActive = e),
							e
								? this.element.addClass("lm_active")
								: this.element.removeClass("lm_active"));
					}
					_$destroy() {
						this.element.off(
							"mousedown touchend",
							this._onTabClickFn
						),
							this.closeElement.off(
								"click touchend",
								this._onCloseClickFn
							),
							this._dragListener &&
								(this.contentItem.off(
									"destroy",
									this._dragListener.destroy,
									this._dragListener
								),
								this._dragListener.off(
									"dragStart",
									this._onDragStart
								),
								(this._dragListener = null)),
							this.element.remove();
					}
					_onDragStart(e, t) {
						return this.header._canDestroy
							? void (!0 ===
									this.contentItem.parent.isMaximised &&
									this.contentItem.parent.toggleMaximise(),
							  new a.a(
									e,
									t,
									this._dragListener,
									this._layoutManager,
									this.contentItem,
									this.header.parent
							  ))
							: null;
					}
					_onTabClick(e) {
						0 === e.button || "touchend" === e.type
							? this.header.parent.setActiveContentItem(
									this.contentItem
							  )
							: 1 === e.button &&
							  this.contentItem.config.isClosable &&
							  this._onCloseClick(e);
					}
					_onCloseClick(e) {
						e.stopPropagation();
						this.header._canDestroy &&
							this.header.parent.removeChild(this.contentItem);
					}
					_onCloseMousedown(e) {
						e.stopPropagation();
					}
				};
			}).call(t, n(0));
		},
		function (e, t, n) {
			"use strict";
			(function (e) {
				var o = n(2),
					a = n(1);
				class i extends o.b {
					constructor(t, n, o, i, s, r) {
						super(),
							(this._dragListener = o),
							(this._layoutManager = i),
							(this._contentItem = s),
							(this._originalParent = r),
							(this._area = null),
							(this._lastValidArea = null),
							this._dragListener.on("drag", this._onDrag, this),
							this._dragListener.on(
								"dragStop",
								this._onDrop,
								this
							),
							(this.element = e(
								'<div class="lm_dragProxy"><div class="lm_header"><ul class="lm_tabs"><li class="lm_tab lm_active"><i class="lm_left"></i><span class="lm_title"></span><i class="lm_right"></i></li></ul></div><div class="lm_content"></div></div>'
							)),
							r &&
								r._side &&
								((this._sided = r._sided),
								this.element.addClass("lm_" + r._side),
								0 <= ["right", "bottom"].indexOf(r._side) &&
									this.element
										.find(".lm_content")
										.after(
											this.element.find(".lm_header")
										)),
							this.element.css({ left: t, top: n }),
							this.element
								.find(".lm_tab")
								.attr(
									"title",
									Object(a.k)(this._contentItem.config.title)
								),
							this.element
								.find(".lm_title")
								.html(this._contentItem.config.title),
							(this.childElementContainer =
								this.element.find(".lm_content")),
							this._undisplayTree(),
							this._layoutManager._$calculateItemAreas(),
							this._setDimensions(),
							this._layoutManager.container.append(this.element);
						var l = this._layoutManager.container.offset();
						(this._minX = l.left),
							(this._minY = l.top),
							(this._maxX =
								this._layoutManager.container.width() +
								this._minX),
							(this._maxY =
								this._layoutManager.container.height() +
								this._minY),
							(this._width = this.element.width()),
							(this._height = this.element.height()),
							this._setDropPosition(t, n);
					}
					_onDrag(e, t, n) {
						n = Object(a.e)(n);
						var o = n.pageX,
							i = n.pageY,
							s =
								o > this._minX &&
								o < this._maxX &&
								i > this._minY &&
								i < this._maxY;
						(s ||
							!0 !==
								this._layoutManager.config.settings
									.constrainDragToContainer) &&
							this._setDropPosition(o, i);
					}
					_setDropPosition(e, t) {
						this.element.css({ left: e, top: t }),
							(this._area = this._layoutManager._$getArea(e, t)),
							null !== this._area &&
								((this._lastValidArea = this._area),
								this._area.contentItem._$highlightDropZone(
									e,
									t,
									this._area
								));
					}
					_onDrop() {
						this._updateTree(),
							this._layoutManager.dropTargetIndicator.hide(),
							null === this._area
								? null === this._lastValidArea
									? this._originalParent
										? this._originalParent.addChild(
												this._contentItem
										  )
										: this._contentItem._$destroy()
									: this._lastValidArea.contentItem._$onDrop(
											this._contentItem,
											this._lastValidArea
									  )
								: this._area.contentItem._$onDrop(
										this._contentItem,
										this._area
								  ),
							this.element.remove(),
							this._layoutManager.emit(
								"itemDropped",
								this._contentItem
							);
					}
					_undisplayTree() {
						this._contentItem.parent &&
							this._contentItem.parent.undisplayChild(
								this._contentItem
							);
					}
					_updateTree() {
						this._contentItem.parent &&
							this._contentItem.parent.removeChild(
								this._contentItem,
								!0
							),
							this._contentItem._$setParent(this);
					}
					_setDimensions() {
						var e = this._layoutManager.config.dimensions,
							t = e.dragProxyWidth,
							n = e.dragProxyHeight;
						this.element.width(t),
							this.element.height(n),
							(t -= this._sided ? e.headerHeight : 0),
							(n -= this._sided ? 0 : e.headerHeight),
							this.childElementContainer.width(t),
							this.childElementContainer.height(n),
							this._contentItem.element.width(t),
							this._contentItem.element.height(n),
							this._contentItem.callDownwards("_$show"),
							this._contentItem.callDownwards("setSize");
					}
				}
				t.a = i;
			}).call(t, n(0));
		},
		function (e, t, n) {
			"use strict";
			(function (e) {
				t.a = class {
					constructor(t, n, o, a) {
						(this._header = t),
							(this.element = e(
								'<li class="' + o + '" title="' + n + '"></li>'
							)),
							this._header.on("destroy", this._$destroy, this),
							(this._action = a),
							this.element.on("click touchend", this._action),
							this._header.controlsContainer.append(this.element);
					}
					_$destroy() {
						this.element.off(), this.element.remove();
					}
				};
			}).call(t, n(0));
		},
		function (e, t, n) {
			"use strict";
			(function (e) {
				var o = n(4),
					a = n(34);
				class i extends o.a {
					constructor(t, n, o) {
						super(t, n, o);
						var i = t.getComponent(this.config.componentName),
							s = e.extend(
								!0,
								{},
								this.config.componentState || {}
							);
						(s.componentName = this.config.componentName),
							(this.componentName = this.config.componentName),
							"" === this.config.title &&
								(this.config.title = this.config.componentName),
							(this.isComponent = !0),
							(this.container = new a.a(this.config, this, t)),
							(this.instance = i(this.container, s)),
							(this.element = this.container._element);
					}
					close() {
						this.parent.removeChild(this);
					}
					setSize() {
						"none" !== this.element.css("display") &&
							this.container._$setSize(
								this.element.width(),
								this.element.height()
							);
					}
					_$init() {
						o.a.prototype._$init.call(this),
							this.container.emit("open");
					}
					_$hide() {
						this.container.hide(), o.a.prototype._$hide.call(this);
					}
					_$show() {
						this.container.show(), o.a.prototype._$show.call(this);
					}
					_$shown() {
						this.container.shown(),
							o.a.prototype._$shown.call(this);
					}
					_$destroy() {
						this.container.emit("destroy", this),
							o.a.prototype._$destroy.call(this);
					}
					_$getArea() {
						return null;
					}
				}
				t.a = i;
			}).call(t, n(0));
		},
		function (e, t, n) {
			"use strict";
			(function (e) {
				var o = n(2);
				class a extends o.b {
					constructor(t, n, o) {
						super(),
							(this.width = null),
							(this.height = null),
							(this.title = t.componentName),
							(this.parent = n),
							(this.layoutManager = o),
							(this.isHidden = !1),
							(this._config = t),
							(this._element = e(
								'<div class="lm_item_container"><div class="lm_content"></div></div>'
							)),
							(this._contentElement =
								this._element.find(".lm_content"));
					}
					getElement() {
						return this._contentElement;
					}
					hide() {
						this.emit("hide"),
							(this.isHidden = !0),
							this._element.hide();
					}
					show() {
						this.emit("show"),
							(this.isHidden = !1),
							this._element.show(),
							(0 != this.height || 0 != this.width) &&
								this.emit("shown");
					}
					setSize(e, t) {
						for (
							var n = this.parent, o = this, a, s, r, l, d, c;
							!n.isColumn && !n.isRow;

						)
							if (((o = n), (n = n.parent), n.isRoot)) return !1;
						for (
							r = n.isColumn ? "height" : "width",
								l = "height" === r ? t : e,
								a = this[r] * (1 / (o.config[r] / 100)),
								s = 100 * (l / a),
								d =
									(o.config[r] - s) /
									(n.contentItems.length - 1),
								c = 0;
							c < n.contentItems.length;
							c++
						)
							n.contentItems[c] === o
								? (n.contentItems[c].config[r] = s)
								: (n.contentItems[c].config[r] += d);
						return n.callDownwards("setSize"), !0;
					}
					close() {
						this._config.isClosable &&
							(this.emit("close"), this.parent.close());
					}
					getState() {
						return this._config.componentState;
					}
					extendState(t) {
						this.setState(e.extend(!0, this.getState(), t));
					}
					setState(e) {
						(this._config.componentState = e),
							this.parent.emitBubblingEvent("stateChanged");
					}
					setTitle(e) {
						this.parent.setTitle(e);
					}
					_$setSize(t, n) {
						(t !== this.width || n !== this.height) &&
							((this.width = t),
							(this.height = n),
							e.zepto
								? this._contentElement.width(t)
								: this._contentElement.outerWidth(t),
							e.zepto
								? this._contentElement.height(n)
								: this._contentElement.outerHeight(n),
							this.emit("resize"));
					}
				}
				t.a = a;
			}).call(t, n(0));
		},
		function (e, n, o) {
			"use strict";
			(function (e) {
				var a = o(69),
					i = o.n(a),
					s = o(2),
					r = o(12),
					l = o(1);
				class d extends s.b {
					constructor(e, t, n, o, a) {
						super(),
							(this.isInitialised = !1),
							(this._config = e),
							(this._dimensions = t),
							(this._parentId = n),
							(this._indexInParent = o),
							(this._layoutManager = a),
							(this._popoutWindow = null),
							(this._id = null),
							this._createWindow();
					}
					toConfig() {
						if (!1 === this.isInitialised)
							throw new Error(
								"Can't create config, layout not yet initialised"
							);
						return {
							dimensions: {
								width: this.getGlInstance().width,
								height: this.getGlInstance().height,
								left:
									this._popoutWindow.screenX ||
									this._popoutWindow.screenLeft,
								top:
									this._popoutWindow.screenY ||
									this._popoutWindow.screenTop,
							},
							content: this.getGlInstance().toConfig().content,
							parentId: this._parentId,
							indexInParent: this._indexInParent,
						};
					}
					getGlInstance() {
						return this._popoutWindow.__glInstance;
					}
					getWindow() {
						return this._popoutWindow;
					}
					close() {
						if (this.getGlInstance())
							this.getGlInstance()._$closeWindow();
						else
							try {
								this.getWindow().close();
							} catch (t) {}
					}
					popIn() {
						var t = this._indexInParent,
							n,
							o;
						this._parentId &&
							((n = e.extend(
								!0,
								{},
								this.getGlInstance().toConfig()
							).content[0]),
							(o = this._layoutManager.root.getItemsById(
								this._parentId
							)[0]),
							!o &&
								((o =
									0 <
									this._layoutManager.root.contentItems.length
										? this._layoutManager.root
												.contentItems[0]
										: this._layoutManager.root),
								(t = 0))),
							o.addChild(n, this._indexInParent),
							this.close();
					}
					_createWindow() {
						var n = this._createUrl(),
							o = t(1e6 * Math.random()).toString(36),
							a = this._serializeWindowOptions({
								width: this._dimensions.width,
								height: this._dimensions.height,
								innerWidth: this._dimensions.width,
								innerHeight: this._dimensions.height,
								menubar: "no",
								toolbar: "no",
								location: "no",
								personalbar: "no",
								resizable: "yes",
								scrollbars: "no",
								status: "no",
							}),
							i;
						if (
							((this._popoutWindow = window.open(n, o, a)),
							!this._popoutWindow)
						)
							if (
								!0 ===
								this._layoutManager.config.settings
									.blockedPopoutsThrowError
							) {
								var s = new Error("Popout blocked");
								throw ((s.type = "popoutBlocked"), s);
							} else return;
						e(this._popoutWindow)
							.on("load", Object(l.c)(this._positionWindow, this))
							.on(
								"unload beforeunload",
								Object(l.c)(this._onClose, this)
							),
							(i = setInterval(
								Object(l.c)(function () {
									this._popoutWindow.__glInstance &&
										this._popoutWindow.__glInstance
											.isInitialised &&
										(this._onInitialised(),
										clearInterval(i));
								}, this),
								10
							));
					}
					_serializeWindowOptions(e) {
						var t = [],
							n;
						for (n in e) t.push(n + "=" + e[n]);
						return t.join(",");
					}
					_createUrl() {
						var e = { content: this._config },
							t = "gl-window-config-" + Object(l.f)(),
							n;
						e = new r.a().minifyConfig(e);
						try {
							localStorage.setItem(t, i()(e));
						} catch (t) {
							throw new Error(
								"Error while writing to localStorage " +
									t.toString()
							);
						}
						return (
							(n = document.location.href.split("?")),
							1 === n.length
								? n[0] + "?gl-window=" + t
								: document.location.href + "&gl-window=" + t
						);
					}
					_positionWindow() {
						this._popoutWindow.moveTo(
							this._dimensions.left,
							this._dimensions.top
						),
							this._popoutWindow.focus();
					}
					_onInitialised() {
						(this.isInitialised = !0),
							this.getGlInstance().on("popIn", this.popIn, this),
							this.emit("initialised");
					}
					_onClose() {
						setTimeout(
							Object(l.c)(this.emit, this, ["closed"]),
							50
						);
					}
				}
				n.a = d;
			}).call(n, o(0));
		},
		function (e, t, n) {
			"use strict";
			Object.defineProperty(t, "__esModule", { value: !0 });
			var o = n(37),
				a = n.n(o),
				i = n(38),
				s = n.n(i),
				r = n(39),
				l = n.n(r),
				d = n(40);
			n.d(t, "default", function () {
				return d.a;
			});
			var c = n(34);
			n.d(t, "ItemContainer", function () {
				return c.a;
			});
			var p = n(35);
			n.d(t, "BrowserPopout", function () {
				return p.a;
			});
			var m = n(29);
			n.d(t, "Header", function () {
				return m.a;
			});
			var u = n(32);
			n.d(t, "HeaderButton", function () {
				return u.a;
			});
			var g = n(30);
			n.d(t, "Tab", function () {
				return g.a;
			});
			var h = n(33);
			n.d(t, "Component", function () {
				return h.a;
			});
			var f = n(13);
			n.d(t, "Root", function () {
				return f.a;
			});
			var _ = n(7);
			n.d(t, "RowOrColumn", function () {
				return _.a;
			});
			var y = n(14);
			n.d(t, "Stack", function () {
				return y.a;
			});
			var b = n(27);
			n.d(t, "BubblingEvent", function () {
				return b.a;
			});
			var v = n(12);
			n.d(t, "ConfigMinifier", function () {
				return v.a;
			});
			var x = n(8);
			n.d(t, "DragListener", function () {
				return x.a;
			});
			var k = n(2);
			n.d(t, "EventEmitter", function () {
				return k.b;
			});
			var w = n(26);
			n.d(t, "EventHub", function () {
				return w.a;
			});
			var I = n(25);
			n.d(t, "ReactComponentHandler", function () {
				return I.a;
			}),
				{
					npm_package_scripts_clean_dist: "del-cli dist",
					npm_config_cache_lock_stale: "60000",
					npm_config_ham_it_up: "",
					GIT_BINARY: "/usr/bin/git",
					SDKMAN_VERSION: "5.7.4+362",
					npm_package_devDependencies_babel_core: "^6.22.1",
					npm_package_devDependencies_chalk: "^2.3.2",
					npm_config_legacy_bundling: "",
					npm_config_sign_git_tag: "",
					J2SDKDIR: "/usr/lib/jvm/java-8-oracle",
					LC_TIME: "fi_FI.UTF-8",
					USER: "paulus",
					LANGUAGE: "en_US",
					_git_cmd: "/usr/bin/git",
					npm_package_directories_test: "test",
					npm_config_user_agent: "npm/6.14.6 node/v14.6.0 linux x64",
					npm_config_always_auth: "",
					XDG_SEAT: "seat0",
					TEXTDOMAIN: "im-config",
					npm_package_bugs_url:
						"https://github.com/deepstreamIO/golden-layout/issues",
					npm_package_devDependencies_concat_files: "^0.1.1",
					npm_package_devDependencies_less: "^3.0.1",
					npm_config_bin_links: "true",
					npm_config_key: "",
					XDG_SESSION_TYPE: "x11",
					SSH_AGENT_PID: "4293",
					npm_package_devDependencies_file_loader: "^1.1.6",
					npm_package_devDependencies_lodash: "^4.17.5",
					npm_package_optionalDependencies_react_dom:
						"14 || 15 || 16",
					npm_config_allow_same_version: "",
					npm_config_description: "true",
					npm_config_fetch_retries: "2",
					npm_config_heading: "npm",
					npm_config_if_present: "",
					npm_config_init_version: "1.0.0",
					npm_config_user: "1000",
					npm_node_execpath:
						"/home/paulus/.nvm/versions/node/v14.6.0/bin/node",
					J2REDIR: "/usr/lib/jvm/java-8-oracle/jre",
					SHLVL: "1",
					KIGITHUB: "https://github.com/KiCad",
					GREP_COLOR: "1;33",
					npm_package_dependencies_imports_loader: "^0.8.0",
					npm_package_devDependencies_babel_cli: "^6.26.0",
					npm_package_devDependencies_babel_preset_es2015: "^6.24.1",
					npm_package_devDependencies_esprima: "^4.0.0",
					npm_package_devDependencies_istanbul_instrumenter_loader:
						"^2.0.0",
					npm_package_devDependencies_url_loader: "^0.6.2",
					npm_config_prefer_online: "",
					npm_config_noproxy: "",
					QT4_IM_MODULE: "xim",
					OLDPWD: "/home/paulus/jloy/golden-layout",
					LESS: "R",
					HOME: "/home/paulus",
					npm_config_force: "",
					DESKTOP_SESSION: "i3-gnome",
					NVM_BIN: "/home/paulus/.nvm/versions/node/v14.6.0/bin",
					npm_package_devDependencies_del_cli: "^1.0.0",
					npm_config_only: "",
					npm_config_read_only: "",
					TERMINAL_EMULATOR: "JetBrains-JediTerm",
					GIO_LAUNCHED_DESKTOP_FILE:
						"/usr/share/applications/i3-gnome.desktop",
					ZSH: "/home/paulus/.oh-my-zsh",
					LSCOLORS: "exfxcxdxbxegedabagacad",
					npm_package_scripts_build_es6z:
						"npm run clean && cross-env STYLES=scss ES6=true ZEPTO=true webpack --progress --env.build --config webpack.config.dev.babel.js",
					npm_package_devDependencies_jasmine_core: "^2.5.2",
					npm_package_engines_node: ">=6.9.0",
					npm_package_npmName: "golden-layout",
					npm_config_cache_min: "10",
					npm_config_init_license: "ISC",
					GTK_MODULES: "gail:atk-bridge",
					XDG_SEAT_PATH: "/org/freedesktop/DisplayManager/Seat0",
					GNOME_SHELL_SESSION_MODE: "classic",
					PAGER: "less",
					npm_package_devDependencies_eslint_loader: "^1.6.1",
					npm_package_devDependencies_postcss_cssnext: "^3.0.2",
					npm_config_editor: "nvim",
					npm_config_rollback: "true",
					npm_config_tag_version_prefix: "v",
					LC_MONETARY: "fi_FI.UTF-8",
					LC_CTYPE: "en_US.UTF-8",
					npm_package_devDependencies_karma: "^1.5.0",
					npm_package_devDependencies_stylelint_config_standard:
						"^18.0.0",
					npm_package_jspm_format: "global",
					npm_config_cache_max: "Infinity",
					npm_config_timing: "",
					npm_config_userconfig: "/home/paulus/.npmrc",
					DBUS_SESSION_BUS_ADDRESS: "unix:path=/run/user/1000/bus",
					VISUAL: "nvim",
					e1: "/home/paulus/jloy/golden-layout/src/less/goldenlayout-light-theme.less",
					npm_package_keywords_0: "docker",
					npm_package_devDependencies_karma_chrome_launcher: "^2.0.0",
					npm_package_devDependencies_stylelint_scss: "^2.0.1",
					npm_config_engine_strict: "",
					npm_config_init_author_name: "",
					npm_config_init_author_url: "",
					npm_config_preid: "",
					npm_config_tmp: "/home/paulus/tmp",
					GIO_LAUNCHED_DESKTOP_FILE_PID: "4465",
					npm_package_description:
						"A multi-screen javascript Layout manager \r https://golden-layout.com",
					npm_package_keywords_1: "javascript",
					npm_package_devDependencies_babel_loader: "^7.0.0",
					npm_package_devDependencies_babel_minify_webpack_plugin:
						"^0.2.0",
					npm_package_devDependencies_karma_sourcemap_loader:
						"^0.3.7",
					npm_config_depth: "Infinity",
					npm_config_package_lock_only: "",
					npm_config_save_dev: "",
					npm_config_usage: "",
					NVM_DIR: "/home/paulus/.nvm",
					scmbDir: "/home/paulus/.scm_breeze",
					ga_auto_remove: "yes",
					npm_package_keywords_2: "layout",
					npm_package_homepage:
						"https://github.com/deepstreamIO/golden-layout",
					npm_package_devDependencies_karma_coverage: "^1.1.1",
					npm_package_npmFileMap_0_basePath: "/dist/",
					npm_package_readmeFilename: "README.md",
					npm_config_metrics_registry: "http://registry.npmjs.org/",
					npm_config_cafile: "",
					npm_config_otp: "",
					npm_config_package_lock: "true",
					npm_config_progress: "true",
					npm_config_https_proxy: "",
					npm_config_save_prod: "",
					QT_QPA_PLATFORMTHEME: "appmenu-qt5",
					MANDATORY_PATH: "/usr/share/gconf/i3-gnome.mandatory.path",
					IM_CONFIG_PHASE: "2",
					npm_package_keywords_3: "layout manager",
					npm_package_scripts_build_es6z_watch:
						"npm run clean && cross-env STYLES=scss ES6=true ZEPTO=true webpack --progress --env.build --env.build_watch --config webpack.config.dev.babel.js",
					npm_package_npmFileMap_1_basePath: "/src/css/",
					npm_config_audit: "true",
					npm_config_cidr: "",
					npm_config_onload_script: "",
					npm_config_sso_type: "oauth",
					GTK_IM_MODULE: "ibus",
					LOGNAME: "paulus",
					npm_package_keywords_4: "popouts",
					npm_package_scripts_clean: "npm-run-all clean:*",
					npm_package_devDependencies_eslint_plugin_import: "^2.2.0",
					npm_package_devDependencies_script_loader: "^0.7.2",
					npm_package_devDependencies_walker: "^1.0.7",
					npm_package_npmFileMap_2_basePath: "/",
					npm_config_rebuild_bundle: "true",
					npm_config_save_bundle: "",
					npm_config_shell: "/bin/zsh",
					DESKTOP_AUTOSTART_ID:
						"1063d9ceccbf39076159739422058130700000042940017",
					TEMP: "/home/paulus/tmp",
					SDKMAN_CANDIDATES_API: "https://api.sdkman.io/2",
					_: "/home/paulus/.nvm/versions/node/v14.6.0/bin/npm",
					npm_package_devDependencies_autoprefixer: "^7.0.1",
					npm_package_devDependencies_node_sass: "^4.5.2",
					npm_package_jspm_main: "dist/goldenlayout",
					npm_package_jspm_registry: "jspm",
					npm_config_dry_run: "",
					npm_config_format_package_lock: "true",
					npm_config_prefix:
						"/home/paulus/.nvm/versions/node/v14.6.0",
					DEFAULTS_PATH: "/usr/share/gconf/i3-gnome.default.path",
					npm_package_devDependencies_postcss_import: "^11.0.0",
					npm_config_scope: "",
					npm_config_registry: "http://registry.npmjs.org/",
					npm_config_browser: "",
					npm_config_cache_lock_wait: "10000",
					npm_config_ignore_prepublish: "",
					npm_config_save_optional: "",
					npm_config_searchopts: "",
					npm_config_versions: "",
					TERM: "xterm-256color",
					XDG_SESSION_ID: "c2",
					npm_package_devDependencies_browser_sync: "^2.18.8",
					npm_package_devDependencies_karma_jasmine_html_reporter:
						"^0.2.2",
					npm_package_devDependencies_stylelint: "^8.0.0",
					npm_package_optionalDependencies_react: "14 || 15 || 16",
					npm_package_jspm_dependencies_jquery: "^2.1.0",
					npm_config_cache: "/home/paulus/.npm",
					npm_config_proxy: "",
					npm_config_send_metrics: "",
					GNOME_DESKTOP_SESSION_ID: "this-is-deprecated",
					git_env_char: "e",
					GIT_REPOS: "",
					npm_package_scripts_start:
						"npm run clean && cross-env STYLES=scss ES6=true JQUERY=true webpack --progress --env.dev --config webpack.config.dev.babel.js",
					npm_package_devDependencies_babel_plugin_transform_class_properties:
						"^6.24.1",
					npm_package_devDependencies_html_webpack_plugin: "^2.28.0",
					npm_package_devDependencies_karma_webpack: "^2.0.2",
					npm_config_global_style: "",
					npm_config_ignore_scripts: "",
					npm_config_version: "",
					GTK2_MODULES: "overlay-scrollbar",
					GIT_REPO_DIR: "/home/paulus/code",
					npm_package_devDependencies_postcss_loader: "^2.0.5",
					npm_config_local_address: "",
					npm_config_viewer: "man",
					npm_config_node_gyp:
						"/home/paulus/.nvm/versions/node/v14.6.0/lib/node_modules/npm/node_modules/node-gyp/bin/node-gyp.js",
					PATH: "/home/paulus/.nvm/versions/node/v14.6.0/lib/node_modules/npm/node_modules/npm-lifecycle/node-gyp-bin:/home/paulus/jloy/golden-layout/node_modules/.bin:/home/paulus/.yarn/bin:/home/paulus/.config/yarn/global/node_modules/.bin:/home/paulus/gems/bin:/home/paulus/.sdkman/candidates/java/current/bin:/home/paulus/.nvm/versions/node/v14.6.0/bin:/home/paulus/.npm/bin:/home/paulus/backup_config/:/home/paulus/bin:/home/paulus/bin/geckodriver:/home/paulus/.gem/ruby/2.5.0/bin:/opt/mssql-tools/bin:/home/paulus/PycharmProjects/pyrestic/src:/home/paulus/jloy/golden-layout/node_modules/.bin:/home/paulus/.local/bin:/usr/bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/sbin:/bin:/usr/games:/usr/local/games:/snap/bin:/home/paulus/.dotnet/tools:/usr/lib/jvm/java-8-oracle/bin:/usr/lib/jvm/java-8-oracle/db/bin:/usr/lib/jvm/java-8-oracle/jre/bin:/home/paulus/.antigen/bundles/robbyrussell/oh-my-zsh/lib:/home/paulus/.antigen/bundles/robbyrussell/oh-my-zsh/plugins/git:/home/paulus/.antigen/bundles/zsh-users/zsh-autosuggestions:/home/paulus/.antigen/bundles/lukechilds/zsh-nvm:/home/paulus/.antigen/bundles/zsh-users/zsh-syntax-highlighting:/home/paulus/go/bin",
					GDM_LANG: "en_US",
					DERBY_HOME: "/usr/lib/jvm/java-8-oracle/db",
					SESSION_MANAGER:
						"local/ThinkPadL450:@/tmp/.ICE-unix/4294,unix/ThinkPadL450:/tmp/.ICE-unix/4294",
					ANDROID_EMULATOR_USE_SYSTEM_LIBS: "1",
					__INTELLIJ_COMMAND_HISTFILE__:
						"/home/paulus/.config/JetBrains/WebStorm2020.1/terminal/history/history-213",
					SDKMAN_CANDIDATES_DIR: "/home/paulus/.sdkman/candidates",
					npm_package_name: "golden-layout",
					npm_config_audit_level: "low",
					npm_config_prefer_offline: "",
					NODE: "/home/paulus/.nvm/versions/node/v14.6.0/bin/node",
					S_COLORS: "auto",
					XDG_RUNTIME_DIR: "/run/user/1000",
					XDG_MENU_PREFIX: "gnome-",
					LC_ADDRESS: "fi_FI.UTF-8",
					XDG_SESSION_PATH:
						"/org/freedesktop/DisplayManager/Session0",
					npm_package_scripts_lint_autofix:
						"stylelint src/scss/**/*.scss --fix && eslint src/js_es6 --fix",
					npm_package_devDependencies_eslint_plugin_jsx_a11y:
						"^6.0.2",
					npm_config_color: "true",
					npm_config_sign_git_commit: "",
					DISPLAY: ":0",
					npm_package_devDependencies_eslint_config_airbnb: "^16.1.0",
					npm_package_devDependencies_pug_html_loader: "^1.1.0",
					npm_config_fetch_retry_mintimeout: "10000",
					npm_config_maxsockets: "50",
					npm_config_offline: "",
					npm_config_sso_poll_frequency: "500",
					LANG: "en_US.UTF-8",
					XDG_CURRENT_DESKTOP: "GNOME",
					DESKTOP_STARTUP_ID:
						'i3/"|home|paulus|.local|share|JetBrains|Toolbox|apps|WebStorm|ch-0|201.8743.9|bin|webstorm.sh"/4516-1-ThinkPadL450_TIME186559',
					LC_TELEPHONE: "fi_FI.UTF-8",
					IBUS_ENABLE_SYNC_MODE: "1",
					git_status_command: "git_status_shortcuts",
					npm_package_dependencies_react_dom: "14 || 15 || 16",
					npm_package_devDependencies_eslint: "^4.1.1",
					npm_package_devDependencies_webpack: "^3.0.0",
					npm_config_umask: "0002",
					XMODIFIERS: "@im=ibus",
					XAUTHORITY: "/home/paulus/.Xauthority",
					XDG_SESSION_DESKTOP: "i3-gnome",
					LS_COLORS:
						"di=34;40:ln=35;40:so=32;40:pi=33;40:ex=31;40:bd=34;46:cd=34;43:su=0;41:sg=0;46:tw=0;42:ow=0;43:",
					SDKMAN_DIR: "/home/paulus/.sdkman",
					SDKMAN_PLATFORM: "Linux64",
					npm_package_main: "webpack.config.dev.babel.js",
					npm_package_devDependencies_copy_webpack_plugin: "^4.5.1",
					npm_package_devDependencies_html_loader: "^0.5.0",
					npm_package_gitHead:
						"bbf0f24afa8c14a763fb9c85b6eca7f4f6c0edc9",
					npm_config_fund: "true",
					npm_config_fetch_retry_maxtimeout: "60000",
					npm_config_loglevel: "notice",
					npm_config_logs_max: "10",
					npm_config_message: "%s",
					npm_lifecycle_script:
						"npm run clean && cross-env STYLES=scss ES6=true JQUERY=true webpack --progress --env.build --config webpack.config.dev.babel.js",
					SSH_AUTH_SOCK: "/run/user/1000/keyring/ssh",
					XDG_GREETER_DATA_DIR: "/var/lib/lightdm-data/paulus",
					root_design_dir: "/home/paulus/Dropbox/Design",
					npm_package_scripts_test:
						"cross-env ES6=true JQUERY=true karma start",
					npm_package_devDependencies_exports_loader: "^0.6.3",
					npm_package_devDependencies_webpack_dev_server: "^2.3.0",
					npm_config_ca: "",
					npm_config_cert: "",
					npm_config_global: "",
					npm_config_link: "",
					SHELL: "/bin/zsh",
					LC_NAME: "fi_FI.UTF-8",
					GOPATH: "/home/paulus/go",
					npm_package_version: "1.5.9",
					npm_package_dependencies_jquery: "^3.3.1",
					npm_package_devDependencies_less_loader: "^4.1.0",
					npm_config_access: "",
					npm_config_also: "",
					npm_config_save: "true",
					npm_config_unicode: "true",
					npm_lifecycle_event: "build",
					GDMSESSION: "i3-gnome",
					QT_ACCESSIBILITY: "1",
					project_design_dir: "design_assets",
					npm_package_scripts_build:
						"npm run clean && cross-env STYLES=scss ES6=true JQUERY=true webpack --progress --env.build --config webpack.config.dev.babel.js",
					npm_package_devDependencies_tslib: "^1.10.0",
					npm_config_argv:
						'{"remain":[],"cooked":["run-script","build"],"original":["run-script","build"]}',
					npm_config_before: "",
					npm_config_long: "",
					npm_config_production: "",
					npm_config_searchlimit: "20",
					npm_config_unsafe_perm: "true",
					npm_config_update_notifier: "true",
					git_setup_aliases: "yes",
					GEM_HOME: "/home/paulus/gems",
					npm_package_devDependencies_karma_jasmine: "^1.1.0",
					npm_config_auth_type: "legacy",
					npm_config_node_version: "14.6.0",
					npm_config_tag: "latest",
					LC_MEASUREMENT: "fi_FI.UTF-8",
					gs_max_changes: "150",
					npm_package_devDependencies_sass_loader: "^6.0.0",
					npm_config_git_tag_version: "true",
					npm_config_commit_hooks: "true",
					npm_config_script_shell: "",
					npm_config_shrinkwrap: "true",
					GPG_AGENT_INFO: "/run/user/1000/gnupg/S.gpg-agent:0:1",
					TEXTDOMAINDIR: "/usr/share/locale/",
					LC_IDENTIFICATION: "fi_FI.UTF-8",
					design_av_dirs: "Animations Videos Flash Music Samples",
					npm_package_license: "MIT",
					npm_package_devDependencies_eslint_plugin_react: "^7.3.0",
					npm_config_fetch_retry_factor: "10",
					npm_config_save_exact: "",
					npm_config_strict_ssl: "true",
					QT_IM_MODULE: "ibus",
					XDG_VTNR: "7",
					BACKUPS_SRC: "/home/paulus/PycharmProjects/pyrestic/src",
					design_base_dirs:
						"Documents Flowcharts Images Backgrounds Logos Icons Mockups Screenshots",
					npm_package_scripts_coverage:
						"ES6=true JQUERY=true karma start --single-run --no-auto-watch --coverage=true || echo done",
					npm_package_devDependencies_babel_preset_stage_2: "^6.24.1",
					npm_package_devDependencies_loader_utils: "^1.1.0",
					npm_package_devDependencies_style_loader: "^0.20.1",
					npm_config_dev: "",
					npm_config_globalconfig:
						"/home/paulus/.nvm/versions/node/v14.6.0/etc/npmrc",
					npm_config_init_module: "/home/paulus/.npm-init.js",
					npm_config_parseable: "",
					KICAD_PATH: "/usr/share/kicad",
					JAVA_HOME: "/home/paulus/.sdkman/candidates/java/current",
					PWD: "/home/paulus/jloy/golden-layout",
					npm_package_jspm_shim_dist_goldenlayout_0: "jquery",
					npm_config_globalignorefile:
						"/home/paulus/.nvm/versions/node/v14.6.0/etc/npmignore",
					npm_execpath:
						"/home/paulus/.nvm/versions/node/v14.6.0/lib/node_modules/npm/bin/npm-cli.js",
					XDG_CONFIG_DIRS: "/etc/xdg/xdg-i3-gnome:/etc/xdg",
					CLUTTER_IM_MODULE: "xim",
					XDG_DATA_DIRS:
						"/usr/share/gnome:/usr/share/i3-gnome:/usr/local/share:/usr/share:/var/lib/snapd/desktop:/var/lib/snapd/desktop",
					ZDOTDIR: "",
					NVM_CD_FLAGS: "-q",
					KEYTIMEOUT: "1",
					npm_package_author_name: "deepstreamHub GmbH",
					npm_package_scripts_build_watch:
						"npm run clean && cross-env STYLES=scss ES6=true JQUERY=true webpack --progress --env.build --env.build_watch --config webpack.config.dev.babel.js",
					npm_package_scripts_prestart:
						"npm-run-all --parallel clean",
					npm_package_dependencies_zepto: "^1.2.0",
					npm_package_devDependencies_css_loader: "^0.28.0",
					npm_package_devDependencies_image_webpack_loader: "^4.0.0",
					npm_package_devDependencies_jasmine: "^2.5.3",
					npm_config_cache_lock_retries: "10",
					npm_config_searchstaleness: "900",
					LC_NUMERIC: "fi_FI.UTF-8",
					npm_package_typings: "./index.d.ts",
					npm_package_devDependencies_babel_preset_env: "^1.6.0",
					npm_package_devDependencies_cross_env: "^5.1.5",
					npm_package_devDependencies_extract_text_webpack_plugin:
						"^3.0.2",
					npm_package_npmFileMap_0_files_0: "goldenlayout.js",
					npm_config_node_options: "",
					npm_config_save_prefix: "^",
					npm_config_scripts_prepend_node_path: "warn-only",
					LC_PAPER: "fi_FI.UTF-8",
					design_ext_dirs: "Fonts IconSets",
					npm_package_devDependencies_babel_eslint: "^8.2.1",
					npm_package_devDependencies_babel_plugin_transform_runtime:
						"^6.22.0",
					npm_package_devDependencies_babel_runtime: "^6.22.0",
					npm_package_devDependencies_browser_sync_webpack_plugin:
						"^1.1.4",
					npm_package_devDependencies_stylelint_webpack_plugin:
						"^0.10.1",
					npm_package_npmFileMap_0_files_1: "goldenlayout.min.js",
					npm_package_npmFileMap_1_files_0: "goldenlayout.base.css",
					npm_config_group: "1000",
					npm_config_init_author_email: "",
					npm_config_searchexclude: "",
					npm_package_devDependencies_ignore_loader: "^0.1.2",
					npm_package_devDependencies_npm_run_all: "^4.0.1",
					npm_package_devDependencies_postcss_extend: "^1.0.5",
					npm_package_npmFileMap_1_files_1:
						"goldenlayout-dark-theme.css",
					npm_package_npmFileMap_2_files_0: "typings.json",
					npm_config_git: "git",
					npm_config_optional: "true",
					EDITOR: "nvim",
					npm_package_scripts_start_es6z:
						"npm run clean && cross-env STYLES=scss ES6=true ZEPTO=true webpack --progress --env.dev --config webpack.config.dev.babel.js",
					npm_package_dependencies_react: "14 || 15 || 16",
					npm_package_devDependencies_postcss_reporter: "^5.0.0",
					npm_package_npmFileMap_1_files_2:
						"goldenlayout-light-theme.css",
					npm_config_json: "",
					INIT_CWD: "/home/paulus/jloy/golden-layout",
					STYLES: "scss",
					ES6: "true",
					JQUERY: "true",
				}.ZEPTO && (n(75), n(78));
		},
		function () {},
		function () {},
		function () {},
		function (e, n, a) {
			"use strict";
			(function (e) {
				var i = a(2),
					s = a(25),
					r = a(12),
					l = a(26),
					d = a(13),
					c = a(7),
					p = a(14),
					m = a(33),
					u = a(4),
					g = a(35),
					h = a(71),
					f = a(72),
					_ = a(73),
					y = a(28),
					b = a(74),
					v = a(1);
				class x extends i.b {
					constructor(t, n) {
						if (!e) {
							var o =
								"jQuery is missing as dependency for GoldenLayout. ";
							throw (
								((o +=
									'Please either expose $ on GoldenLayout\'s scope (e.g. window) or add "jquery" to '),
								(o += "your paths when using RequireJS/AMD"),
								new Error(o))
							);
						}
						super(),
							(this.isInitialised = !1),
							(this._isFullPage = !1),
							(this._resizeTimeoutId = null),
							(this._components = { "lm-react-component": s.a }),
							(this._itemAreas = []),
							(this._resizeFunction = Object(v.c)(
								this._onResize,
								this
							)),
							(this._unloadFunction = Object(v.c)(
								this._onUnload,
								this
							)),
							(this._maximisedItem = null),
							(this._maximisePlaceholder = e(
								'<div class="lm_maximise_place"></div>'
							)),
							(this._creationTimeoutPassed = !1),
							(this._subWindowsCreated = !1),
							(this._dragSources = []),
							(this._updatingColumnsResponsive = !1),
							(this._firstLoad = !0),
							(this.width = null),
							(this.height = null),
							(this.root = null),
							(this.openPopouts = []),
							(this.selectedItem = null),
							(this.isSubWindow = !1),
							(this.eventHub = new l.a(this)),
							(this.config = this._createConfig(t)),
							(this.container = n),
							(this.dropTargetIndicator = null),
							(this.transitionIndicator = null),
							(this.tabDropPlaceholder = e(
								'<div class="lm_drop_tab_placeholder"></div>'
							)),
							!0 === this.isSubWindow &&
								e("body").css("visibility", "hidden"),
							(this._typeToItem = {
								column: Object(v.c)(c.a, this, [!0]),
								row: Object(v.c)(c.a, this, [!1]),
								stack: p.a,
								component: m.a,
							});
					}
					minifyConfig(e) {
						return new r.a().minifyConfig(e);
					}
					unminifyConfig(e) {
						return new r.a().unminifyConfig(e);
					}
					registerComponent(e, t) {
						if ("function" != typeof t)
							throw new Error(
								"Please register a constructor function"
							);
						if (void 0 !== this._components[e])
							throw new Error(
								"Component " + e + " is already registered"
							);
						this._components[e] = t;
					}
					toConfig(e) {
						var t, n, o;
						if (!1 === this.isInitialised)
							throw new Error(
								"Can't create config, layout not yet initialised"
							);
						if (e && !(e instanceof u.a))
							throw new Error("Root must be a ContentItem");
						for (
							t = {
								settings: Object(v.b)({}, this.config.settings),
								dimensions: Object(v.b)(
									{},
									this.config.dimensions
								),
								labels: Object(v.b)({}, this.config.labels),
							},
								t.content = [],
								n = function (e, t) {
									var o, a;
									for (o in t.config)
										"content" !== o && (e[o] = t.config[o]);
									if (t.contentItems.length)
										for (
											e.content = [], a = 0;
											a < t.contentItems.length;
											a++
										)
											(e.content[a] = {}),
												n(
													e.content[a],
													t.contentItems[a]
												);
								},
								e
									? n(t, { contentItems: [e] })
									: n(t, this.root),
								this._$reconcilePopoutWindows(),
								t.openPopouts = [],
								o = 0;
							o < this.openPopouts.length;
							o++
						)
							t.openPopouts.push(this.openPopouts[o].toConfig());
						return (
							(t.maximisedItemId = this._maximisedItem
								? "__glMaximised"
								: null),
							t
						);
					}
					getComponent(e) {
						if (this._components[e] === void 0)
							throw new y.a('Unknown component "' + e + '"');
						return this._components[e];
					}
					init() {
						return (
							!1 === this._subWindowsCreated &&
								(this._createSubWindows(),
								(this._subWindowsCreated = !0)),
							!0 === this.isSubWindow &&
							!1 === this._creationTimeoutPassed
								? (setTimeout(Object(v.c)(this.init, this), 7),
								  void (this._creationTimeoutPassed = !0))
								: void (!0 === this.isSubWindow &&
										this._adjustToWindowMode(),
								  this._setContainer(),
								  (this.dropTargetIndicator = new f.a(
										this.container
								  )),
								  (this.transitionIndicator = new _.a(
										this.container
								  )),
								  this.updateSize(),
								  this._create(this.config),
								  this._bindEvents(),
								  (this.isInitialised = !0),
								  this._adjustColumnsResponsive(),
								  this.emit("initialised"))
						);
					}
					updateSize(e, t) {
						2 === arguments.length
							? ((this.width = e), (this.height = t))
							: ((this.width = this.container.width()),
							  (this.height = this.container.height())),
							!0 === this.isInitialised &&
								(this.root.callDownwards("setSize", [
									this.width,
									this.height,
								]),
								this._maximisedItem &&
									(this._maximisedItem.element.width(
										this.container.width()
									),
									this._maximisedItem.element.height(
										this.container.height()
									),
									this._maximisedItem.callDownwards(
										"setSize"
									)),
								this._adjustColumnsResponsive());
					}
					destroy() {
						!1 === this.isInitialised ||
							(this._onUnload(),
							e(window).off("resize", this._resizeFunction),
							e(window).off(
								"unload beforeunload",
								this._unloadFunction
							),
							this.root.callDownwards("_$destroy", [], !0),
							(this.root.contentItems = []),
							this.tabDropPlaceholder.remove(),
							this.dropTargetIndicator.destroy(),
							this.transitionIndicator.destroy(),
							this.eventHub.destroy(),
							this._dragSources.forEach(function (e) {
								e._dragListener.destroy(),
									(e._element = null),
									(e._itemConfig = null),
									(e._dragListener = null);
							}),
							(this._dragSources = []));
					}
					createContentItem(e, t) {
						var n, o;
						if ("string" != typeof e.type)
							throw new y.a("Missing parameter 'type'", e);
						if (
							("react-component" === e.type &&
								((e.type = "component"),
								(e.componentName = "lm-react-component")),
							!this._typeToItem[e.type])
						)
							throw (
								((n =
									"Unknown type '" +
									e.type +
									"'. Valid types are " +
									Object(v.j)(this._typeToItem).join(",")),
								new y.a(n))
							);
						return (
							"component" !== e.type ||
								t instanceof p.a ||
								!t ||
								(!0 === this.isSubWindow && t instanceof d.a) ||
								(e = {
									type: "stack",
									width: e.width,
									height: e.height,
									content: [e],
								}),
							(o = new this._typeToItem[e.type](this, e, t)),
							o
						);
					}
					createPopout(e, t, n, o) {
						var a = e,
							i = e instanceof u.a,
							s = this,
							r,
							l,
							d,
							c,
							p,
							m;
						if (((n = n || null), i)) {
							for (
								a = this.toConfig(e).content,
									n = Object(v.f)(),
									c = e.parent,
									p = e;
								1 === c.contentItems.length && !c.isRoot;

							)
								(c = c.parent), (p = p.parent);
							c.addId(n),
								isNaN(o) &&
									(o = Object(v.g)(p, c.contentItems));
						} else a instanceof Array || (a = [a]);
						return (
							!t &&
								i &&
								((r = window.screenX || window.screenLeft),
								(l = window.screenY || window.screenTop),
								(d = e.element.offset()),
								(t = {
									left: r + d.left,
									top: l + d.top,
									width: e.element.width(),
									height: e.element.height(),
								})),
							t ||
								i ||
								(t = {
									left:
										window.screenX ||
										window.screenLeft + 20,
									top:
										window.screenY || window.screenTop + 20,
									width: 500,
									height: 309,
								}),
							i && e.remove(),
							(m = new g.a(a, t, n, o, this)),
							m.on("initialised", function () {
								s.emit("windowOpened", m);
							}),
							m.on("closed", function () {
								s._$reconcilePopoutWindows();
							}),
							this.openPopouts.push(m),
							m
						);
					}
					createDragSource(t, n) {
						this.config.settings.constrainDragToContainer = !1;
						var o = new h.a(e(t), n, this);
						return this._dragSources.push(o), o;
					}
					removeDragSource(e) {
						e.destroy(),
							lm.utils.removeFromArray(e, this._dragSources);
					}
					selectItem(e, t) {
						if (!0 !== this.config.settings.selectionEnabled)
							throw new Error(
								"Please set selectionEnabled to true to use this feature"
							);
						e === this.selectedItem ||
							(null !== this.selectedItem &&
								this.selectedItem.deselect(),
							e && !0 !== t && e.select(),
							(this.selectedItem = e),
							this.emit("selectionChanged", e));
					}
					_$maximiseItem(e) {
						null !== this._maximisedItem &&
							this._$minimiseItem(this._maximisedItem),
							(this._maximisedItem = e),
							e.on(
								"beforeItemDestroyed",
								this._$cleanupBeforeMaximisedItemDestroyed,
								this
							),
							this._maximisedItem.addId("__glMaximised"),
							e.element.addClass("lm_maximised"),
							e.element.after(this._maximisePlaceholder),
							this.root.element.prepend(e.element),
							e.element.width(this.container.width()),
							e.element.height(this.container.height()),
							e.callDownwards("setSize"),
							this._maximisedItem.emit("maximised"),
							this.emit("stateChanged");
					}
					_$minimiseItem(e) {
						e.element.removeClass("lm_maximised"),
							e.removeId("__glMaximised"),
							this._maximisePlaceholder.after(e.element),
							this._maximisePlaceholder.remove(),
							e.parent.callDownwards("setSize"),
							(this._maximisedItem = null),
							e.off(
								"beforeItemDestroyed",
								this._$cleanupBeforeMaximisedItemDestroyed,
								this
							),
							e.emit("minimised"),
							this.emit("stateChanged");
					}
					_$cleanupBeforeMaximisedItemDestroyed() {
						this._maximisedItem === event.origin &&
							(this._maximisedItem.off(
								"beforeItemDestroyed",
								this._$cleanupBeforeMaximisedItemDestroyed,
								this
							),
							(this._maximisedItem = null));
					}
					_$closeWindow() {
						window.setTimeout(function () {
							window.close();
						}, 1);
					}
					_$getArea(e, t) {
						var n = Infinity,
							o = null,
							a,
							i;
						for (a = 0; a < this._itemAreas.length; a++)
							(i = this._itemAreas[a]),
								e > i.x1 &&
									e < i.x2 &&
									t > i.y1 &&
									t < i.y2 &&
									n > i.surface &&
									((n = i.surface), (o = i));
						return o;
					}
					_$createRootItemAreas() {
						var e = 50,
							t = { y2: "y1", x2: "x1", y1: "y2", x1: "x2" };
						for (var n in t) {
							var o = this.root._$getArea();
							(o.side = n),
								(o[n] =
									"2" === t[n][1]
										? o[t[n]] - e
										: o[t[n]] + e),
								(o.surface = (o.x2 - o.x1) * (o.y2 - o.y1)),
								this._itemAreas.push(o);
						}
					}
					_$calculateItemAreas() {
						var e = this._getAllContentItems(),
							t,
							n;
						if (((this._itemAreas = []), 1 === e.length))
							return void this._itemAreas.push(
								this.root._$getArea()
							);
						for (
							this._$createRootItemAreas(), t = 0;
							t < e.length;
							t++
						)
							if (e[t].isStack)
								if (((n = e[t]._$getArea()), null === n))
									continue;
								else if (n instanceof Array)
									this._itemAreas = this._itemAreas.concat(n);
								else {
									this._itemAreas.push(n);
									var o = {};
									Object(v.b)(o, n),
										Object(v.b)(
											o,
											n.contentItem._contentAreaDimensions
												.header.highlightArea
										),
										(o.surface =
											(o.x2 - o.x1) * (o.y2 - o.y1)),
										this._itemAreas.push(o);
								}
					}
					_$normalizeContentItem(t, n) {
						if (!t) throw new Error("No content item defined");
						if ((Object(v.h)(t) && (t = t()), t instanceof u.a))
							return t;
						if (e.isPlainObject(t) && t.type) {
							var o = this.createContentItem(t, n);
							return o.callDownwards("_$init"), o;
						}
						throw new Error("Invalid contentItem");
					}
					_$reconcilePopoutWindows() {
						var e = [],
							t;
						for (t = 0; t < this.openPopouts.length; t++)
							!1 === this.openPopouts[t].getWindow().closed
								? e.push(this.openPopouts[t])
								: this.emit(
										"windowClosed",
										this.openPopouts[t]
								  );
						this.openPopouts.length !== e.length &&
							((this.openPopouts = e), this.emit("stateChanged"));
					}
					_getAllContentItems() {
						var e = [],
							t = function (n) {
								if (
									(e.push(n), n.contentItems instanceof Array)
								)
									for (
										var o = 0;
										o < n.contentItems.length;
										o++
									)
										t(n.contentItems[o]);
							};
						return t(this.root), e;
					}
					_bindEvents() {
						this._isFullPage &&
							e(window).resize(this._resizeFunction),
							e(window).on(
								"unload beforeunload",
								this._unloadFunction
							);
					}
					_onResize() {
						clearTimeout(this._resizeTimeoutId),
							(this._resizeTimeoutId = setTimeout(
								Object(v.c)(this.updateSize, this),
								100
							));
					}
					_createConfig(t) {
						var n = Object(v.d)("gl-window");
						n &&
							((this.isSubWindow = !0),
							(t = localStorage.getItem(n)),
							(t = JSON.parse(t)),
							(t = new r.a().unminifyConfig(t)),
							localStorage.removeItem(n)),
							(t = e.extend(!0, {}, b.a, t));
						var o = function (e) {
							for (var t in e)
								"props" != t && "object" == typeof e[t]
									? o(e[t])
									: "type" == t &&
									  "react-component" === e[t] &&
									  ((e.type = "component"),
									  (e.componentName = "lm-react-component"));
						};
						return (
							o(t),
							!1 === t.settings.hasHeaders &&
								(t.dimensions.headerHeight = 0),
							t
						);
					}
					_adjustToWindowMode() {
						var t = e(
							'<div class="lm_popin" title="' +
								this.config.labels.popin +
								'"><div class="lm_icon"></div><div class="lm_bg"></div></div>'
						);
						t.click(
							Object(v.c)(function () {
								this.emit("popIn");
							}, this)
						),
							(document.title = Object(v.k)(
								this.config.content[0].title
							)),
							e("head").append(
								e("body link, body style, template, .gl_keep")
							),
							(this.container = e("body")
								.html("")
								.css("visibility", "visible")
								.append(t)),
							(window.__glInstance = this);
					}
					_createSubWindows() {
						var e, t;
						for (e = 0; e < this.config.openPopouts.length; e++)
							(t = this.config.openPopouts[e]),
								this.createPopout(
									t.content,
									t.dimensions,
									t.parentId,
									t.indexInParent
								);
					}
					_setContainer() {
						var t = e(this.container || "body");
						if (0 === t.length)
							throw new Error("GoldenLayout container not found");
						if (1 < t.length)
							throw new Error(
								"GoldenLayout more than one container element specified"
							);
						this.container = t;
					}
					_create(e) {
						var t;
						if (!(e.content instanceof Array))
							throw (
								((t =
									void 0 === e.content
										? "Missing setting 'content' on top level of configuration"
										: "Configuration parameter 'content' must be an array"),
								new y.a(t, e))
							);
						if (1 < e.content.length)
							throw (
								((t =
									"Top level content can't contain more then one element."),
								new y.a(t, e))
							);
						(this.root = new d.a(
							this,
							{ content: e.content },
							this.container
						)),
							this.root.callDownwards("_$init"),
							"__glMaximised" === e.maximisedItemId &&
								this.root
									.getItemsById(e.maximisedItemId)[0]
									.toggleMaximise();
					}
					_onUnload() {
						if (!0 === this.config.settings.closePopoutsOnUnload)
							for (var e = 0; e < this.openPopouts.length; e++)
								this.openPopouts[e].close();
					}
					_adjustColumnsResponsive() {
						if (
							!this._useResponsiveLayout() ||
							this._updatingColumnsResponsive ||
							!this.config.dimensions ||
							!this.config.dimensions.minItemWidth ||
							0 === this.root.contentItems.length ||
							!this.root.contentItems[0].isRow
						)
							return void (this._firstLoad = !1);
						if (((this._firstLoad = !1), 0 !== this.width)) {
							var e =
								this.root.contentItems[0].contentItems.length;
							if (!(1 >= e)) {
								var n = this.config.dimensions.minItemWidth;
								if (!(e * n <= this.width)) {
									this._updatingColumnsResponsive = !0;
									for (
										var a = o(t(this.width / n), 1),
											s = this.root.contentItems[0],
											r =
												this._findAllStackContainers()[0],
											l = 0,
											i;
										l < e - a;
										l++
									)
										(i =
											s.contentItems[
												s.contentItems.length - 1
											]),
											this._addChildContentItemsToContainer(
												r,
												i
											);
									this._updatingColumnsResponsive = !1;
								}
							}
						}
					}
					_useResponsiveLayout() {
						return (
							this.config.settings &&
							("always" == this.config.settings.responsiveMode ||
								("onload" ==
									this.config.settings.responsiveMode &&
									this._firstLoad))
						);
					}
					_addChildContentItemsToContainer(e, t) {
						"stack" === t.type
							? t.contentItems.forEach(function (n) {
									e.addChild(n), t.removeChild(n, !0);
							  })
							: t.contentItems.forEach(
									Object(v.c)(function (t) {
										this._addChildContentItemsToContainer(
											e,
											t
										);
									}, this)
							  );
					}
					_findAllStackContainers() {
						var e = [];
						return (
							this._findAllStackContainersRecursive(e, this.root),
							e
						);
					}
					_findAllStackContainersRecursive(e, t) {
						t.contentItems.forEach(
							Object(v.c)(function (t) {
								"stack" == t.type
									? e.push(t)
									: !t.isComponent &&
									  this._findAllStackContainersRecursive(
											e,
											t
									  );
							}, this)
						);
					}
				}
				n.a = x;
			}).call(n, a(0));
		},
		function (e, t, n) {
			e.exports = { default: n(42), __esModule: !0 };
		},
		function (e, t, n) {
			n(43), (e.exports = n(3).Object.keys);
		},
		function (e, t, n) {
			var o = n(44),
				a = n(16);
			n(54)("keys", function () {
				return function (e) {
					return a(o(e));
				};
			});
		},
		function (e, t, n) {
			var o = n(15);
			e.exports = function (e) {
				return Object(o(e));
			};
		},
		function (e, t, n) {
			var o = n(17),
				a = n(18),
				s = n(48)(!1),
				i = n(20)("IE_PROTO");
			e.exports = function (e, t) {
				var n = a(e),
					r = 0,
					l = [],
					d;
				for (d in n) d != i && o(n, d) && l.push(d);
				for (; t.length > r; )
					o(n, (d = t[r++])) && (~s(l, d) || l.push(d));
				return l;
			};
		},
		function (e, t, n) {
			var o = n(47);
			e.exports = Object("z").propertyIsEnumerable(0)
				? Object
				: function (e) {
						return "String" == o(e) ? e.split("") : Object(e);
				  };
		},
		function (e) {
			var t = {}.toString;
			e.exports = function (e) {
				return t.call(e).slice(8, -1);
			};
		},
		function (e, t, n) {
			var o = n(18),
				a = n(49),
				i = n(50);
			e.exports = function (e) {
				return function (t, n, s) {
					var r = o(t),
						l = a(r.length),
						d = i(s, l),
						c;
					if (e && n != n) {
						for (; l > d; ) if (((c = r[d++]), c != c)) return !0;
					} else
						for (; l > d; d++)
							if ((e || d in r) && r[d] === n) return e || d || 0;
					return !e && -1;
				};
			};
		},
		function (t, n, o) {
			var a = o(19);
			t.exports = function (t) {
				return 0 < t ? e(a(t), 9007199254740991) : 0;
			};
		},
		function (t, n, a) {
			var i = a(19);
			t.exports = function (t, n) {
				return (t = i(t)), 0 > t ? o(t + n, 0) : e(t, n);
			};
		},
		function (e, t, n) {
			var o = n(3),
				a = n(5),
				i = "__core-js_shared__",
				s = a[i] || (a[i] = {});
			(e.exports = function (e, t) {
				return s[e] || (s[e] = t === void 0 ? {} : t);
			})("versions", []).push({
				version: o.version,
				mode: n(52) ? "pure" : "global",
				copyright: "\xA9 2019 Denis Pushkarev (zloirock.ru)",
			});
		},
		function (e) {
			e.exports = !0;
		},
		function (e) {
			var t = 0,
				n = Math.random();
			e.exports = function (e) {
				return "Symbol(".concat(
					e === void 0 ? "" : e,
					")_",
					(++t + n).toString(36)
				);
			};
		},
		function (e, t, n) {
			var o = n(22),
				a = n(3),
				i = n(11);
			e.exports = function (e, t) {
				var n = (a.Object || {})[e] || Object[e],
					s = {};
				(s[e] = t(n)),
					o(
						o.S +
							o.F *
								i(function () {
									n(1);
								}),
						"Object",
						s
					);
			};
		},
		function (e, t, n) {
			var o = n(56);
			e.exports = function (e, t, n) {
				return (o(e), void 0 === t)
					? e
					: 1 === n
					? function (n) {
							return e.call(t, n);
					  }
					: 2 === n
					? function (n, o) {
							return e.call(t, n, o);
					  }
					: 3 === n
					? function (n, o, a) {
							return e.call(t, n, o, a);
					  }
					: function () {
							return e.apply(t, arguments);
					  };
			};
		},
		function (e) {
			e.exports = function (e) {
				if ("function" != typeof e)
					throw TypeError(e + " is not a function!");
				return e;
			};
		},
		function (e, t, n) {
			var o = n(23),
				a = n(60);
			e.exports = n(6)
				? function (e, t, n) {
						return o.f(e, t, a(1, n));
				  }
				: function (e, t, n) {
						return (e[t] = n), e;
				  };
		},
		function (e, t, n) {
			e.exports =
				!n(6) &&
				!n(11)(function () {
					return (
						7 !=
						Object.defineProperty(n(24)("div"), "a", {
							get: function () {
								return 7;
							},
						}).a
					);
				});
		},
		function (e, t, n) {
			var o = n(10);
			e.exports = function (e, t) {
				if (!o(e)) return e;
				var n, a;
				if (
					t &&
					"function" == typeof (n = e.toString) &&
					!o((a = n.call(e)))
				)
					return a;
				if ("function" == typeof (n = e.valueOf) && !o((a = n.call(e))))
					return a;
				if (
					!t &&
					"function" == typeof (n = e.toString) &&
					!o((a = n.call(e)))
				)
					return a;
				throw TypeError("Can't convert object to primitive value");
			};
		},
		function (e) {
			e.exports = function (e, t) {
				return {
					enumerable: !(1 & e),
					configurable: !(2 & e),
					writable: !(4 & e),
					value: t,
				};
			};
		},
		function (e, t, n) {
			e.exports = { default: n(62), __esModule: !0 };
		},
		function (e, t, n) {
			n(63);
			var o = n(3).Object;
			e.exports = function (e, t) {
				return o.create(e, t);
			};
		},
		function (e, t, n) {
			var o = n(22);
			o(o.S, "Object", { create: n(64) });
		},
		function (e, t, n) {
			var o = n(9),
				a = n(65),
				s = n(21),
				i = n(20)("IE_PROTO"),
				r = function () {},
				l = "prototype",
				d = function () {
					var e = n(24)("iframe"),
						t = s.length,
						o = "<",
						a = ">",
						i;
					for (
						e.style.display = "none",
							n(66).appendChild(e),
							e.src = "javascript:",
							i = e.contentWindow.document,
							i.open(),
							i.write(
								o +
									"script" +
									a +
									"document.F=Object" +
									o +
									"/script" +
									a
							),
							i.close(),
							d = i.F;
						t--;

					)
						delete d[l][s[t]];
					return d();
				};
			e.exports =
				Object.create ||
				function (e, t) {
					var n;
					return (
						null === e
							? (n = d())
							: ((r[l] = o(e)),
							  (n = new r()),
							  (r[l] = null),
							  (n[i] = e)),
						void 0 === t ? n : a(n, t)
					);
				};
		},
		function (e, t, n) {
			var o = n(23),
				a = n(9),
				s = n(16);
			e.exports = n(6)
				? Object.defineProperties
				: function (e, t) {
						a(e);
						for (var n = s(t), r = n.length, l = 0, i; r > l; )
							o.f(e, (i = n[l++]), t[i]);
						return e;
				  };
		},
		function (e, t, n) {
			var o = n(5).document;
			e.exports = o && o.documentElement;
		},
		function (e, t) {
			"use strict";
			t.a = { isClosable: !0, reorderEnabled: !0, title: "" };
		},
		function (e, t, n) {
			"use strict";
			(function (e) {
				var o = n(8);
				t.a = class {
					constructor(e, t, n, a) {
						(this._isVertical = e),
							(this._size = t),
							(this._grabSize = n < t ? t : n),
							(this._container = a),
							(this.element = this._createElement()),
							(this._dragListener = new o.a(this.element, a));
					}
					on(e, t, n) {
						this._dragListener.on(e, t, n);
					}
					_$destroy() {
						this.element.remove();
					}
					_createElement() {
						var t = e('<div class="lm_drag_handle"></div>'),
							n = e('<div class="lm_splitter"></div>');
						n.append(t);
						var o = this._grabSize - this._size,
							a = o / 2;
						return (
							this._isVertical
								? (t.css("top", -a),
								  t.css("height", this._size + o),
								  n.addClass("lm_vertical"),
								  n.height(this._size))
								: (t.css("left", -a),
								  t.css("width", this._size + o),
								  n.addClass("lm_horizontal"),
								  n.width(this._size)),
							n
						);
					}
				};
			}).call(t, n(0));
		},
		function (e, t, n) {
			e.exports = { default: n(70), __esModule: !0 };
		},
		function (e, t, n) {
			var o = n(3),
				a = o.JSON || (o.JSON = { stringify: JSON.stringify });
			e.exports = function () {
				return a.stringify.apply(a, arguments);
			};
		},
		function (e, t, n) {
			"use strict";
			(function (e) {
				var o = n(8),
					a = n(31),
					i = n(1);
				t.a = class {
					constructor(e, t, n, o) {
						(this._element = e),
							(this._itemConfig = t),
							(this._layoutManager = n),
							(this._container = o),
							(this._dragListener = null),
							this._createDragListener();
					}
					destroy() {
						this._removeDragListener();
					}
					_createDragListener() {
						this._removeDragListener(),
							(this._dragListener = new o.a(
								this._element,
								this._container
							)),
							this._dragListener.on(
								"dragStart",
								this._onDragStart,
								this
							),
							this._dragListener.on(
								"dragStop",
								this._createDragListener,
								this
							);
					}
					_onDragStart(t, n) {
						var o = this._itemConfig;
						Object(i.h)(o) && (o = o());
						var s = this._layoutManager._$normalizeContentItem(
								e.extend(!0, {}, o)
							),
							r = new a.a(
								t,
								n,
								this._dragListener,
								this._layoutManager,
								s,
								null
							);
						this._layoutManager.transitionIndicator.transitionElements(
							this._element,
							r.element
						);
					}
					_removeDragListener() {
						null !== this._dragListener &&
							this._dragListener.destroy();
					}
				};
			}).call(t, n(0));
		},
		function (e, t, n) {
			"use strict";
			(function (e) {
				t.a = class {
					constructor(t) {
						(this.element = e(
							'<div class="lm_dropTargetIndicator"><div class="lm_inner"></div></div>'
						)),
							t.append(this.element);
					}
					destroy() {
						this.element.remove();
					}
					highlight(e, t, n, o) {
						this.highlightArea({ x1: e, y1: t, x2: n, y2: o });
					}
					highlightArea(e) {
						this.element
							.css({
								left: e.x1,
								top: e.y1,
								width: e.x2 - e.x1,
								height: e.y2 - e.y1,
								display: "block",
							})
							.show();
					}
					hide() {
						this.element.hide();
					}
				};
			}).call(t, n(0));
		},
		function (e, t, n) {
			"use strict";
			(function (e) {
				var o = n(1);
				t.a = class {
					constructor(t) {
						(this._element = e(
							'<div class="lm_transition_indicator"></div>'
						)),
							t.append(this._element),
							(this._toElement = null),
							(this._fromDimensions = null),
							(this._totalAnimationDuration = 200),
							(this._animationStartTime = null);
					}
					destroy() {
						this._element.remove();
					}
					transitionElements() {}
					_nextAnimationFrame() {
						var e = this._measure(this._toElement),
							t =
								(Object(o.i)() - this._animationStartTime) /
								this._totalAnimationDuration,
							n = {},
							a;
						if (1 <= t) return void this._element.hide();
						for (a in ((e.opacity = 0), this._fromDimensions))
							n[a] =
								this._fromDimensions[a] +
								(e[a] - this._fromDimensions[a]) * t;
						this._element.css(n),
							Object(o.a)(
								Object(o.c)(this._nextAnimationFrame, this)
							);
					}
					_measure(e) {
						var t = e.offset();
						return {
							left: t.left,
							top: t.top,
							width: e.outerWidth(),
							height: e.outerHeight(),
						};
					}
				};
			}).call(t, n(0));
		},
		function (e, t) {
			"use strict";
			t.a = {
				openPopouts: [],
				settings: {
					hasHeaders: !0,
					constrainDragToContainer: !0,
					reorderEnabled: !0,
					selectionEnabled: !1,
					popoutWholeStack: !1,
					blockedPopoutsThrowError: !0,
					closePopoutsOnUnload: !0,
					showPopoutIcon: !0,
					showMaximiseIcon: !0,
					showCloseIcon: !0,
					responsiveMode: "onload",
					tabOverlapAllowance: 0,
					reorderOnTabMenuClick: !0,
					tabControlOffset: 10,
				},
				dimensions: {
					borderWidth: 5,
					borderGrabWidth: 15,
					minItemHeight: 10,
					minItemWidth: 10,
					headerHeight: 20,
					dragProxyWidth: 300,
					dragProxyHeight: 200,
				},
				labels: {
					close: "close",
					maximise: "maximise",
					minimise: "minimise",
					popout: "open in new window",
					popin: "pop in",
					tabDropdown: "additional tabs",
				},
			};
		},
		function (e, t, n) {
			n(76)(n(77));
		},
		function (e) {
			e.exports = function (e) {
				function t(e) {
					"undefined" != typeof console &&
						(console.error || console.log)("[Script Loader]", e);
				}
				function n() {
					return (
						"undefined" != typeof attachEvent &&
						"undefined" == typeof addEventListener
					);
				}
				try {
					"undefined" != typeof execScript && n()
						? execScript(e)
						: "undefined" == typeof eval
						? t("EvalError: No eval function available")
						: eval.call(null, e);
				} catch (e) {
					t(e);
				}
			};
		},
		function (e) {
			e.exports =
				"/* Zepto v1.2.0 - zepto event ajax form ie - zeptojs.com/license */\n(function(global, factory) {\n  if (typeof define === 'function' && define.amd)\n    define(function() { return factory(global) })\n  else\n    factory(global)\n}(this, function(window) {\n  var Zepto = (function() {\n  var undefined, key, $, classList, emptyArray = [], concat = emptyArray.concat, filter = emptyArray.filter, slice = emptyArray.slice,\n    document = window.document,\n    elementDisplay = {}, classCache = {},\n    cssNumber = { 'column-count': 1, 'columns': 1, 'font-weight': 1, 'line-height': 1,'opacity': 1, 'z-index': 1, 'zoom': 1 },\n    fragmentRE = /^\\s*<(\\w+|!)[^>]*>/,\n    singleTagRE = /^<(\\w+)\\s*\\/?>(?:<\\/\\1>|)$/,\n    tagExpanderRE = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\\w:]+)[^>]*)\\/>/ig,\n    rootNodeRE = /^(?:body|html)$/i,\n    capitalRE = /([A-Z])/g,\n\n    // special attributes that should be get/set via method calls\n    methodAttributes = ['val', 'css', 'html', 'text', 'data', 'width', 'height', 'offset'],\n\n    adjacencyOperators = [ 'after', 'prepend', 'before', 'append' ],\n    table = document.createElement('table'),\n    tableRow = document.createElement('tr'),\n    containers = {\n      'tr': document.createElement('tbody'),\n      'tbody': table, 'thead': table, 'tfoot': table,\n      'td': tableRow, 'th': tableRow,\n      '*': document.createElement('div')\n    },\n    readyRE = /complete|loaded|interactive/,\n    simpleSelectorRE = /^[\\w-]*$/,\n    class2type = {},\n    toString = class2type.toString,\n    zepto = {},\n    camelize, uniq,\n    tempParent = document.createElement('div'),\n    propMap = {\n      'tabindex': 'tabIndex',\n      'readonly': 'readOnly',\n      'for': 'htmlFor',\n      'class': 'className',\n      'maxlength': 'maxLength',\n      'cellspacing': 'cellSpacing',\n      'cellpadding': 'cellPadding',\n      'rowspan': 'rowSpan',\n      'colspan': 'colSpan',\n      'usemap': 'useMap',\n      'frameborder': 'frameBorder',\n      'contenteditable': 'contentEditable'\n    },\n    isArray = Array.isArray ||\n      function(object){ return object instanceof Array }\n\n  zepto.matches = function(element, selector) {\n    if (!selector || !element || element.nodeType !== 1) return false\n    var matchesSelector = element.matches || element.webkitMatchesSelector ||\n                          element.mozMatchesSelector || element.oMatchesSelector ||\n                          element.matchesSelector\n    if (matchesSelector) return matchesSelector.call(element, selector)\n    // fall back to performing a selector:\n    var match, parent = element.parentNode, temp = !parent\n    if (temp) (parent = tempParent).appendChild(element)\n    match = ~zepto.qsa(parent, selector).indexOf(element)\n    temp && tempParent.removeChild(element)\n    return match\n  }\n\n  function type(obj) {\n    return obj == null ? String(obj) :\n      class2type[toString.call(obj)] || \"object\"\n  }\n\n  function isFunction(value) { return type(value) == \"function\" }\n  function isWindow(obj)     { return obj != null && obj == obj.window }\n  function isDocument(obj)   { return obj != null && obj.nodeType == obj.DOCUMENT_NODE }\n  function isObject(obj)     { return type(obj) == \"object\" }\n  function isPlainObject(obj) {\n    return isObject(obj) && !isWindow(obj) && Object.getPrototypeOf(obj) == Object.prototype\n  }\n\n  function likeArray(obj) {\n    var length = !!obj && 'length' in obj && obj.length,\n      type = $.type(obj)\n\n    return 'function' != type && !isWindow(obj) && (\n      'array' == type || length === 0 ||\n        (typeof length == 'number' && length > 0 && (length - 1) in obj)\n    )\n  }\n\n  function compact(array) { return filter.call(array, function(item){ return item != null }) }\n  function flatten(array) { return array.length > 0 ? $.fn.concat.apply([], array) : array }\n  camelize = function(str){ return str.replace(/-+(.)?/g, function(match, chr){ return chr ? chr.toUpperCase() : '' }) }\n  function dasherize(str) {\n    return str.replace(/::/g, '/')\n           .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')\n           .replace(/([a-z\\d])([A-Z])/g, '$1_$2')\n           .replace(/_/g, '-')\n           .toLowerCase()\n  }\n  uniq = function(array){ return filter.call(array, function(item, idx){ return array.indexOf(item) == idx }) }\n\n  function classRE(name) {\n    return name in classCache ?\n      classCache[name] : (classCache[name] = new RegExp('(^|\\\\s)' + name + '(\\\\s|$)'))\n  }\n\n  function maybeAddPx(name, value) {\n    return (typeof value == \"number\" && !cssNumber[dasherize(name)]) ? value + \"px\" : value\n  }\n\n  function defaultDisplay(nodeName) {\n    var element, display\n    if (!elementDisplay[nodeName]) {\n      element = document.createElement(nodeName)\n      document.body.appendChild(element)\n      display = getComputedStyle(element, '').getPropertyValue(\"display\")\n      element.parentNode.removeChild(element)\n      display == \"none\" && (display = \"block\")\n      elementDisplay[nodeName] = display\n    }\n    return elementDisplay[nodeName]\n  }\n\n  function children(element) {\n    return 'children' in element ?\n      slice.call(element.children) :\n      $.map(element.childNodes, function(node){ if (node.nodeType == 1) return node })\n  }\n\n  function Z(dom, selector) {\n    var i, len = dom ? dom.length : 0\n    for (i = 0; i < len; i++) this[i] = dom[i]\n    this.length = len\n    this.selector = selector || ''\n  }\n\n  // `$.zepto.fragment` takes a html string and an optional tag name\n  // to generate DOM nodes from the given html string.\n  // The generated DOM nodes are returned as an array.\n  // This function can be overridden in plugins for example to make\n  // it compatible with browsers that don't support the DOM fully.\n  zepto.fragment = function(html, name, properties) {\n    var dom, nodes, container\n\n    // A special case optimization for a single tag\n    if (singleTagRE.test(html)) dom = $(document.createElement(RegExp.$1))\n\n    if (!dom) {\n      if (html.replace) html = html.replace(tagExpanderRE, \"<$1></$2>\")\n      if (name === undefined) name = fragmentRE.test(html) && RegExp.$1\n      if (!(name in containers)) name = '*'\n\n      container = containers[name]\n      container.innerHTML = '' + html\n      dom = $.each(slice.call(container.childNodes), function(){\n        container.removeChild(this)\n      })\n    }\n\n    if (isPlainObject(properties)) {\n      nodes = $(dom)\n      $.each(properties, function(key, value) {\n        if (methodAttributes.indexOf(key) > -1) nodes[key](value)\n        else nodes.attr(key, value)\n      })\n    }\n\n    return dom\n  }\n\n  // `$.zepto.Z` swaps out the prototype of the given `dom` array\n  // of nodes with `$.fn` and thus supplying all the Zepto functions\n  // to the array. This method can be overridden in plugins.\n  zepto.Z = function(dom, selector) {\n    return new Z(dom, selector)\n  }\n\n  // `$.zepto.isZ` should return `true` if the given object is a Zepto\n  // collection. This method can be overridden in plugins.\n  zepto.isZ = function(object) {\n    return object instanceof zepto.Z\n  }\n\n  // `$.zepto.init` is Zepto's counterpart to jQuery's `$.fn.init` and\n  // takes a CSS selector and an optional context (and handles various\n  // special cases).\n  // This method can be overridden in plugins.\n  zepto.init = function(selector, context) {\n    var dom\n    // If nothing given, return an empty Zepto collection\n    if (!selector) return zepto.Z()\n    // Optimize for string selectors\n    else if (typeof selector == 'string') {\n      selector = selector.trim()\n      // If it's a html fragment, create nodes from it\n      // Note: In both Chrome 21 and Firefox 15, DOM error 12\n      // is thrown if the fragment doesn't begin with <\n      if (selector[0] == '<' && fragmentRE.test(selector))\n        dom = zepto.fragment(selector, RegExp.$1, context), selector = null\n      // If there's a context, create a collection on that context first, and select\n      // nodes from there\n      else if (context !== undefined) return $(context).find(selector)\n      // If it's a CSS selector, use it to select nodes.\n      else dom = zepto.qsa(document, selector)\n    }\n    // If a function is given, call it when the DOM is ready\n    else if (isFunction(selector)) return $(document).ready(selector)\n    // If a Zepto collection is given, just return it\n    else if (zepto.isZ(selector)) return selector\n    else {\n      // normalize array if an array of nodes is given\n      if (isArray(selector)) dom = compact(selector)\n      // Wrap DOM nodes.\n      else if (isObject(selector))\n        dom = [selector], selector = null\n      // If it's a html fragment, create nodes from it\n      else if (fragmentRE.test(selector))\n        dom = zepto.fragment(selector.trim(), RegExp.$1, context), selector = null\n      // If there's a context, create a collection on that context first, and select\n      // nodes from there\n      else if (context !== undefined) return $(context).find(selector)\n      // And last but no least, if it's a CSS selector, use it to select nodes.\n      else dom = zepto.qsa(document, selector)\n    }\n    // create a new Zepto collection from the nodes found\n    return zepto.Z(dom, selector)\n  }\n\n  // `$` will be the base `Zepto` object. When calling this\n  // function just call `$.zepto.init, which makes the implementation\n  // details of selecting nodes and creating Zepto collections\n  // patchable in plugins.\n  $ = function(selector, context){\n    return zepto.init(selector, context)\n  }\n\n  function extend(target, source, deep) {\n    for (key in source)\n      if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {\n        if (isPlainObject(source[key]) && !isPlainObject(target[key]))\n          target[key] = {}\n        if (isArray(source[key]) && !isArray(target[key]))\n          target[key] = []\n        extend(target[key], source[key], deep)\n      }\n      else if (source[key] !== undefined) target[key] = source[key]\n  }\n\n  // Copy all but undefined properties from one or more\n  // objects to the `target` object.\n  $.extend = function(target){\n    var deep, args = slice.call(arguments, 1)\n    if (typeof target == 'boolean') {\n      deep = target\n      target = args.shift()\n    }\n    args.forEach(function(arg){ extend(target, arg, deep) })\n    return target\n  }\n\n  // `$.zepto.qsa` is Zepto's CSS selector implementation which\n  // uses `document.querySelectorAll` and optimizes for some special cases, like `#id`.\n  // This method can be overridden in plugins.\n  zepto.qsa = function(element, selector){\n    var found,\n        maybeID = selector[0] == '#',\n        maybeClass = !maybeID && selector[0] == '.',\n        nameOnly = maybeID || maybeClass ? selector.slice(1) : selector, // Ensure that a 1 char tag name still gets checked\n        isSimple = simpleSelectorRE.test(nameOnly)\n    return (element.getElementById && isSimple && maybeID) ? // Safari DocumentFragment doesn't have getElementById\n      ( (found = element.getElementById(nameOnly)) ? [found] : [] ) :\n      (element.nodeType !== 1 && element.nodeType !== 9 && element.nodeType !== 11) ? [] :\n      slice.call(\n        isSimple && !maybeID && element.getElementsByClassName ? // DocumentFragment doesn't have getElementsByClassName/TagName\n          maybeClass ? element.getElementsByClassName(nameOnly) : // If it's simple, it could be a class\n          element.getElementsByTagName(selector) : // Or a tag\n          element.querySelectorAll(selector) // Or it's not simple, and we need to query all\n      )\n  }\n\n  function filtered(nodes, selector) {\n    return selector == null ? $(nodes) : $(nodes).filter(selector)\n  }\n\n  $.contains = document.documentElement.contains ?\n    function(parent, node) {\n      return parent !== node && parent.contains(node)\n    } :\n    function(parent, node) {\n      while (node && (node = node.parentNode))\n        if (node === parent) return true\n      return false\n    }\n\n  function funcArg(context, arg, idx, payload) {\n    return isFunction(arg) ? arg.call(context, idx, payload) : arg\n  }\n\n  function setAttribute(node, name, value) {\n    value == null ? node.removeAttribute(name) : node.setAttribute(name, value)\n  }\n\n  // access className property while respecting SVGAnimatedString\n  function className(node, value){\n    var klass = node.className || '',\n        svg   = klass && klass.baseVal !== undefined\n\n    if (value === undefined) return svg ? klass.baseVal : klass\n    svg ? (klass.baseVal = value) : (node.className = value)\n  }\n\n  // \"true\"  => true\n  // \"false\" => false\n  // \"null\"  => null\n  // \"42\"    => 42\n  // \"42.5\"  => 42.5\n  // \"08\"    => \"08\"\n  // JSON    => parse if valid\n  // String  => self\n  function deserializeValue(value) {\n    try {\n      return value ?\n        value == \"true\" ||\n        ( value == \"false\" ? false :\n          value == \"null\" ? null :\n          +value + \"\" == value ? +value :\n          /^[\\[\\{]/.test(value) ? $.parseJSON(value) :\n          value )\n        : value\n    } catch(e) {\n      return value\n    }\n  }\n\n  $.type = type\n  $.isFunction = isFunction\n  $.isWindow = isWindow\n  $.isArray = isArray\n  $.isPlainObject = isPlainObject\n\n  $.isEmptyObject = function(obj) {\n    var name\n    for (name in obj) return false\n    return true\n  }\n\n  $.isNumeric = function(val) {\n    var num = Number(val), type = typeof val\n    return val != null && type != 'boolean' &&\n      (type != 'string' || val.length) &&\n      !isNaN(num) && isFinite(num) || false\n  }\n\n  $.inArray = function(elem, array, i){\n    return emptyArray.indexOf.call(array, elem, i)\n  }\n\n  $.camelCase = camelize\n  $.trim = function(str) {\n    return str == null ? \"\" : String.prototype.trim.call(str)\n  }\n\n  // plugin compatibility\n  $.uuid = 0\n  $.support = { }\n  $.expr = { }\n  $.noop = function() {}\n\n  $.map = function(elements, callback){\n    var value, values = [], i, key\n    if (likeArray(elements))\n      for (i = 0; i < elements.length; i++) {\n        value = callback(elements[i], i)\n        if (value != null) values.push(value)\n      }\n    else\n      for (key in elements) {\n        value = callback(elements[key], key)\n        if (value != null) values.push(value)\n      }\n    return flatten(values)\n  }\n\n  $.each = function(elements, callback){\n    var i, key\n    if (likeArray(elements)) {\n      for (i = 0; i < elements.length; i++)\n        if (callback.call(elements[i], i, elements[i]) === false) return elements\n    } else {\n      for (key in elements)\n        if (callback.call(elements[key], key, elements[key]) === false) return elements\n    }\n\n    return elements\n  }\n\n  $.grep = function(elements, callback){\n    return filter.call(elements, callback)\n  }\n\n  if (window.JSON) $.parseJSON = JSON.parse\n\n  // Populate the class2type map\n  $.each(\"Boolean Number String Function Array Date RegExp Object Error\".split(\" \"), function(i, name) {\n    class2type[ \"[object \" + name + \"]\" ] = name.toLowerCase()\n  })\n\n  // Define methods that will be available on all\n  // Zepto collections\n  $.fn = {\n    constructor: zepto.Z,\n    length: 0,\n\n    // Because a collection acts like an array\n    // copy over these useful array functions.\n    forEach: emptyArray.forEach,\n    reduce: emptyArray.reduce,\n    push: emptyArray.push,\n    sort: emptyArray.sort,\n    splice: emptyArray.splice,\n    indexOf: emptyArray.indexOf,\n    concat: function(){\n      var i, value, args = []\n      for (i = 0; i < arguments.length; i++) {\n        value = arguments[i]\n        args[i] = zepto.isZ(value) ? value.toArray() : value\n      }\n      return concat.apply(zepto.isZ(this) ? this.toArray() : this, args)\n    },\n\n    // `map` and `slice` in the jQuery API work differently\n    // from their array counterparts\n    map: function(fn){\n      return $($.map(this, function(el, i){ return fn.call(el, i, el) }))\n    },\n    slice: function(){\n      return $(slice.apply(this, arguments))\n    },\n\n    ready: function(callback){\n      // need to check if document.body exists for IE as that browser reports\n      // document ready when it hasn't yet created the body element\n      if (readyRE.test(document.readyState) && document.body) callback($)\n      else document.addEventListener('DOMContentLoaded', function(){ callback($) }, false)\n      return this\n    },\n    get: function(idx){\n      return idx === undefined ? slice.call(this) : this[idx >= 0 ? idx : idx + this.length]\n    },\n    toArray: function(){ return this.get() },\n    size: function(){\n      return this.length\n    },\n    remove: function(){\n      return this.each(function(){\n        if (this.parentNode != null)\n          this.parentNode.removeChild(this)\n      })\n    },\n    each: function(callback){\n      emptyArray.every.call(this, function(el, idx){\n        return callback.call(el, idx, el) !== false\n      })\n      return this\n    },\n    filter: function(selector){\n      if (isFunction(selector)) return this.not(this.not(selector))\n      return $(filter.call(this, function(element){\n        return zepto.matches(element, selector)\n      }))\n    },\n    add: function(selector,context){\n      return $(uniq(this.concat($(selector,context))))\n    },\n    is: function(selector){\n      return this.length > 0 && zepto.matches(this[0], selector)\n    },\n    not: function(selector){\n      var nodes=[]\n      if (isFunction(selector) && selector.call !== undefined)\n        this.each(function(idx){\n          if (!selector.call(this,idx)) nodes.push(this)\n        })\n      else {\n        var excludes = typeof selector == 'string' ? this.filter(selector) :\n          (likeArray(selector) && isFunction(selector.item)) ? slice.call(selector) : $(selector)\n        this.forEach(function(el){\n          if (excludes.indexOf(el) < 0) nodes.push(el)\n        })\n      }\n      return $(nodes)\n    },\n    has: function(selector){\n      return this.filter(function(){\n        return isObject(selector) ?\n          $.contains(this, selector) :\n          $(this).find(selector).size()\n      })\n    },\n    eq: function(idx){\n      return idx === -1 ? this.slice(idx) : this.slice(idx, + idx + 1)\n    },\n    first: function(){\n      var el = this[0]\n      return el && !isObject(el) ? el : $(el)\n    },\n    last: function(){\n      var el = this[this.length - 1]\n      return el && !isObject(el) ? el : $(el)\n    },\n    find: function(selector){\n      var result, $this = this\n      if (!selector) result = $()\n      else if (typeof selector == 'object')\n        result = $(selector).filter(function(){\n          var node = this\n          return emptyArray.some.call($this, function(parent){\n            return $.contains(parent, node)\n          })\n        })\n      else if (this.length == 1) result = $(zepto.qsa(this[0], selector))\n      else result = this.map(function(){ return zepto.qsa(this, selector) })\n      return result\n    },\n    closest: function(selector, context){\n      var nodes = [], collection = typeof selector == 'object' && $(selector)\n      this.each(function(_, node){\n        while (node && !(collection ? collection.indexOf(node) >= 0 : zepto.matches(node, selector)))\n          node = node !== context && !isDocument(node) && node.parentNode\n        if (node && nodes.indexOf(node) < 0) nodes.push(node)\n      })\n      return $(nodes)\n    },\n    parents: function(selector){\n      var ancestors = [], nodes = this\n      while (nodes.length > 0)\n        nodes = $.map(nodes, function(node){\n          if ((node = node.parentNode) && !isDocument(node) && ancestors.indexOf(node) < 0) {\n            ancestors.push(node)\n            return node\n          }\n        })\n      return filtered(ancestors, selector)\n    },\n    parent: function(selector){\n      return filtered(uniq(this.pluck('parentNode')), selector)\n    },\n    children: function(selector){\n      return filtered(this.map(function(){ return children(this) }), selector)\n    },\n    contents: function() {\n      return this.map(function() { return this.contentDocument || slice.call(this.childNodes) })\n    },\n    siblings: function(selector){\n      return filtered(this.map(function(i, el){\n        return filter.call(children(el.parentNode), function(child){ return child!==el })\n      }), selector)\n    },\n    empty: function(){\n      return this.each(function(){ this.innerHTML = '' })\n    },\n    // `pluck` is borrowed from Prototype.js\n    pluck: function(property){\n      return $.map(this, function(el){ return el[property] })\n    },\n    show: function(){\n      return this.each(function(){\n        this.style.display == \"none\" && (this.style.display = '')\n        if (getComputedStyle(this, '').getPropertyValue(\"display\") == \"none\")\n          this.style.display = defaultDisplay(this.nodeName)\n      })\n    },\n    replaceWith: function(newContent){\n      return this.before(newContent).remove()\n    },\n    wrap: function(structure){\n      var func = isFunction(structure)\n      if (this[0] && !func)\n        var dom   = $(structure).get(0),\n            clone = dom.parentNode || this.length > 1\n\n      return this.each(function(index){\n        $(this).wrapAll(\n          func ? structure.call(this, index) :\n            clone ? dom.cloneNode(true) : dom\n        )\n      })\n    },\n    wrapAll: function(structure){\n      if (this[0]) {\n        $(this[0]).before(structure = $(structure))\n        var children\n        // drill down to the inmost element\n        while ((children = structure.children()).length) structure = children.first()\n        $(structure).append(this)\n      }\n      return this\n    },\n    wrapInner: function(structure){\n      var func = isFunction(structure)\n      return this.each(function(index){\n        var self = $(this), contents = self.contents(),\n            dom  = func ? structure.call(this, index) : structure\n        contents.length ? contents.wrapAll(dom) : self.append(dom)\n      })\n    },\n    unwrap: function(){\n      this.parent().each(function(){\n        $(this).replaceWith($(this).children())\n      })\n      return this\n    },\n    clone: function(){\n      return this.map(function(){ return this.cloneNode(true) })\n    },\n    hide: function(){\n      return this.css(\"display\", \"none\")\n    },\n    toggle: function(setting){\n      return this.each(function(){\n        var el = $(this)\n        ;(setting === undefined ? el.css(\"display\") == \"none\" : setting) ? el.show() : el.hide()\n      })\n    },\n    prev: function(selector){ return $(this.pluck('previousElementSibling')).filter(selector || '*') },\n    next: function(selector){ return $(this.pluck('nextElementSibling')).filter(selector || '*') },\n    html: function(html){\n      return 0 in arguments ?\n        this.each(function(idx){\n          var originHtml = this.innerHTML\n          $(this).empty().append( funcArg(this, html, idx, originHtml) )\n        }) :\n        (0 in this ? this[0].innerHTML : null)\n    },\n    text: function(text){\n      return 0 in arguments ?\n        this.each(function(idx){\n          var newText = funcArg(this, text, idx, this.textContent)\n          this.textContent = newText == null ? '' : ''+newText\n        }) :\n        (0 in this ? this.pluck('textContent').join(\"\") : null)\n    },\n    attr: function(name, value){\n      var result\n      return (typeof name == 'string' && !(1 in arguments)) ?\n        (0 in this && this[0].nodeType == 1 && (result = this[0].getAttribute(name)) != null ? result : undefined) :\n        this.each(function(idx){\n          if (this.nodeType !== 1) return\n          if (isObject(name)) for (key in name) setAttribute(this, key, name[key])\n          else setAttribute(this, name, funcArg(this, value, idx, this.getAttribute(name)))\n        })\n    },\n    removeAttr: function(name){\n      return this.each(function(){ this.nodeType === 1 && name.split(' ').forEach(function(attribute){\n        setAttribute(this, attribute)\n      }, this)})\n    },\n    prop: function(name, value){\n      name = propMap[name] || name\n      return (1 in arguments) ?\n        this.each(function(idx){\n          this[name] = funcArg(this, value, idx, this[name])\n        }) :\n        (this[0] && this[0][name])\n    },\n    removeProp: function(name){\n      name = propMap[name] || name\n      return this.each(function(){ delete this[name] })\n    },\n    data: function(name, value){\n      var attrName = 'data-' + name.replace(capitalRE, '-$1').toLowerCase()\n\n      var data = (1 in arguments) ?\n        this.attr(attrName, value) :\n        this.attr(attrName)\n\n      return data !== null ? deserializeValue(data) : undefined\n    },\n    val: function(value){\n      if (0 in arguments) {\n        if (value == null) value = \"\"\n        return this.each(function(idx){\n          this.value = funcArg(this, value, idx, this.value)\n        })\n      } else {\n        return this[0] && (this[0].multiple ?\n           $(this[0]).find('option').filter(function(){ return this.selected }).pluck('value') :\n           this[0].value)\n      }\n    },\n    offset: function(coordinates){\n      if (coordinates) return this.each(function(index){\n        var $this = $(this),\n            coords = funcArg(this, coordinates, index, $this.offset()),\n            parentOffset = $this.offsetParent().offset(),\n            props = {\n              top:  coords.top  - parentOffset.top,\n              left: coords.left - parentOffset.left\n            }\n\n        if ($this.css('position') == 'static') props['position'] = 'relative'\n        $this.css(props)\n      })\n      if (!this.length) return null\n      if (document.documentElement !== this[0] && !$.contains(document.documentElement, this[0]))\n        return {top: 0, left: 0}\n      var obj = this[0].getBoundingClientRect()\n      return {\n        left: obj.left + window.pageXOffset,\n        top: obj.top + window.pageYOffset,\n        width: Math.round(obj.width),\n        height: Math.round(obj.height)\n      }\n    },\n    css: function(property, value){\n      if (arguments.length < 2) {\n        var element = this[0]\n        if (typeof property == 'string') {\n          if (!element) return\n          return element.style[camelize(property)] || getComputedStyle(element, '').getPropertyValue(property)\n        } else if (isArray(property)) {\n          if (!element) return\n          var props = {}\n          var computedStyle = getComputedStyle(element, '')\n          $.each(property, function(_, prop){\n            props[prop] = (element.style[camelize(prop)] || computedStyle.getPropertyValue(prop))\n          })\n          return props\n        }\n      }\n\n      var css = ''\n      if (type(property) == 'string') {\n        if (!value && value !== 0)\n          this.each(function(){ this.style.removeProperty(dasherize(property)) })\n        else\n          css = dasherize(property) + \":\" + maybeAddPx(property, value)\n      } else {\n        for (key in property)\n          if (!property[key] && property[key] !== 0)\n            this.each(function(){ this.style.removeProperty(dasherize(key)) })\n          else\n            css += dasherize(key) + ':' + maybeAddPx(key, property[key]) + ';'\n      }\n\n      return this.each(function(){ this.style.cssText += ';' + css })\n    },\n    index: function(element){\n      return element ? this.indexOf($(element)[0]) : this.parent().children().indexOf(this[0])\n    },\n    hasClass: function(name){\n      if (!name) return false\n      return emptyArray.some.call(this, function(el){\n        return this.test(className(el))\n      }, classRE(name))\n    },\n    addClass: function(name){\n      if (!name) return this\n      return this.each(function(idx){\n        if (!('className' in this)) return\n        classList = []\n        var cls = className(this), newName = funcArg(this, name, idx, cls)\n        newName.split(/\\s+/g).forEach(function(klass){\n          if (!$(this).hasClass(klass)) classList.push(klass)\n        }, this)\n        classList.length && className(this, cls + (cls ? \" \" : \"\") + classList.join(\" \"))\n      })\n    },\n    removeClass: function(name){\n      return this.each(function(idx){\n        if (!('className' in this)) return\n        if (name === undefined) return className(this, '')\n        classList = className(this)\n        funcArg(this, name, idx, classList).split(/\\s+/g).forEach(function(klass){\n          classList = classList.replace(classRE(klass), \" \")\n        })\n        className(this, classList.trim())\n      })\n    },\n    toggleClass: function(name, when){\n      if (!name) return this\n      return this.each(function(idx){\n        var $this = $(this), names = funcArg(this, name, idx, className(this))\n        names.split(/\\s+/g).forEach(function(klass){\n          (when === undefined ? !$this.hasClass(klass) : when) ?\n            $this.addClass(klass) : $this.removeClass(klass)\n        })\n      })\n    },\n    scrollTop: function(value){\n      if (!this.length) return\n      var hasScrollTop = 'scrollTop' in this[0]\n      if (value === undefined) return hasScrollTop ? this[0].scrollTop : this[0].pageYOffset\n      return this.each(hasScrollTop ?\n        function(){ this.scrollTop = value } :\n        function(){ this.scrollTo(this.scrollX, value) })\n    },\n    scrollLeft: function(value){\n      if (!this.length) return\n      var hasScrollLeft = 'scrollLeft' in this[0]\n      if (value === undefined) return hasScrollLeft ? this[0].scrollLeft : this[0].pageXOffset\n      return this.each(hasScrollLeft ?\n        function(){ this.scrollLeft = value } :\n        function(){ this.scrollTo(value, this.scrollY) })\n    },\n    position: function() {\n      if (!this.length) return\n\n      var elem = this[0],\n        // Get *real* offsetParent\n        offsetParent = this.offsetParent(),\n        // Get correct offsets\n        offset       = this.offset(),\n        parentOffset = rootNodeRE.test(offsetParent[0].nodeName) ? { top: 0, left: 0 } : offsetParent.offset()\n\n      // Subtract element margins\n      // note: when an element has margin: auto the offsetLeft and marginLeft\n      // are the same in Safari causing offset.left to incorrectly be 0\n      offset.top  -= parseFloat( $(elem).css('margin-top') ) || 0\n      offset.left -= parseFloat( $(elem).css('margin-left') ) || 0\n\n      // Add offsetParent borders\n      parentOffset.top  += parseFloat( $(offsetParent[0]).css('border-top-width') ) || 0\n      parentOffset.left += parseFloat( $(offsetParent[0]).css('border-left-width') ) || 0\n\n      // Subtract the two offsets\n      return {\n        top:  offset.top  - parentOffset.top,\n        left: offset.left - parentOffset.left\n      }\n    },\n    offsetParent: function() {\n      return this.map(function(){\n        var parent = this.offsetParent || document.body\n        while (parent && !rootNodeRE.test(parent.nodeName) && $(parent).css(\"position\") == \"static\")\n          parent = parent.offsetParent\n        return parent\n      })\n    }\n  }\n\n  // for now\n  $.fn.detach = $.fn.remove\n\n  // Generate the `width` and `height` functions\n  ;['width', 'height'].forEach(function(dimension){\n    var dimensionProperty =\n      dimension.replace(/./, function(m){ return m[0].toUpperCase() })\n\n    $.fn[dimension] = function(value){\n      var offset, el = this[0]\n      if (value === undefined) return isWindow(el) ? el['inner' + dimensionProperty] :\n        isDocument(el) ? el.documentElement['scroll' + dimensionProperty] :\n        (offset = this.offset()) && offset[dimension]\n      else return this.each(function(idx){\n        el = $(this)\n        el.css(dimension, funcArg(this, value, idx, el[dimension]()))\n      })\n    }\n  })\n\n  function traverseNode(node, fun) {\n    fun(node)\n    for (var i = 0, len = node.childNodes.length; i < len; i++)\n      traverseNode(node.childNodes[i], fun)\n  }\n\n  // Generate the `after`, `prepend`, `before`, `append`,\n  // `insertAfter`, `insertBefore`, `appendTo`, and `prependTo` methods.\n  adjacencyOperators.forEach(function(operator, operatorIndex) {\n    var inside = operatorIndex % 2 //=> prepend, append\n\n    $.fn[operator] = function(){\n      // arguments can be nodes, arrays of nodes, Zepto objects and HTML strings\n      var argType, nodes = $.map(arguments, function(arg) {\n            var arr = []\n            argType = type(arg)\n            if (argType == \"array\") {\n              arg.forEach(function(el) {\n                if (el.nodeType !== undefined) return arr.push(el)\n                else if ($.zepto.isZ(el)) return arr = arr.concat(el.get())\n                arr = arr.concat(zepto.fragment(el))\n              })\n              return arr\n            }\n            return argType == \"object\" || arg == null ?\n              arg : zepto.fragment(arg)\n          }),\n          parent, copyByClone = this.length > 1\n      if (nodes.length < 1) return this\n\n      return this.each(function(_, target){\n        parent = inside ? target : target.parentNode\n\n        // convert all methods to a \"before\" operation\n        target = operatorIndex == 0 ? target.nextSibling :\n                 operatorIndex == 1 ? target.firstChild :\n                 operatorIndex == 2 ? target :\n                 null\n\n        var parentInDocument = $.contains(document.documentElement, parent)\n\n        nodes.forEach(function(node){\n          if (copyByClone) node = node.cloneNode(true)\n          else if (!parent) return $(node).remove()\n\n          parent.insertBefore(node, target)\n          if (parentInDocument) traverseNode(node, function(el){\n            if (el.nodeName != null && el.nodeName.toUpperCase() === 'SCRIPT' &&\n               (!el.type || el.type === 'text/javascript') && !el.src){\n              var target = el.ownerDocument ? el.ownerDocument.defaultView : window\n              target['eval'].call(target, el.innerHTML)\n            }\n          })\n        })\n      })\n    }\n\n    // after    => insertAfter\n    // prepend  => prependTo\n    // before   => insertBefore\n    // append   => appendTo\n    $.fn[inside ? operator+'To' : 'insert'+(operatorIndex ? 'Before' : 'After')] = function(html){\n      $(html)[operator](this)\n      return this\n    }\n  })\n\n  zepto.Z.prototype = Z.prototype = $.fn\n\n  // Export internal API functions in the `$.zepto` namespace\n  zepto.uniq = uniq\n  zepto.deserializeValue = deserializeValue\n  $.zepto = zepto\n\n  return $\n})()\n\nwindow.Zepto = Zepto\nwindow.$ === undefined && (window.$ = Zepto)\n\n;(function($){\n  var _zid = 1, undefined,\n      slice = Array.prototype.slice,\n      isFunction = $.isFunction,\n      isString = function(obj){ return typeof obj == 'string' },\n      handlers = {},\n      specialEvents={},\n      focusinSupported = 'onfocusin' in window,\n      focus = { focus: 'focusin', blur: 'focusout' },\n      hover = { mouseenter: 'mouseover', mouseleave: 'mouseout' }\n\n  specialEvents.click = specialEvents.mousedown = specialEvents.mouseup = specialEvents.mousemove = 'MouseEvents'\n\n  function zid(element) {\n    return element._zid || (element._zid = _zid++)\n  }\n  function findHandlers(element, event, fn, selector) {\n    event = parse(event)\n    if (event.ns) var matcher = matcherFor(event.ns)\n    return (handlers[zid(element)] || []).filter(function(handler) {\n      return handler\n        && (!event.e  || handler.e == event.e)\n        && (!event.ns || matcher.test(handler.ns))\n        && (!fn       || zid(handler.fn) === zid(fn))\n        && (!selector || handler.sel == selector)\n    })\n  }\n  function parse(event) {\n    var parts = ('' + event).split('.')\n    return {e: parts[0], ns: parts.slice(1).sort().join(' ')}\n  }\n  function matcherFor(ns) {\n    return new RegExp('(?:^| )' + ns.replace(' ', ' .* ?') + '(?: |$)')\n  }\n\n  function eventCapture(handler, captureSetting) {\n    return handler.del &&\n      (!focusinSupported && (handler.e in focus)) ||\n      !!captureSetting\n  }\n\n  function realEvent(type) {\n    return hover[type] || (focusinSupported && focus[type]) || type\n  }\n\n  function add(element, events, fn, data, selector, delegator, capture){\n    var id = zid(element), set = (handlers[id] || (handlers[id] = []))\n    events.split(/\\s/).forEach(function(event){\n      if (event == 'ready') return $(document).ready(fn)\n      var handler   = parse(event)\n      handler.fn    = fn\n      handler.sel   = selector\n      // emulate mouseenter, mouseleave\n      if (handler.e in hover) fn = function(e){\n        var related = e.relatedTarget\n        if (!related || (related !== this && !$.contains(this, related)))\n          return handler.fn.apply(this, arguments)\n      }\n      handler.del   = delegator\n      var callback  = delegator || fn\n      handler.proxy = function(e){\n        e = compatible(e)\n        if (e.isImmediatePropagationStopped()) return\n        e.data = data\n        var result = callback.apply(element, e._args == undefined ? [e] : [e].concat(e._args))\n        if (result === false) e.preventDefault(), e.stopPropagation()\n        return result\n      }\n      handler.i = set.length\n      set.push(handler)\n      if ('addEventListener' in element)\n        element.addEventListener(realEvent(handler.e), handler.proxy, eventCapture(handler, capture))\n    })\n  }\n  function remove(element, events, fn, selector, capture){\n    var id = zid(element)\n    ;(events || '').split(/\\s/).forEach(function(event){\n      findHandlers(element, event, fn, selector).forEach(function(handler){\n        delete handlers[id][handler.i]\n      if ('removeEventListener' in element)\n        element.removeEventListener(realEvent(handler.e), handler.proxy, eventCapture(handler, capture))\n      })\n    })\n  }\n\n  $.event = { add: add, remove: remove }\n\n  $.proxy = function(fn, context) {\n    var args = (2 in arguments) && slice.call(arguments, 2)\n    if (isFunction(fn)) {\n      var proxyFn = function(){ return fn.apply(context, args ? args.concat(slice.call(arguments)) : arguments) }\n      proxyFn._zid = zid(fn)\n      return proxyFn\n    } else if (isString(context)) {\n      if (args) {\n        args.unshift(fn[context], fn)\n        return $.proxy.apply(null, args)\n      } else {\n        return $.proxy(fn[context], fn)\n      }\n    } else {\n      throw new TypeError(\"expected function\")\n    }\n  }\n\n  $.fn.bind = function(event, data, callback){\n    return this.on(event, data, callback)\n  }\n  $.fn.unbind = function(event, callback){\n    return this.off(event, callback)\n  }\n  $.fn.one = function(event, selector, data, callback){\n    return this.on(event, selector, data, callback, 1)\n  }\n\n  var returnTrue = function(){return true},\n      returnFalse = function(){return false},\n      ignoreProperties = /^([A-Z]|returnValue$|layer[XY]$|webkitMovement[XY]$)/,\n      eventMethods = {\n        preventDefault: 'isDefaultPrevented',\n        stopImmediatePropagation: 'isImmediatePropagationStopped',\n        stopPropagation: 'isPropagationStopped'\n      }\n\n  function compatible(event, source) {\n    if (source || !event.isDefaultPrevented) {\n      source || (source = event)\n\n      $.each(eventMethods, function(name, predicate) {\n        var sourceMethod = source[name]\n        event[name] = function(){\n          this[predicate] = returnTrue\n          return sourceMethod && sourceMethod.apply(source, arguments)\n        }\n        event[predicate] = returnFalse\n      })\n\n      event.timeStamp || (event.timeStamp = Date.now())\n\n      if (source.defaultPrevented !== undefined ? source.defaultPrevented :\n          'returnValue' in source ? source.returnValue === false :\n          source.getPreventDefault && source.getPreventDefault())\n        event.isDefaultPrevented = returnTrue\n    }\n    return event\n  }\n\n  function createProxy(event) {\n    var key, proxy = { originalEvent: event }\n    for (key in event)\n      if (!ignoreProperties.test(key) && event[key] !== undefined) proxy[key] = event[key]\n\n    return compatible(proxy, event)\n  }\n\n  $.fn.delegate = function(selector, event, callback){\n    return this.on(event, selector, callback)\n  }\n  $.fn.undelegate = function(selector, event, callback){\n    return this.off(event, selector, callback)\n  }\n\n  $.fn.live = function(event, callback){\n    $(document.body).delegate(this.selector, event, callback)\n    return this\n  }\n  $.fn.die = function(event, callback){\n    $(document.body).undelegate(this.selector, event, callback)\n    return this\n  }\n\n  $.fn.on = function(event, selector, data, callback, one){\n    var autoRemove, delegator, $this = this\n    if (event && !isString(event)) {\n      $.each(event, function(type, fn){\n        $this.on(type, selector, data, fn, one)\n      })\n      return $this\n    }\n\n    if (!isString(selector) && !isFunction(callback) && callback !== false)\n      callback = data, data = selector, selector = undefined\n    if (callback === undefined || data === false)\n      callback = data, data = undefined\n\n    if (callback === false) callback = returnFalse\n\n    return $this.each(function(_, element){\n      if (one) autoRemove = function(e){\n        remove(element, e.type, callback)\n        return callback.apply(this, arguments)\n      }\n\n      if (selector) delegator = function(e){\n        var evt, match = $(e.target).closest(selector, element).get(0)\n        if (match && match !== element) {\n          evt = $.extend(createProxy(e), {currentTarget: match, liveFired: element})\n          return (autoRemove || callback).apply(match, [evt].concat(slice.call(arguments, 1)))\n        }\n      }\n\n      add(element, event, callback, data, selector, delegator || autoRemove)\n    })\n  }\n  $.fn.off = function(event, selector, callback){\n    var $this = this\n    if (event && !isString(event)) {\n      $.each(event, function(type, fn){\n        $this.off(type, selector, fn)\n      })\n      return $this\n    }\n\n    if (!isString(selector) && !isFunction(callback) && callback !== false)\n      callback = selector, selector = undefined\n\n    if (callback === false) callback = returnFalse\n\n    return $this.each(function(){\n      remove(this, event, callback, selector)\n    })\n  }\n\n  $.fn.trigger = function(event, args){\n    event = (isString(event) || $.isPlainObject(event)) ? $.Event(event) : compatible(event)\n    event._args = args\n    return this.each(function(){\n      // handle focus(), blur() by calling them directly\n      if (event.type in focus && typeof this[event.type] == \"function\") this[event.type]()\n      // items in the collection might not be DOM elements\n      else if ('dispatchEvent' in this) this.dispatchEvent(event)\n      else $(this).triggerHandler(event, args)\n    })\n  }\n\n  // triggers event handlers on current element just as if an event occurred,\n  // doesn't trigger an actual event, doesn't bubble\n  $.fn.triggerHandler = function(event, args){\n    var e, result\n    this.each(function(i, element){\n      e = createProxy(isString(event) ? $.Event(event) : event)\n      e._args = args\n      e.target = element\n      $.each(findHandlers(element, event.type || event), function(i, handler){\n        result = handler.proxy(e)\n        if (e.isImmediatePropagationStopped()) return false\n      })\n    })\n    return result\n  }\n\n  // shortcut methods for `.bind(event, fn)` for each event type\n  ;('focusin focusout focus blur load resize scroll unload click dblclick '+\n  'mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave '+\n  'change select keydown keypress keyup error').split(' ').forEach(function(event) {\n    $.fn[event] = function(callback) {\n      return (0 in arguments) ?\n        this.bind(event, callback) :\n        this.trigger(event)\n    }\n  })\n\n  $.Event = function(type, props) {\n    if (!isString(type)) props = type, type = props.type\n    var event = document.createEvent(specialEvents[type] || 'Events'), bubbles = true\n    if (props) for (var name in props) (name == 'bubbles') ? (bubbles = !!props[name]) : (event[name] = props[name])\n    event.initEvent(type, bubbles, true)\n    return compatible(event)\n  }\n\n})(Zepto)\n\n;(function($){\n  var jsonpID = +new Date(),\n      document = window.document,\n      key,\n      name,\n      rscript = /<script\\b[^<]*(?:(?!<\\/script>)<[^<]*)*<\\/script>/gi,\n      scriptTypeRE = /^(?:text|application)\\/javascript/i,\n      xmlTypeRE = /^(?:text|application)\\/xml/i,\n      jsonType = 'application/json',\n      htmlType = 'text/html',\n      blankRE = /^\\s*$/,\n      originAnchor = document.createElement('a')\n\n  originAnchor.href = window.location.href\n\n  // trigger a custom event and return false if it was cancelled\n  function triggerAndReturn(context, eventName, data) {\n    var event = $.Event(eventName)\n    $(context).trigger(event, data)\n    return !event.isDefaultPrevented()\n  }\n\n  // trigger an Ajax \"global\" event\n  function triggerGlobal(settings, context, eventName, data) {\n    if (settings.global) return triggerAndReturn(context || document, eventName, data)\n  }\n\n  // Number of active Ajax requests\n  $.active = 0\n\n  function ajaxStart(settings) {\n    if (settings.global && $.active++ === 0) triggerGlobal(settings, null, 'ajaxStart')\n  }\n  function ajaxStop(settings) {\n    if (settings.global && !(--$.active)) triggerGlobal(settings, null, 'ajaxStop')\n  }\n\n  // triggers an extra global event \"ajaxBeforeSend\" that's like \"ajaxSend\" but cancelable\n  function ajaxBeforeSend(xhr, settings) {\n    var context = settings.context\n    if (settings.beforeSend.call(context, xhr, settings) === false ||\n        triggerGlobal(settings, context, 'ajaxBeforeSend', [xhr, settings]) === false)\n      return false\n\n    triggerGlobal(settings, context, 'ajaxSend', [xhr, settings])\n  }\n  function ajaxSuccess(data, xhr, settings, deferred) {\n    var context = settings.context, status = 'success'\n    settings.success.call(context, data, status, xhr)\n    if (deferred) deferred.resolveWith(context, [data, status, xhr])\n    triggerGlobal(settings, context, 'ajaxSuccess', [xhr, settings, data])\n    ajaxComplete(status, xhr, settings)\n  }\n  // type: \"timeout\", \"error\", \"abort\", \"parsererror\"\n  function ajaxError(error, type, xhr, settings, deferred) {\n    var context = settings.context\n    settings.error.call(context, xhr, type, error)\n    if (deferred) deferred.rejectWith(context, [xhr, type, error])\n    triggerGlobal(settings, context, 'ajaxError', [xhr, settings, error || type])\n    ajaxComplete(type, xhr, settings)\n  }\n  // status: \"success\", \"notmodified\", \"error\", \"timeout\", \"abort\", \"parsererror\"\n  function ajaxComplete(status, xhr, settings) {\n    var context = settings.context\n    settings.complete.call(context, xhr, status)\n    triggerGlobal(settings, context, 'ajaxComplete', [xhr, settings])\n    ajaxStop(settings)\n  }\n\n  function ajaxDataFilter(data, type, settings) {\n    if (settings.dataFilter == empty) return data\n    var context = settings.context\n    return settings.dataFilter.call(context, data, type)\n  }\n\n  // Empty function, used as default callback\n  function empty() {}\n\n  $.ajaxJSONP = function(options, deferred){\n    if (!('type' in options)) return $.ajax(options)\n\n    var _callbackName = options.jsonpCallback,\n      callbackName = ($.isFunction(_callbackName) ?\n        _callbackName() : _callbackName) || ('Zepto' + (jsonpID++)),\n      script = document.createElement('script'),\n      originalCallback = window[callbackName],\n      responseData,\n      abort = function(errorType) {\n        $(script).triggerHandler('error', errorType || 'abort')\n      },\n      xhr = { abort: abort }, abortTimeout\n\n    if (deferred) deferred.promise(xhr)\n\n    $(script).on('load error', function(e, errorType){\n      clearTimeout(abortTimeout)\n      $(script).off().remove()\n\n      if (e.type == 'error' || !responseData) {\n        ajaxError(null, errorType || 'error', xhr, options, deferred)\n      } else {\n        ajaxSuccess(responseData[0], xhr, options, deferred)\n      }\n\n      window[callbackName] = originalCallback\n      if (responseData && $.isFunction(originalCallback))\n        originalCallback(responseData[0])\n\n      originalCallback = responseData = undefined\n    })\n\n    if (ajaxBeforeSend(xhr, options) === false) {\n      abort('abort')\n      return xhr\n    }\n\n    window[callbackName] = function(){\n      responseData = arguments\n    }\n\n    script.src = options.url.replace(/\\?(.+)=\\?/, '?$1=' + callbackName)\n    document.head.appendChild(script)\n\n    if (options.timeout > 0) abortTimeout = setTimeout(function(){\n      abort('timeout')\n    }, options.timeout)\n\n    return xhr\n  }\n\n  $.ajaxSettings = {\n    // Default type of request\n    type: 'GET',\n    // Callback that is executed before request\n    beforeSend: empty,\n    // Callback that is executed if the request succeeds\n    success: empty,\n    // Callback that is executed the the server drops error\n    error: empty,\n    // Callback that is executed on request complete (both: error and success)\n    complete: empty,\n    // The context for the callbacks\n    context: null,\n    // Whether to trigger \"global\" Ajax events\n    global: true,\n    // Transport\n    xhr: function () {\n      return new window.XMLHttpRequest()\n    },\n    // MIME types mapping\n    // IIS returns Javascript as \"application/x-javascript\"\n    accepts: {\n      script: 'text/javascript, application/javascript, application/x-javascript',\n      json:   jsonType,\n      xml:    'application/xml, text/xml',\n      html:   htmlType,\n      text:   'text/plain'\n    },\n    // Whether the request is to another domain\n    crossDomain: false,\n    // Default timeout\n    timeout: 0,\n    // Whether data should be serialized to string\n    processData: true,\n    // Whether the browser should be allowed to cache GET responses\n    cache: true,\n    //Used to handle the raw response data of XMLHttpRequest.\n    //This is a pre-filtering function to sanitize the response.\n    //The sanitized response should be returned\n    dataFilter: empty\n  }\n\n  function mimeToDataType(mime) {\n    if (mime) mime = mime.split(';', 2)[0]\n    return mime && ( mime == htmlType ? 'html' :\n      mime == jsonType ? 'json' :\n      scriptTypeRE.test(mime) ? 'script' :\n      xmlTypeRE.test(mime) && 'xml' ) || 'text'\n  }\n\n  function appendQuery(url, query) {\n    if (query == '') return url\n    return (url + '&' + query).replace(/[&?]{1,2}/, '?')\n  }\n\n  // serialize payload and append it to the URL for GET requests\n  function serializeData(options) {\n    if (options.processData && options.data && $.type(options.data) != \"string\")\n      options.data = $.param(options.data, options.traditional)\n    if (options.data && (!options.type || options.type.toUpperCase() == 'GET' || 'jsonp' == options.dataType))\n      options.url = appendQuery(options.url, options.data), options.data = undefined\n  }\n\n  $.ajax = function(options){\n    var settings = $.extend({}, options || {}),\n        deferred = $.Deferred && $.Deferred(),\n        urlAnchor, hashIndex\n    for (key in $.ajaxSettings) if (settings[key] === undefined) settings[key] = $.ajaxSettings[key]\n\n    ajaxStart(settings)\n\n    if (!settings.crossDomain) {\n      urlAnchor = document.createElement('a')\n      urlAnchor.href = settings.url\n      // cleans up URL for .href (IE only), see https://github.com/madrobby/zepto/pull/1049\n      urlAnchor.href = urlAnchor.href\n      settings.crossDomain = (originAnchor.protocol + '//' + originAnchor.host) !== (urlAnchor.protocol + '//' + urlAnchor.host)\n    }\n\n    if (!settings.url) settings.url = window.location.toString()\n    if ((hashIndex = settings.url.indexOf('#')) > -1) settings.url = settings.url.slice(0, hashIndex)\n    serializeData(settings)\n\n    var dataType = settings.dataType, hasPlaceholder = /\\?.+=\\?/.test(settings.url)\n    if (hasPlaceholder) dataType = 'jsonp'\n\n    if (settings.cache === false || (\n         (!options || options.cache !== true) &&\n         ('script' == dataType || 'jsonp' == dataType)\n        ))\n      settings.url = appendQuery(settings.url, '_=' + Date.now())\n\n    if ('jsonp' == dataType) {\n      if (!hasPlaceholder)\n        settings.url = appendQuery(settings.url,\n          settings.jsonp ? (settings.jsonp + '=?') : settings.jsonp === false ? '' : 'callback=?')\n      return $.ajaxJSONP(settings, deferred)\n    }\n\n    var mime = settings.accepts[dataType],\n        headers = { },\n        setHeader = function(name, value) { headers[name.toLowerCase()] = [name, value] },\n        protocol = /^([\\w-]+:)\\/\\//.test(settings.url) ? RegExp.$1 : window.location.protocol,\n        xhr = settings.xhr(),\n        nativeSetHeader = xhr.setRequestHeader,\n        abortTimeout\n\n    if (deferred) deferred.promise(xhr)\n\n    if (!settings.crossDomain) setHeader('X-Requested-With', 'XMLHttpRequest')\n    setHeader('Accept', mime || '*/*')\n    if (mime = settings.mimeType || mime) {\n      if (mime.indexOf(',') > -1) mime = mime.split(',', 2)[0]\n      xhr.overrideMimeType && xhr.overrideMimeType(mime)\n    }\n    if (settings.contentType || (settings.contentType !== false && settings.data && settings.type.toUpperCase() != 'GET'))\n      setHeader('Content-Type', settings.contentType || 'application/x-www-form-urlencoded')\n\n    if (settings.headers) for (name in settings.headers) setHeader(name, settings.headers[name])\n    xhr.setRequestHeader = setHeader\n\n    xhr.onreadystatechange = function(){\n      if (xhr.readyState == 4) {\n        xhr.onreadystatechange = empty\n        clearTimeout(abortTimeout)\n        var result, error = false\n        if ((xhr.status >= 200 && xhr.status < 300) || xhr.status == 304 || (xhr.status == 0 && protocol == 'file:')) {\n          dataType = dataType || mimeToDataType(settings.mimeType || xhr.getResponseHeader('content-type'))\n\n          if (xhr.responseType == 'arraybuffer' || xhr.responseType == 'blob')\n            result = xhr.response\n          else {\n            result = xhr.responseText\n\n            try {\n              // http://perfectionkills.com/global-eval-what-are-the-options/\n              // sanitize response accordingly if data filter callback provided\n              result = ajaxDataFilter(result, dataType, settings)\n              if (dataType == 'script')    (1,eval)(result)\n              else if (dataType == 'xml')  result = xhr.responseXML\n              else if (dataType == 'json') result = blankRE.test(result) ? null : $.parseJSON(result)\n            } catch (e) { error = e }\n\n            if (error) return ajaxError(error, 'parsererror', xhr, settings, deferred)\n          }\n\n          ajaxSuccess(result, xhr, settings, deferred)\n        } else {\n          ajaxError(xhr.statusText || null, xhr.status ? 'error' : 'abort', xhr, settings, deferred)\n        }\n      }\n    }\n\n    if (ajaxBeforeSend(xhr, settings) === false) {\n      xhr.abort()\n      ajaxError(null, 'abort', xhr, settings, deferred)\n      return xhr\n    }\n\n    var async = 'async' in settings ? settings.async : true\n    xhr.open(settings.type, settings.url, async, settings.username, settings.password)\n\n    if (settings.xhrFields) for (name in settings.xhrFields) xhr[name] = settings.xhrFields[name]\n\n    for (name in headers) nativeSetHeader.apply(xhr, headers[name])\n\n    if (settings.timeout > 0) abortTimeout = setTimeout(function(){\n        xhr.onreadystatechange = empty\n        xhr.abort()\n        ajaxError(null, 'timeout', xhr, settings, deferred)\n      }, settings.timeout)\n\n    // avoid sending empty string (#319)\n    xhr.send(settings.data ? settings.data : null)\n    return xhr\n  }\n\n  // handle optional data/success arguments\n  function parseArguments(url, data, success, dataType) {\n    if ($.isFunction(data)) dataType = success, success = data, data = undefined\n    if (!$.isFunction(success)) dataType = success, success = undefined\n    return {\n      url: url\n    , data: data\n    , success: success\n    , dataType: dataType\n    }\n  }\n\n  $.get = function(/* url, data, success, dataType */){\n    return $.ajax(parseArguments.apply(null, arguments))\n  }\n\n  $.post = function(/* url, data, success, dataType */){\n    var options = parseArguments.apply(null, arguments)\n    options.type = 'POST'\n    return $.ajax(options)\n  }\n\n  $.getJSON = function(/* url, data, success */){\n    var options = parseArguments.apply(null, arguments)\n    options.dataType = 'json'\n    return $.ajax(options)\n  }\n\n  $.fn.load = function(url, data, success){\n    if (!this.length) return this\n    var self = this, parts = url.split(/\\s/), selector,\n        options = parseArguments(url, data, success),\n        callback = options.success\n    if (parts.length > 1) options.url = parts[0], selector = parts[1]\n    options.success = function(response){\n      self.html(selector ?\n        $('<div>').html(response.replace(rscript, \"\")).find(selector)\n        : response)\n      callback && callback.apply(self, arguments)\n    }\n    $.ajax(options)\n    return this\n  }\n\n  var escape = encodeURIComponent\n\n  function serialize(params, obj, traditional, scope){\n    var type, array = $.isArray(obj), hash = $.isPlainObject(obj)\n    $.each(obj, function(key, value) {\n      type = $.type(value)\n      if (scope) key = traditional ? scope :\n        scope + '[' + (hash || type == 'object' || type == 'array' ? key : '') + ']'\n      // handle data in serializeArray() format\n      if (!scope && array) params.add(value.name, value.value)\n      // recurse into nested objects\n      else if (type == \"array\" || (!traditional && type == \"object\"))\n        serialize(params, value, traditional, key)\n      else params.add(key, value)\n    })\n  }\n\n  $.param = function(obj, traditional){\n    var params = []\n    params.add = function(key, value) {\n      if ($.isFunction(value)) value = value()\n      if (value == null) value = \"\"\n      this.push(escape(key) + '=' + escape(value))\n    }\n    serialize(params, obj, traditional)\n    return params.join('&').replace(/%20/g, '+')\n  }\n})(Zepto)\n\n;(function($){\n  $.fn.serializeArray = function() {\n    var name, type, result = [],\n      add = function(value) {\n        if (value.forEach) return value.forEach(add)\n        result.push({ name: name, value: value })\n      }\n    if (this[0]) $.each(this[0].elements, function(_, field){\n      type = field.type, name = field.name\n      if (name && field.nodeName.toLowerCase() != 'fieldset' &&\n        !field.disabled && type != 'submit' && type != 'reset' && type != 'button' && type != 'file' &&\n        ((type != 'radio' && type != 'checkbox') || field.checked))\n          add($(field).val())\n    })\n    return result\n  }\n\n  $.fn.serialize = function(){\n    var result = []\n    this.serializeArray().forEach(function(elm){\n      result.push(encodeURIComponent(elm.name) + '=' + encodeURIComponent(elm.value))\n    })\n    return result.join('&')\n  }\n\n  $.fn.submit = function(callback) {\n    if (0 in arguments) this.bind('submit', callback)\n    else if (this.length) {\n      var event = $.Event('submit')\n      this.eq(0).trigger(event)\n      if (!event.isDefaultPrevented()) this.get(0).submit()\n    }\n    return this\n  }\n\n})(Zepto)\n\n;(function(){\n  // getComputedStyle shouldn't freak out when called\n  // without a valid element as argument\n  try {\n    getComputedStyle(undefined)\n  } catch(e) {\n    var nativeGetComputedStyle = getComputedStyle\n    window.getComputedStyle = function(element, pseudoElement){\n      try {\n        return nativeGetComputedStyle(element, pseudoElement)\n      } catch(e) {\n        return null\n      }\n    }\n  }\n})()\n  return Zepto\n}))\n";
		},
		function () {
			(function (e) {
				(e.expr = { ":": {} }),
					(e.support = {}),
					(e.fn.clone = function () {
						var t = e();
						return (
							this.each(function () {
								t.push(this.cloneNode(!0));
							}),
							t
						);
					}),
					["Left", "Top"].forEach(function (t, n) {
						function o(e) {
							return (
								e && "object" == typeof e && "setInterval" in e
							);
						}
						function a(e) {
							return o(e)
								? e
								: !(9 !== e.nodeType) &&
										(e.defaultView || e.parentWindow);
						}
						var i = "scroll" + t;
						e.fn[i] = function (t) {
							var o, s;
							return void 0 === t
								? ((o = this[0]), !o)
									? null
									: ((s = a(o)),
									  s
											? "pageXOffset" in s
												? s[
														n
															? "pageYOffset"
															: "pageXOffset"
												  ]
												: s.document.documentElement[
														i
												  ] || s.document.body[i]
											: o[i])
								: void this.each(function () {
										if (((s = a(this)), s)) {
											var o = n ? e(s).scrollLeft() : t,
												r = n ? t : e(s).scrollTop();
											s.scrollTo(o, r);
										} else this[i] = t;
								  });
						};
					}),
					["width", "height"].forEach(function (t) {
						var n = t.replace(/./, function (e) {
							return e[0].toUpperCase();
						});
						(e.fn["inner" + n] = function (e) {
							var n = this;
							if (n) {
								var o = n[t]();
								return (
									{
										width: ["left", "right"],
										height: ["top", "bottom"],
									}[t].forEach(function (t) {
										(o += parseInt(
											n.css("padding-" + t),
											10
										)),
											e &&
												(o += parseInt(
													n.css("margin-" + t),
													10
												));
									}),
									o
								);
							}
							return null;
						}),
							(e.fn["outer" + n] = function (e) {
								var n = this;
								if (n) {
									var o = n[t]();
									return (
										{
											width: ["left", "right"],
											height: ["top", "bottom"],
										}[t].forEach(function (t) {
											e &&
												(o += parseInt(
													n.css("margin-" + t),
													10
												));
										}),
										o
									);
								}
								return null;
							});
					}),
					(e.proxy = function (t, n) {
						if ("string" == typeof n) {
							var o = t[n];
							(n = t), (t = o);
						}
						if (e.isFunction(t)) {
							var a = Array.prototype.slice.call(arguments, 2),
								i = function () {
									return t.apply(
										n,
										a.concat(
											Array.prototype.slice.call(
												arguments
											)
										)
									);
								};
							return (
								(i.guid = t.guid =
									t.guid || i.guid || e.guid++),
								i
							);
						}
					});
				var t = String.prototype.trim;
				e.trim = function (e, n) {
					return !n && t
						? t.call(e)
						: ((n = defaultToWhiteSpace(n)),
						  e.replace(
								new RegExp("^[" + n + "]+|[" + n + "]+$", "g"),
								""
						  ));
				};
				var n = /^t(?:able|d|h)$/i,
					o = /^(?:body|html)$/i;
				(e.fn.position = function () {
					if (!this[0]) return null;
					var t = this[0],
						n = this.offsetParent(),
						a = this.offset(),
						i = o.test(n[0].nodeName)
							? { top: 0, left: 0 }
							: n.offset();
					return (
						(a.top -= parseFloat(e(t).css("margin-top")) || 0),
						(a.left -= parseFloat(e(t).css("margin-left")) || 0),
						(i.top +=
							parseFloat(e(n[0]).css("border-top-width")) || 0),
						(i.left +=
							parseFloat(e(n[0]).css("border-left-width")) || 0),
						{ top: a.top - i.top, left: a.left - i.left }
					);
				}),
					(e.fn.offsetParent = function () {
						var t = e();
						return (
							this.each(function () {
								for (
									var n = this.offsetParent || document.body;
									n &&
									!o.test(n.nodeName) &&
									"static" === e(n).css("position");

								)
									n = n.offsetParent;
								t.push(n);
							}),
							t
						);
					});
			})(Zepto);
		},
	]);
}());
//# sourceMappingURL=goldenlayout.js.map
